import type { Dict } from '../types';

export const ar: Dict = {
  'chat.amrCard.switchTitle': 'فشل استدعاء النموذج — تم إيقاف هذه المهمة مؤقتًا',
  'chat.amrCard.switchBody': 'بدِّل إلى خدمة نماذج AMR الرسمية من Open Design — لا حاجة لإعداد مفتاح API. بعد تسجيل الدخول والتفويض والشحن، ستُعاد محاولة هذه المهمة تلقائيًا.',
  'chat.amrCard.chipOfficial': 'استضافة رسمية',
  'chat.amrCard.chipNoKey': 'بدون مفتاح API',
  'chat.amrCard.chipAutoRetry': 'إعادة المحاولة تلقائيًا بعد تسجيل الدخول',
  'chat.amrCard.switchCta': 'التبديل إلى AMR وإعادة المحاولة',
  'chat.amrError.authMessage': 'حساب AMR الخاص بك لم يتم تفويضه بعد. فوِّضه وستُعاد محاولة هذه المهمة تلقائيًا.',
  'chat.amrError.balanceMessage': 'نفد رصيد AMR الخاص بك. اشحن للاستمرار في هذه المهمة.',
  'chat.amrError.authorizeCta': 'تفويض وإعادة المحاولة',
  'chat.amrError.rechargeCta': 'شحن AMR',
  'chat.antigravityError.launchTerminalCta': 'تسجيل الدخول عبر الطرفية',
  'chat.antigravityError.launchSwitchModelCta': 'تبديل النموذج في الطرفية',
  'chat.connectionDropped': 'انقطع الاتصال بخدمة النموذج قبل اكتمال الاستجابة — عادةً بسبب شبكة أو وكيل (proxy) غير مستقر. يرجى إعادة المحاولة.',
  'common.cancel': 'إلغاء',
  'common.save': 'حفظ',
  'common.close': 'إغلاق',
  'common.clear': 'مسح',
  'common.delete': 'حذف',
  'common.rename': 'إعادة تسمية',
  'common.edit': 'تعديل',
  'common.preview': 'معاينة',
  'common.share': 'مشاركة',
  'common.search': 'بحث',
  'common.searchEllipsis': 'بحث...',
  'common.loading': 'جاري التحميل...',
  'common.all': 'الكل',
  'common.none': 'لا شيء',
  'common.default': 'افتراضي',
  'common.installed': 'مثبت',
  'common.notInstalled': 'غير مثبت',
  'common.active': 'نشط',
  'common.offline': 'غير متصل',
  'common.selected': 'محدد',
  'common.create': 'إنشاء',
  'common.openPreview': 'فتح المعاينة',
  'common.exitFullscreen': 'الخروج من ملء الشاشة',
  'common.fullscreen': 'ملء الشاشة',
  'common.openInNewTab': 'فتح في علامة تبويب جديدة',
  'common.exportPdf': 'تصدير كـ PDF',
  'common.exportZip': 'تحميل كـ zip.',
  'common.exportHtml': 'تصدير كـ HTML مستقل',
  'common.exportImage': 'تصدير كصورة',
  'common.exportImageFailed': 'فشل التقاط الصورة. يرجى المحاولة مرة أخرى أو استخدام أداة لقطة الشاشة في المتصفح.',
  'common.justNow': 'الآن',
  'common.minutesAgo': 'منذ {n} دقيقة',
  'common.hoursAgo': 'منذ {n} ساعة',
  'common.daysAgo': 'منذ {n} يوم',
  'common.weeksAgo': 'قبل {n} أسبوع',
  'common.now': 'الآن',
  'common.minutesShort': '{n} د',
  'common.hoursShort': '{n} سا',
  'common.daysShort': '{n} ي',
  'common.untitled': 'بدون عنوان',
  'plugins.availableDetails.provenance': 'المصدر',
  'plugins.availableDetails.provenanceLine': 'من {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'من {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'تثبيت',
  'plugins.availableDetails.version': 'الإصدار',
  'plugins.availableDetails.pluginVersion': 'إصدار الإضافة',
  'plugins.availableDetails.copyInstallCommand': 'نسخ أمر التثبيت',
  'plugins.availableDetails.copied': 'تم النسخ',
  'plugins.availableDetails.deprecatedPrefix': 'مهمَل: {message}',
  'plugins.availableDetails.deprecatedFallback': 'تم وضع علامة على هذا الإصدار كمهمَل.',
  'plugins.availableDetails.yanked': 'تم السحب.',
  'plugins.availableDetails.yankedWithReason': 'تم السحب: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (مهمَل)',
  'plugins.availableDetails.versionYankedSuffix': ' (مسحوب)',
  'plugins.availableDetails.ref': 'المرجع',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'الأذونات',
  'plugins.availableDetails.capabilitySummary': 'ملخص الإمكانات',
  'plugins.actions.copyInstallCommand': 'نسخ أمر التثبيت',
  'plugins.actions.copyPluginId': 'نسخ معرّف الإضافة',
  'plugins.actions.copyReadmeBadge': 'نسخ شارة README',
  'plugins.actions.openSourceGithub': 'فتح المصدر على GitHub',
  'plugins.actions.openSource': 'فتح المصدر',
  'plugins.actions.openHomepage': 'فتح الصفحة الرئيسية',
  'plugins.actions.openMarketplace': 'فتح في السوق',
  'app.brand': 'Open Design',
  'app.brandPill': 'معاينة البحث',
  'app.brandSubtitle': 'بواسطة Nexu Labs',
  'app.welcomeLoading': 'جاري تحميل مساحة العمل...',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'مرحبًا',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'ابدأ من ملخص',
  'settings.onboardingCreateBody': 'صِف الموقع أو التطبيق أو العرض التقديمي أو الصورة أو الفيديو الذي تريده. سيُنشئ Open Design مشروعًا ويُبقي العمل قابلاً للتحرير.',
  'settings.onboardingMemoryTitle': 'حفظ سياق العمل',
  'settings.onboardingMemoryBody': 'أضِف التفضيلات وحقائق المشروع والقواعد المتكررة حتى تلتقط المحادثات المستقبلية السياق الصحيح.',
  'settings.onboardingSystemsTitle': 'أحضِر نظام التصميم الخاص بك',
  'settings.onboardingSystemsBody': 'اختر أو أنشئ نظام علامة تجارية حتى يتبع العمل المُولَّد الألوان والطباعة ولغة المنتج الحقيقية.',
  'settings.onboardingExecutionTitle': 'اختر طريقة تشغيل التوليد',
  'settings.onboardingExecutionBody': 'CLI رسمي بإعداد بنقرة واحدة وإعدادات افتراضية جاهزة للاستخدام. استخدم مفتاحًا واحدًا للاختيار من بين العديد من النماذج بأسعار أفضل.',
  'settings.onboardingAmrCloudBenefitOfficial': 'موصى به رسميًا',
  'settings.onboardingAmrCloudBenefitReady': 'بلا نشر',
  'settings.onboardingAmrCloudBenefitModels': 'يدعم Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'حزمة SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'قريبًا',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'الصور والفيديو',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills كثيرة',
  'settings.onboardingAmrCloudUpcomingRouting': 'توجيه ذكي',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'تخويل AMR',
  'settings.onboardingAmrCloudAuthorizedAction': 'تم التخويل',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'ابقَ على اطلاع',
  'settings.onboardingNewsletterTitle': 'ابقَ على اطلاع',
  'settings.onboardingNewsletterBody': 'احصل على تحديثات المنتج والقوالب الجديدة وأنظمة التصميم وأنشطة السفراء في بريدك. اختياري — يمكنك التخطي.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'رسمي',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.onboardingSkip': 'Skip for now',
  'settings.kicker': 'الإعدادات',
  'settings.title': 'وضع التنفيذ',
  'settings.subtitle': 'اختر بين CLI المحلي و BYOK.',
  'settings.modeAria': 'وضع التنفيذ',
  'settings.protocolAria': 'بروتوكول API',
  'settings.modeDaemon': 'CLI محلي',
  'settings.modeDaemonHelp': 'التشغيل عبر واجهة CLI على جهازك',
  'settings.modeDaemonOffline': 'البرنامج الخفي لا يعمل',
  'settings.modeDaemonOfflineMeta': 'غير متصل',
  'settings.modeDaemonInstalledMeta': '{count} مثبت',
  'settings.modeApi': 'مزود API',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'لا يمكن لـ BYOK قراءة ملفات المشروع أو الكتابة فيها أو تعديلها. استخدم Local CLI عندما تحتاج إلى تغييرات في الكود.',
  'settings.codeAgent': 'وكيل الكود',
  'settings.codeAgentHint': 'تم اكتشافه عبر مسح PATH الخاص بك. اختر واجهة CLI التي تريد أن تمر الأجيال عبرها.',
  'settings.rescan': '↻ إعادة المسح',
  'settings.rescanTitle': 'إعادة مسح PATH',
  'settings.rescanRunning': 'جارٍ المسح...',
  'settings.rescanSuccess': 'اكتمل المسح. {count} متاح.',
  'settings.designSystemRenameFailed': 'فشلت إعادة التسمية. تحقق من البرنامج الخفي وحاول مرة أخرى.',
  'settings.rescanFailed': 'فشل المسح. تحقق من البرنامج الخفي وحاول مرة أخرى.',
  'settings.test': 'اختبار',
  'settings.testTitle': 'أرسل مطالبة اختبار صغيرة للتحقق من الاتصال',
  'settings.testRunning': 'جاري اختبار الاتصال…',
  'settings.byokReadyToTest': 'جاهز للاختبار',
  'settings.testCancel': 'إلغاء',
  'settings.testRetry': 'إعادة الاختبار',
  'settings.required': 'مطلوب',
  'settings.testMissingFields': 'املأ {fields} لاختبار الاتصال.',
  'settings.testSuccessApi': 'تم الاتصال. رد خلال {ms} مللي ثانية — \'{sample}\'',
  'settings.testSuccessCli': 'رد {agentName} خلال {ms} مللي ثانية — \'{sample}\'',
  'settings.testAuthFailed': 'فشلت المصادقة. تحقق من مفتاح الـ API.',
  'settings.testForbidden': 'الوصول ممنوع. تحقق من الحساب أو المنطقة أو المؤسسة.',
  'settings.testNotFoundModel': 'لم يتم العثور على النموذج \'{model}\' في هذه النقطة.',
  'settings.testInvalidModelId': 'معرّف النموذج \'{model}\' غير صالح. يجب أن يبدأ المعرّف المخصص بحرف أو رقم وألا يحتوي على مسافات.',
  'settings.testInvalidBaseUrl': 'Base URL غير صالح أو يتعذر الوصول إليه.',
  'settings.testRateLimited': 'حد المزود معدّل الاختبار. التكوين يبدو صالحاً.',
  'settings.testUpstream': 'أعاد المزود {status}. حاول مرة أخرى بعد قليل.',
  'settings.testTimeout': 'انتهت مهلة الاختبار بعد {ms} مللي ثانية.',
  'settings.testAgentMissing': '{agentName} غير مثبت أو ليس في PATH.',
  'settings.testAgentSpawn': 'تعذّر تشغيل {agentName}: {detail}.',
  'settings.testUnknown': 'فشل الاختبار: {detail}',
  'settings.agentInstall.install': 'تثبيت',
  'settings.agentInstall.docs': 'الوثائق',
  'settings.agentInstall.pathHint': 'إذا ثبّتّ CLI باستخدام npm أو Homebrew وما زال يظهر كغير مثبت، فتأكد من أن مجلد bin للأداة موجود في PATH الذي يرثه daemon الخاص بـ Open Design (قد يختلف PATH بين Terminal وتطبيقات GUI على macOS). راجع QUICKSTART.md (قسم "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'افتح رابط التثبيت أو الوثائق للوكيل الذي تفضله.',
  'settings.agentInstall.stepAuth': 'أكمِل المصادقة في CLI الخاص بالمزوّد (تسجيل الدخول أو إضافة بيانات اعتماد API) قبل العودة إلى Open Design.',
  'settings.agentInstall.stepRescan': 'انقر إعادة المسح في هذا القسم.',
  'settings.agentInstall.stepSelect': 'اختر بطاقة الوكيل عندما يظهر كأنه مثبت.',
  'settings.noAgentsDetected': 'لم يتم اكتشاف أي وكلاء بعد. قم بتثبيت Claude Code أو Codex أو Devin أو Gemini CLI أو OpenCode أو Cursor Agent أو Qwen أو GitHub Copilot CLI، ثم اضغط على إعادة المسح.',
  'settings.agentInstalledGroup': 'واجهات CLI لديك ({count})',
  'settings.agentInstallGroup': 'متاحة للتثبيت ({count})',
  'settings.agentAuthRequired': 'المصادقة مطلوبة',
  'settings.agentAuthUnknown': 'حالة المصادقة غير معروفة',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': 'تفويض',
  'settings.amrBenefitOfficial': 'رسمي',
  'settings.amrBenefitLowerPrice': 'تكلفة أقل',
  'settings.amrBenefitManyModels': 'نماذج متعددة',
  'settings.amrPromoBonus': 'مكافأة محدودة: +100%',
  'settings.amrSignInToContinue': 'سجّل الدخول للمتابعة',
  'settings.amrSignIn': 'تسجيل الدخول',
  'settings.amrSignedIn': 'تم تسجيل الدخول',
  'settings.amrNotSignedIn': 'لم يتم تسجيل الدخول',
  'settings.amrSigningIn': 'جارٍ تسجيل الدخول…',
  'settings.amrCancelSignIn': 'إلغاء تسجيل الدخول',
  'settings.amrAccountStatus': 'حالة حساب AMR',
  'settings.amrConsole': 'وحدة تحكّم AMR',
  'settings.amrLoginErrorCompact': 'فشل تسجيل الدخول إلى AMR.',
  'settings.advanced': 'متقدّم',
  'settings.amrLogin': 'تسجيل الدخول',
  'settings.amrLogout': 'تسجيل الخروج',
  'settings.amrLoggingIn': 'جارٍ تسجيل الدخول…',
  'settings.amrLoggingOut': 'جارٍ تسجيل الخروج…',
  'settings.amrLoggedInAs': 'تم تسجيل الدخول باسم {email}',
  'settings.amrLoggedInWithPlan': 'تم تسجيل الدخول باسم {email} · {plan}',
  'settings.amrLoggedInPill': 'تم تسجيل الدخول',
  'settings.amrNotLoggedIn': 'لم يتم تسجيل الدخول',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'ملء المزوّد سريعًا',
  'settings.providerPreset': 'إعداد البوابة المسبق',
  'settings.protocolGroupProtocols': 'البروتوكولات',
  'settings.protocolGroupGateways': 'البوابات',
  'settings.customProvider': 'مزوّد مخصص',
  'settings.apiKey': 'مفتاح API',
  'settings.apiKeyGetLink': 'الحصول على المفتاح ↗',
  'settings.showKey': 'إظهار المفتاح',
  'settings.hideKey': 'إخفاء المفتاح',
  'settings.show': 'إظهار',
  'settings.hide': 'إخفاء',
  'settings.model': 'النموذج',
  'settings.apiKeyInvalid': 'API key غير صالح.',
  'settings.apiKeyCleaned': 'تمت إزالة المسافات الزائدة من API key.',
  'settings.modelsLoadedFromAccount': '✓ تم تحميل {count} نموذج من حسابك.',
  'settings.modelsLoadedCount': '✓ تم تحميل {count} نموذج.',
  'settings.modelSourceAccount': 'من حسابك',
  'settings.modelSourceSuggested': 'مُقترح',
  'settings.fetchModels': 'جلب النماذج',
  'settings.fetchModelsTitle': 'جلب النماذج المتاحة من هذا المزوّد',
  'settings.fetchModelsRunning': 'جارٍ جلب النماذج…',
  'settings.fetchModelsMissingFields': 'املأ {fields} لجلب النماذج.',
  'settings.fetchModelsInvalidBaseUrl': 'أدخل Base URL صالحًا لجلب النماذج.',
  'settings.fetchModelsUnsupportedAzure': 'يستخدم Azure OpenAI أسماء عمليات النشر، لذا فإن اكتشاف النماذج غير متاح هنا.',
  'settings.fetchModelsUnsupportedOllama': 'اكتشاف نماذج Ollama Cloud غير متاح بعد. اختر نموذجًا أو اكتبه.',
  'settings.fetchModelsSuccess': 'تم جلب {count} نموذجًا.',
  'settings.fetchModelsEmpty': 'لم يتم إرجاع أي نماذج نصية متوافقة.',
  'settings.fetchModelsUnsupported': 'اكتشاف النماذج غير متاح لهذا البروتوكول.',
  'settings.fetchModelsFailed': 'تعذّر جلب النماذج: {detail}',
  'settings.suggestedModelsHint': 'هذه نماذج مقترحة لهذا البروتوكول. قد يدعم مزوّدك نماذج مختلفة.',
  'settings.baseUrl': 'رابط القاعدة',
  'settings.baseUrlInvalid': 'استخدم رابط http:// أو https:// عامًا.',
  'settings.baseUrlCustomize': 'تخصيص',
  'settings.baseUrlDefaultHint': 'نقطة النهاية الافتراضية. عادة لا تحتاج إلى تغييرها.',
  'settings.azureBaseUrlPlaceholder': 'ألصق عنوان URL لنقطة نهاية Azure',
  'settings.azureBaseUrlHint': 'يمكنك العثور على هذا في بوابة Azure ← المورد الخاص بك ← Endpoint.',
  'settings.azureDeploymentModel': 'اسم النشر',
  'settings.azureCustomDeploymentName': 'اسم نشر مخصّص',
  'settings.azureDeploymentModelHint': 'في Azure OpenAI، يُستخدم هذا الحقل كاسم النشر في /openai/deployments/<model>. أدخل اسم النشر الذي أنشأته في Azure.',
  'settings.azureModelFetchHint': 'أدخل اسم النشر من مورد Azure الخاص بك. لا يمكن جلب عمليات نشر Azure تلقائيًا.',
  'settings.apiVersion': 'إصدار API',
  'settings.byokImageModel': 'نموذج إنشاء الصور',
  'settings.byokVideoModel': 'نموذج إنشاء الفيديو',
  'settings.byokVideoI2vHint': 'نموذج صورة-إلى-فيديو: مطلوب صورة مرجعية (يُستخدم أحدث صورة في المشروع تلقائيًا إن لم تحددها)',
  'settings.byokSpeechModel': 'نموذج توليد الصوت',
  'settings.byokSpeechVoice': 'صوت الكلام',
  'settings.byokModelDefaultOption': 'افتراضي',
  'settings.maxTokens': 'أقصى عدد من الرموز (اختياري)',
  'settings.maxTokensHint': 'الحد الأقصى لطول الاستجابة. لكل نموذج قيمة افتراضية؛ اتركها فارغة لاستخدامها، أو أدخل رقماً للتجاوز.',
  'settings.apiHint': 'تُرسل الطلبات عبر وكيل daemon المحلي إلى Base URL الذي تحدده. يُحفظ المفتاح في هذا المتصفح فقط ويُرسل مع طلبات المزود.',
  'settings.skipForNow': 'تخطي الآن',
  'settings.getStarted': 'ابدأ الآن',
  'settings.envConfigure': 'وضع التنفيذ',
  'settings.localCli': 'CLI محلي',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'لم يتم اختيار وكيل',
  'settings.language': 'اللغة',
  'settings.languageHint': 'تغيير لغة الواجهة. تحفظ في المتصفح.',
  'settings.appearance': 'المظهر',
  'settings.appearanceHint': 'اختر الفاتح، الداكن، أو اتبع إعدادات النظام.',
  'settings.themeSystem': 'النظام',
  'settings.themeLight': 'فاتح',
  'settings.themeDark': 'داكن',
  'settings.agentModelHead': 'النموذج لـ:',
  'settings.modelPicker': 'النموذج',
  'settings.modelSourceLive': 'مباشر من CLI',
  'settings.modelSourceFallback': 'القائمة المضمنة',
  'settings.reasoningPicker': 'جهد التفكير',
  'settings.modelPickerHint': 'يتم جلبه من CLI عندما يعرض أمر `models`. "الافتراضي" يترك الخيار لإعدادات CLI؛ "مخصص..." يسمح لك بكتابة أي معرف نموذج يقبله CLI.',
  'settings.modelPickerLiveHint': 'تم تحديث النماذج من CLI المثبت. لا يزال الخيار الافتراضي يستخدم إعدادات CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'تم تحديث النماذج من CLI المثبت.',
  'settings.modelPickerFallbackHint': 'يتم عرض الإعدادات الافتراضية المضمنة. انقر على إعادة المسح لجلب النماذج المباشرة من CLI.',
  'settings.cliEnvTitle': 'متقدّم: الوكيل والمسارات المخصّصة',
  'settings.cliEnvHint': 'استخدم هذه الخيارات فقط إذا كنت توجّه حركة مرور CLI عبر وكيلك الخاص أو ثبّتّ الملف الثنائي في موقع غير قياسي. تبقى الأسرار في إعدادات التطبيق المحلية ولا يراها سوى CLI المحدّد.',
  'settings.cliEnvClaudeConfigDir': 'دليل إعدادات Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL لوكيل Claude',
  'settings.cliEnvClaudeApiKey': 'API key لوكيل Claude',
  'settings.cliEnvCodexHome': 'مجلد Codex الرئيسي',
  'settings.cliEnvCodexBin': 'مسار ملف Codex التنفيذي',
  'settings.cliEnvCodexBaseUrl': 'Base URL لوكيل Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key لوكيل Codex/OpenAI',
  'settings.modelCustom': 'مخصص (اكتب أدناه)...',
  'settings.modelCustomLabel': 'معرف النموذج المخصص',
  'settings.modelCustomPlaceholder': 'مثلاً: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'مزودو الوسائط',
  'settings.mediaProvidersHint': 'مفاتيح API لإنشاء الصور والفيديو والصوت. تخزن محلياً وتزامن مع البرنامج الخفي المحلي.',
  'settings.mcpServerTitle': 'خادم MCP',
  'settings.mcpServerHint': 'كشف Open Design كخادم MCP لوكيل البرمجة الخاص بك.',
  'settings.externalMcpTitle': 'MCP خارجي',
  'settings.externalMcpHint': 'أضف أدوات MCP من خدمات خارجية (Higgsfield، GitHub، …).',
  'settings.mediaProviderApiKey': 'مفتاح API',
  'settings.mediaProviderBaseUrl': 'رابط القاعدة',
  'settings.mediaProviderConfigured': 'تم التكوين',
  'settings.mediaProviderUnset': 'غير محدد',
  'settings.mediaProviderClear': 'مسح',
  'settings.mediaProviderClearConfirm': 'مسح إعدادات {name} المحفوظة؟ ستحتاج إلى إدخالها مرة أخرى لاستخدام {name}.',
  'settings.mediaProviderPlaceholder': 'الصق مفتاح API',
  'settings.mediaProviderBaseUrlPlaceholder': 'تجاوز رابط القاعدة الافتراضي',
  'settings.mediaProviderReload': 'إعادة التحميل من الـ daemon المحلي',
  'settings.mediaProviderReloadError': 'تعذر إعادة تحميل إعدادات موفري الوسائط من الـ daemon المحلي.',
  'settings.mediaProviderReloadSuccess': 'تمت إعادة تحميل إعدادات موفري الوسائط من الـ daemon المحلي.',
  'settings.mediaProviderLoadError': 'تعذر تحميل إعدادات موفري الوسائط من الـ daemon المحلي. سيُستخدم مؤقتًا ما هو محفوظ في المتصفح.',
  'settings.mediaProviderComingSoonHint': 'نحن نتتبع هذه المزودات في خارطة الطريق؛ لم يقم البرنامج الخفي بشحن عميل بعد، لذا لا يوجد شيء لتكوينه.',
  'settings.privacy': 'الخصوصية',
  'settings.privacyHint': 'البيانات التي تتم مشاركتها مع فريق Open Design',
  'settings.privacyConsentKicker': 'ساعدنا في تحسين Open Design',
  'settings.privacyConsentLead': 'يمكن لـ Open Design مشاركة بيانات الاستخدام مع فريقنا لمساعدتنا على التحسين. يشمل ذلك:',
  'settings.privacyConsentFooter': 'يمكنك تغيير هذه الخيارات في أي وقت من الإعدادات ← الخصوصية.',
  'settings.privacyConsentShare': 'مشاركة بيانات الاستخدام',
  'settings.privacyConsentDecline': 'عدم المشاركة',
  'settings.privacyConsentAccept': 'فهمت',
  'settings.privacyConsentBannerFooter': 'مشاركة البيانات مفعّلة افتراضيًا. يمكنك إيقافها في أي وقت من الإعدادات ← الخصوصية.',
  'settings.privacyConsentPolicyLink': 'اقرأ سياسة الخصوصية',
  'settings.privacyMetrics': 'مقاييس مجهولة المصدر',
  'settings.privacyMetricsHint': 'عدد مرات التشغيل، واستخدام Token، ومعدل الأخطاء، والمدة. بدون أي مطالبات، وبدون أي بيانات للمشروع.',
  'settings.privacyContent': 'محتوى المحادثة والأدوات',
  'settings.privacyContentHint': 'المطالبات، وردود المساعد، ومدخلات/مخرجات الأدوات، وملفات السياق الكامل اللازمة لمراجعة الجودة. تتم إزالة الأسرار قبل الإرسال.',
  'settings.privacyInstallationId': 'المُعرّف المجهول',
  'settings.privacyOptedOut': 'تم إلغاء الاشتراك',
  'settings.privacyDataDeletion': 'حذف بياناتي',
  'settings.privacyDataDeletionHint': 'يُجدّد مُعرّفك المجهول ويوقف الإرسال. تنتهي صلاحية الآثار الحالية وفقًا لسياسة الاحتفاظ لدينا.',
  'settings.about': 'حول',
  'settings.aboutHint': 'تفاصيل النسخة ووقت التشغيل',
  'settings.appVersion': 'النسخة',
  'settings.appChannel': 'القناة',
  'settings.appRuntime': 'وقت التشغيل',
  'settings.appPlatform': 'المنصة',
  'settings.appArchitecture': 'المعمارية',
  'settings.runtimePackaged': 'تطبيق معبأ',
  'settings.runtimeDevelopment': 'تطوير',
  'settings.versionUnavailable': 'تفاصيل النسخة غير متوفرة بينما البرنامج الخفي غير متصل.',
  'settings.installLatest': 'تثبيت الأحدث',
  'settings.alreadyLatest': 'أنت تستخدم أحدث إصدار',
  'settings.mcpTitle': 'خادم MCP',
  'settings.mcpHint': 'اسمح لوكلاء البرمجة (Cursor، Claude Code، VS Code…) بقراءة مشاريع Open Design الخاصة بك مباشرةً.',
  'settings.mcpDaemonError': 'تعذّر الوصول إلى الـ daemon المحلي لتحديد مسارات التثبيت ({error}). تأكد من أن Open Design قيد التشغيل، ثم أعد فتح هذه اللوحة.',
  'settings.mcpBuildDaemon': 'قم ببناء الـ daemon أولًا.',
  'settings.mcpNodeMissing': 'ملف Node التنفيذي مفقود.',
  'settings.mcpBuildHint': 'الملف apps/daemon/dist/cli.js مفقود. شغّل `pnpm --filter @open-design/daemon build` ثم حدّث.',
  'settings.mcpMethodCli': 'أمر CLI',
  'settings.mcpInstructionCli': 'شغّل هذا في الـ terminal لديك.',
  'settings.mcpMethodToml': 'إعداد TOML',
  'settings.mcpInstructionCodex': 'أضف هذا الجدول إلى {path}. يتم مشاركة الإعداد نفسه بين Codex CLI وامتداد Codex IDE.',
  'settings.mcpMethodOneClick': 'تثبيت بنقرة واحدة',
  'settings.mcpInstructionCursor': 'انقر على "Install in Cursor" للتثبيت عبر مربع حوار للموافقة، أو ادمج ملف JSON هذا في {path}.',
  'settings.mcpDeeplinkInstallCursor': 'التثبيت في Cursor',
  'settings.mcpMethodJson': 'إعداد JSON',
  'settings.mcpInstructionCopilot': 'افتح Command Palette ({shortcut})، وشغّل "MCP: Open User Configuration"، ثم ادمج ملف JSON هذا. يجب أن يكون Copilot Chat في وضع Agent حتى تظهر الأدوات.',
  'settings.mcpInstructionAntigravity': 'في Antigravity: قائمة "..." في لوحة الوكيل ← MCP Servers ← Manage MCP Servers ← View raw config. ادمج هذا الـ JSON.',
  'settings.mcpInstructionZed': 'افتح إعدادات Zed ({shortcut}) وادمج هذا في الكائن ذي المستوى الأعلى. يستخدم Zed "context_servers" وليس "mcpServers".',
  'settings.mcpInstructionWindsurf': 'افتح {path} (أو استخدم أيقونة MCPs في Cascade ← Configure) وادمج:',
  'settings.mcpCopyAria': 'نسخ مقتطف إعداد MCP',
  'settings.mcpResolvingFailed': '# فشل تحديد المسارات، راجع الخطأ أعلاه',
  'settings.mcpLoadingPaths': '# جارٍ تحميل مسارات التثبيت من الخدمة المحلية…',
  'settings.mcpCopied': 'تم النسخ',
  'settings.mcpCopy': 'نسخ',
  'settings.mcpCursorApproval': 'يُظهر Cursor مربع حوار للموافقة قبل كتابة الإعداد.',
  'settings.mcpCodexOneClickInstall': 'التثبيت في Codex',
  'settings.mcpCodexOneClickUninstall': 'الإزالة من Codex',
  'settings.mcpCodexOneClickUnavailable': 'لم يُعثر على Codex CLI في PATH — ثبّت Codex أو الصق المقتطف يدويًا.',
  'settings.mcpCodexInstallSuccess': 'تم التثبيت. أعد تشغيل Codex لتحميل الخادم الجديد.',
  'settings.mcpCodexUninstallSuccess': 'تمت الإزالة من Codex.',
  'settings.mcpCodexBusy': 'جارٍ العمل…',
  'settings.mcpCodexInstallError': 'فشلت العملية: {error}',
  'settings.mcpRestartNote': 'أعد تشغيل عميلك لالتقاط الخادم الجديد.',
  'settings.mcpRestartDetail': 'معظم المحررات تُحمّل خوادم MCP عند بدء التشغيل فقط. في Cursor / VS Code / Antigravity / Windsurf يمكنك تشغيل `Developer: Reload Window` من Command Palette بدلًا من إعادة التشغيل الكاملة. أما Zed و Claude Code فيحتاجان إلى الإغلاق وإعادة الفتح.',
  'settings.mcpCapabilitiesTitle': 'ما يستطيع Agent القيام به',
  'settings.mcpCapabilityRead': 'قراءة أي ملف في المشروع أو البحث فيه (HTML، JSX، CSS، JSON، SVG، Markdown).',
  'settings.mcpCapabilityPull': 'سحب حزمة تصميم في استدعاء واحد: ملف الإدخال إضافةً إلى كل متغير CSS ومكوّن وخط يشير إليه.',
  'settings.mcpCapabilityDefault': 'الاعتماد افتراضيًا على المشروع والملف المفتوحَين في Open Design، حتى تتمكن من قول "ابنِ هذا في تطبيقي" دون إعادة تحديد التصميم المقصود.',
  'settings.mcpRunningNote': 'يجب أن يكون Open Design قيد التشغيل حتى تنجح استدعاءات أدوات MCP. إذا بدأت تشغيل وكيل البرمجة قبل فتح Open Design، فأعد تشغيل الـ Agent ليتمكن من الوصول إلى الـ daemon النشط.',
  'entry.tabDesigns': 'التصاميم',
  'entry.tabTemplates': 'قوالب',
  'entry.tabDesignSystems': 'أنظمة التصميم',
  'entry.tabConnectors': 'الموصلات',
  'entry.openSettingsTitle': 'الإعدادات',
  'entry.openSettingsAria': 'فتح الإعدادات',
  'entry.discordLabel': 'انضم إلى Discord',
  'entry.discordAria': 'انضم إلى Discord الخاص بـ Open Design',
  'entry.discordAriaWithOnline': 'انضم إلى Discord الخاص بـ Open Design - {online}',
  'entry.discordOnlineLabel': '{count} متصل',
  'entry.followXLabel': 'تابع @nexudotio على X',
  'entry.resizeAria': 'تغيير حجم الشريط الجانبي',
  'entry.loadingWorkspace': 'جاري تحميل مساحة العمل...',
  'entry.useEverywhereTitle': 'استخدمه في كل مكان',
  'entry.useEverywhereAria': 'افتح دليل «استخدمه في كل مكان» (CLI، MCP، HTTP، Skills)',
  'entry.navExpand': 'توسيع الشريط الجانبي',
  'entry.navCollapse': 'طي الشريط الجانبي',
  'entry.navNewProject': 'مشروع جديد',
  'entry.navHome': 'الرئيسية',
  'entry.navProjects': 'المشاريع',
  'entry.navTasks': 'الأتمتة',
  'entry.navPlugins': 'الإضافات',
  'entry.navDesignSystems': 'أنظمة التصميم',
  'entry.navIntegrations': 'عمليات الدمج',
  'workspaceTabs.project': 'المشروع',
  'workspaceTabs.pluginDetails': 'تفاصيل الإضافة',
  'workspaceTabs.marketplace': 'المتجر',
  'homeHero.title': 'ماذا تريد أن تصمّم؟',
  'homeHero.templatesScrollHint': 'مرّر لأعلى لاستكشاف المزيد من القوالب',
  'homeHero.templatesCollapse': 'طيّ القوالب',
  'homeHero.subtitlePrefix': 'البديل مفتوح المصدر لـ Claude Design.',
  'homeHero.placeholder': 'صِف ما تريد إنشاءه…',
  'homeHero.placeholderActive': 'عدّل الاستعلام المثال أو اكتب استعلامك الخاص…',
  'homeHero.skills': 'المهارات',
  'homeHero.addMenu': 'إضافة سياق',
  'homeHero.addPlugin': 'إضافة مكوّن إضافي',
  'homeHero.addConnectors': 'إضافة موصّلات',
  'homeHero.addMcp': 'إضافة خادم MCP',
  'homeHero.noPlugins': 'لا توجد مكوّنات إضافية مثبّتة',
  'homeHero.noMcp': 'لا توجد خوادم MCP',
  'homeHero.noConnectors': 'لا توجد موصّلات متصلة',
  'homeHero.applying': 'جارٍ التطبيق…',
  'homeHero.pluginTitle': 'الإضافة: {title}',
  'homeHero.pluginPrefix': 'الإضافة: {title}',
  'homeHero.skillPrefix': 'المهارة: {title}',
  'homeHero.removePlugin': 'إزالة الإضافة',
  'homeHero.removePluginAria': 'إزالة الإضافة {title}',
  'homeHero.clearActivePlugin': 'مسح الإضافة النشطة',
  'homeHero.clearActiveSkill': 'مسح المهارة النشطة',
  'homeHero.contextItemsResolved': 'تم حلّ {n} من عناصر السياق',
  'homeHero.removeFile': 'إزالة الملف',
  'homeHero.contextSearchResults': 'نتائج بحث السياق',
  'homeHero.contextSurfaces': 'أسطح السياق',
  'homeHero.loadingContext': 'جارٍ تحميل السياق…',
  'homeHero.noResults': 'لا توجد نتائج لـ "{query}".',
  'homeHero.searchPrompt': 'ابحث في الملفات والإضافات والمهارات وخوادم MCP والموصّلات.',
  'homeHero.parameters': '{n} معامل',
  'homeHero.details': 'التفاصيل',
  'homeHero.toRun': 'للتشغيل',
  'homeHero.forNewLine': 'لسطر جديد',
  'homeHero.run': 'تشغيل',
  'homeHero.typeSomethingToRun': 'اكتب شيئًا لتشغيله',
  'homeHero.promptExamples': 'أمثلة',
  'homeHero.footer.designSystem': 'النمط',
  'homeHero.footer.autoDesignSystem': 'تلقائي',
  'homeHero.footer.autoDesignSystemSummary': 'يطابق تلقائياً نظام التصميم والأسلوب البصري الأنسب للموجه الحالي.',
  'homeHero.footer.ratio': 'النسبة',
  'homeHero.footer.duration': 'المدة',
  'homeHero.footer.resolution': 'الدقة',
  'homeHero.footer.speakerNotes': 'الملاحظات',
  'homeHero.footer.noSpeakerNotes': 'بلا ملاحظات',
  'homeHero.footer.availableCount': '{n} متاح',
  'homeHero.footer.noMatches': 'لا توجد تطابقات',
  'homeHero.moreShortcuts': 'المزيد',
  'homeHero.railAria': 'اختر فئة مشروع أو اختصار بداية',
  'homeHero.subTypeAria': 'اختر نوعًا فرعيًا',
  'homeHero.confirmReplaceTitle': 'استبدال الموجّه الحالي؟',
  'homeHero.confirmReplaceBody': 'سيؤدي استخدام {title} إلى استبدال النص الموجود حاليًا في حقل الإدخال.',
  'homeHero.confirmReplace': 'استبدال',
  'homeHero.chip.prototype': 'نموذج أولي',
  'homeHero.chip.liveArtifact': 'عنصر حيّ',
  'homeHero.chip.deck': 'عرض شرائح',
  'homeHero.chip.image': 'صورة',
  'homeHero.chip.video': 'فيديو',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'صوت',
  'homeHero.chip.createPlugin': 'إنشاء إضافة',
  'homeHero.chip.figma': 'من Figma',
  'homeHero.chip.folder': 'من مجلد',
  'homeHero.chip.template': 'من قالب',
  'homeHero.chip.liveArtifactHint': 'أنشئ عنصرًا تفاعليًا بـ HTML/CSS/JS يمكنك معاينته مباشرة.',
  'homeHero.chip.hyperframesHint': 'صمّم حركة قائمة على HTML: تسميات توضيحية، ومرئيات تتفاعل مع الصوت، وانتقالات بين المشاهد.',
  'homeHero.chip.createPluginHint': 'أنشئ إضافة Open Design قابلة لإعادة الاستخدام وأضِفها إلى إضافاتي.',
  'homeHero.chip.figmaHint': 'رحّل إطار Figma إلى نظام التصميم النشط.',
  'homeHero.chip.folderHint': 'استورد مجلدًا محليًا موجودًا وتابع التحرير.',
  'homeHero.chip.templateHint': 'ابدأ من قالب مُضمّن.',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'مجلد',
  'workingDirPicker.homeTitle': 'محفوظ في التخزين المحلي — انقر لاختيار مجلد',
  'workingDirPicker.processing': 'جارٍ المعالجة…',
  'workingDirPicker.select': 'التخزين المحلي',
  'workingDirPicker.clearAria': 'مسح دليل العمل',
  'workingDirPicker.replaceFailed': 'تعذّر استبدال دليل العمل',
  'workingDirPicker.unavailable': 'منتقي المجلدات غير متاح في هذه النسخة. شغّل تطبيق سطح المكتب لاختيار مجلد.',
  'workingDirPicker.openUnavailable': 'افتح هذا المشروع في تطبيق سطح المكتب لإظهار المجلد.',
  'workingDirPicker.openFailed': 'تعذّر إظهار هذا المجلد',
  'workingDirPicker.showInFileManager': 'إظهار في مدير الملفات',
  'workingDirPicker.replace': 'اختيار مجلد…',
  'workingDirPicker.recent': 'الأدلّة الأخيرة',
  'workingDirPicker.defaultLabel': 'التخزين المحلي',
  'handoff.toTarget': 'التسليم إلى {target}',
  'handoff.openInTarget': 'فتح في {target}',
  'handoff.openAction': 'فتح',
  'handoff.menuTitle': 'الفتح في أي محرر؟',
  'handoff.action': 'تسليم',
  'handoff.fallbackTitle': 'لم يُعثر على محررات في $PATH - يُفتح في {target}',
  'handoff.chooseTargetAria': 'اختر وجهة التسليم',
  'handoff.optionsAria': 'خيارات التسليم',
  'handoff.editorSection': 'الفتح باستخدام محرر',
  'handoff.cliSection': 'نسخ لاستخدام CLI',
  'handoff.clickOpen': 'انقر للفتح',
  'handoff.framework': 'إطار عمل الكود',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript و HTML و CSS الأساسية',
  'handoff.amrWebsite': 'فتح موقع AMR',
  'handoff.copyPrompt': 'نسخ الموجّه',
  'handoff.copyPromptForTarget': 'نسخ الموجّه لـ {target}',
  'handoff.copied': 'تم النسخ',
  'handoff.projectPathUnavailable': 'لا يزال مسار المشروع قيد التحميل. حاول مرة أخرى بعد لحظة.',
  'handoff.copyFailed': 'تم حظر الكتابة إلى الحافظة. حاول مرة أخرى بعد لحظة.',
  'handoff.promptIntro': 'المتابعة من مجلد مشروع Open Design المحلي هذا:',
  'handoff.promptTarget': 'الوجهة',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'أنت تتولّى المهمة الآن في {cli}. يُرجى:',
  'handoff.promptReadFiles': 'ادخل إلى هذا الدليل أو اقرأه أولاً. أعطِ الأولوية لـ DESIGN.md و README وملفات HTML/CSS/JS الموجودة والأصول و package.json إن وُجد.',
  'handoff.promptKeepDesign': 'حافظ على التصميم المرئي الحالي والتخطيط والتفاعلات والأصول. لا تتوقف عند مرحلة التخطيط.',
  'handoff.promptProduceCode': 'أنشئ أو عدّل كود {framework} قابل للتشغيل فعليًا. إذا كان للمشروع بالفعل حزمة تقنية أوضح، فأشر إلى التعارض وأبقِ النتيجة قابلة للتشغيل.',
  'handoff.promptVerify': 'اختم بإخباري بأوامر التشغيل والمعاينة والتحقق.',
  'handoff.promptCommandHint': 'للبدء من دليل المشروع، استخدم:',
  'handoff.promptProject': 'المشروع',
  'handoff.promptProjectId': 'معرّف المشروع',
  'handoff.notInstalled': 'غير مُثبَّت',
  'handoff.notDetectedTitle': '{target} - لم يُكتشف في $PATH',
  'designSystemPicker.select': 'اختر نظام التصميم',
  'designSystemPicker.loading': 'جارٍ تحميل أنظمة التصميم…',
  'designSystemPicker.searchPlaceholder': 'البحث في أنظمة التصميم (العنوان / الفئة / الملخص)',
  'designSystemPicker.searchCompactPlaceholder': 'البحث في أنظمة التصميم',
  'designSystemPicker.noneTitle': 'بدون نظام تصميم',
  'designSystemPicker.noneSummary': 'دع النموذج يختار بحرية',
  'designSystemPicker.empty': 'لا توجد أنظمة تصميم مطابقة',
  'designSystemPicker.openPreview': 'فتح المعاينة',
  'designSystemPicker.loadingPreview': 'جارٍ تحميل المعاينة…',
  'designSystemPicker.noPreview': 'لا توجد صفحة معاينة. افتح أنظمة التصميم لعرض المعاينة الكاملة.',
  'designSystemPicker.previewHint': 'مرّر المؤشر فوق نظام تصميم لمعاينته',
  'designSystemPicker.fullscreenAria': 'معاينة {title} بملء الشاشة',
  'designSystemPicker.closeFullscreen': 'إغلاق معاينة ملء الشاشة',
  'designSystemPicker.closeEsc': 'إغلاق (Esc)',
  'designSystemPicker.previewFrameTitle': 'معاينة {title}',
  'designSystemPicker.fullscreenFrameTitle': 'معاينة {title} بملء الشاشة',
  'recentProjects.title': 'المشاريع الأخيرة',
  'recentProjects.viewAll': 'عرض الكل',
  'recentProjects.empty': 'لا توجد مشاريع بعد — اكتب موجّهًا لبدء مشروع.',
  'pluginsHome.title': 'المجتمع',
  'pluginsHome.subtitle': 'سير عمل Open Design جاهز للاستخدام ومرفق بهذا التشغيل. اختر واحدًا لتحميل موجّه بدء، أو تصفّح السجل للمزيد.',
  'pluginsHome.browseRegistry': 'تصفح السجل',
  'pluginsHome.count': '{filtered} من {total}',
  'pluginsHome.loadingCatalog': 'جارٍ تحميل الكتالوج…',
  'pluginsHome.emptyCatalog': 'الكتالوج فارغ. تأتي الإضافات المُجمَّعة مع Open Design ومن المفترض أن تظهر هنا تلقائيًا — جرّب إعادة تشغيل الـ daemon إذا استمرت هذه المشكلة.',
  'pluginsHome.emptyFiltered': 'لا توجد إضافات تطابق عوامل التصفية الحالية.',
  'pluginsHome.clearFilters': 'مسح عوامل التصفية',
  'pluginsHome.modeAria': 'وضع الإضافات',
  'pluginsHome.featured': 'محفوظ',
  'pluginsHome.totalInCatalog': '{n} في الكتالوج',
  'pluginsHome.categoryFilterAria': 'تصفية حسب الفئة',
  'pluginsHome.subcategoryFilterAria': 'تصفية حسب الفئة الفرعية لـ {label}',
  'pluginsHome.allCategory': 'كل {label}',
  'pluginsHome.searchPlaceholder': 'البحث عن الإضافات…',
  'pluginsHome.searchAria': 'البحث في الإضافات',
  'pluginsHome.clearSearch': 'مسح البحث',
  'pluginsHome.facet.import': 'استيراد',
  'pluginsHome.facet.create': 'إنشاء',
  'pluginsHome.facet.export': 'تصدير',
  'pluginsHome.facet.share': 'مشاركة',
  'pluginsHome.facet.deploy': 'نشر',
  'pluginsHome.facet.refine': 'تحسين',
  'pluginsHome.facet.extend': 'توسيع',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'كود / مجلد',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'لقطة شاشة',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'شرائح',
  'pluginsHome.facet.publicLink': 'رابط عام',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'لوحات المعلومات',
  'pluginsHome.subfacet.app-prototypes': 'تطبيقات',
  'pluginsHome.subfacet.landing-marketing': 'صفحات هبوط / تسويق',
  'pluginsHome.subfacet.developer-tools': 'أدوات المطورين',
  'pluginsHome.subfacet.docs-reports': 'مستندات / تقارير',
  'pluginsHome.subfacet.brand-design': 'علامة / تصميم',
  'pluginsHome.subfacet.pitch-business': 'عرض / أعمال',
  'pluginsHome.subfacet.course-training': 'دورات / تدريب',
  'pluginsHome.subfacet.reports-briefings': 'تقارير / موجزات',
  'pluginsHome.subfacet.product-sales': 'منتج / مبيعات',
  'pluginsHome.subfacet.engineering-talks': 'محاضرات تقنية',
  'pluginsHome.subfacet.creative-decks': 'عروض إبداعية',
  'pluginsHome.subfacet.ui-product-mockups': 'واجهات / نماذج منتج',
  'pluginsHome.subfacet.brand-visuals': 'علامة / شعار',
  'pluginsHome.subfacet.storyboards-motion-refs': 'قصص مصورة',
  'pluginsHome.subfacet.social-content': 'سوشيال / محتوى',
  'pluginsHome.subfacet.avatar-portrait': 'صورة رمزية / بورتريه',
  'pluginsHome.subfacet.illustration-style': 'رسوم / أسلوب',
  'pluginsHome.subfacet.motion-effects': 'حركة / مؤثرات',
  'pluginsHome.subfacet.social-short-form': 'سوشيال / فيديو قصير',
  'pluginsHome.subfacet.marketing-product': 'تسويق / منتج',
  'pluginsHome.subfacet.data-explainers': 'بيانات / شروحات',
  'pluginsHome.subfacet.cinematic-story': 'سينمائي / قصة',
  'pluginsView.lede': 'تصفّح سير العمل المثبّتة، واكتشف إدخالات السجل، وأدر المصادر، وجهّز الإضافات لتوزيعها على الفريق.',
  'pluginsView.importPlugin': 'استيراد إضافة',
  'pluginsView.agentContext': 'سياق الـ Agent',
  'pluginsView.summaryAria': 'ملخص الإضافة',
  'pluginsView.areasAria': 'مجالات الإضافة',
  'pluginsView.loading': 'جارٍ تحميل الإضافات…',
  'pluginsView.tab.installed': 'مثبّت',
  'pluginsView.tab.available': 'متاح',
  'pluginsView.tab.sources': 'المصادر',
  'pluginsView.tab.team': 'الفريق',
  'pluginsView.tabHint.installed': 'إضافاتك',
  'pluginsView.tabHint.available': 'من المصادر',
  'pluginsView.tabHint.sources': 'الكتالوجات',
  'pluginsView.tabHint.team': 'المؤسسات',
  'pluginsView.installedTitle': 'الإضافات المثبّتة',
  'pluginsView.installedSubtitle': 'الإضافات التي قمت باستيرادها أو تثبيتها من مصادر المتجر.',
  'pluginsView.installedEmpty': 'لا توجد إضافات مستخدم مثبّتة بعد. استخدم إنشاء / استيراد أو ثبّت إدخالاً متاحاً.',
  'pluginsView.availableTitle': 'متاح من المصادر',
  'pluginsView.availableSubtitle': 'إدخالات الكتالوج المكتشفة من المتاجر المُهيّأة.',
  'pluginsView.availableFiltersAria': 'عوامل تصفية الإضافات المتاحة',
  'pluginsView.searchAvailableAria': 'البحث في الإضافات المتاحة',
  'pluginsView.searchAvailablePlaceholder': 'البحث في الإضافات المتاحة',
  'pluginsView.clearAvailableSearch': 'مسح بحث الإضافات المتاحة',
  'pluginsView.source': 'المصدر',
  'pluginsView.availableEmptyInstalled': 'لا توجد إدخالات متاحة بعد. تُزال إدخالات الكتالوج المثبّتة من المتاح؛ ألغِ تثبيت أحدها لإتاحته من جديد.',
  'pluginsView.availableEmptyFiltered': 'لا توجد إدخالات متاحة تطابق عوامل التصفية الخاصة بك.',
  'pluginsView.availableEmptyNoSources': 'لا توجد إدخالات متاحة بعد. أضف مصدراً في علامة تبويب المصادر.',
  'pluginsView.installing': 'جارٍ التثبيت…',
  'pluginsView.install': 'تثبيت',
  'pluginsView.sourcesTitle': 'مصادر السجل',
  'pluginsView.sourcesSubtitle': 'كتالوجات السوق التي تغذّي إدخالات الإضافات المتاحة.',
  'pluginsView.sourceUrl': 'عنوان URL المصدر',
  'pluginsView.defaultTrust': 'الثقة الافتراضية',
  'pluginsView.trust.restricted': 'مقيّد',
  'pluginsView.trust.trusted': 'موثوق',
  'pluginsView.trust.official': 'رسمي',
  'pluginsView.adding': 'جارٍ الإضافة…',
  'pluginsView.addSource': 'إضافة مصدر',
  'pluginsView.sourcesEmpty': 'لم يتم تكوين أي مصادر سجلّ بعد.',
  'pluginsView.pluginsCount': '{n} إضافة',
  'pluginsView.catalogVersion': 'كتالوج الإصدار v{version}',
  'pluginsView.trustFor': 'الثقة في {name}',
  'pluginsView.refreshing': 'جارٍ التحديث…',
  'pluginsView.removing': 'جارٍ الإزالة…',
  'pluginsView.teamTitle': 'أسواق الفِرق الخاصة',
  'pluginsView.teamBody': 'هذه المنطقة مخصّصة لكتالوجات المؤسسات والفِرق، وسياسات الثقة الخاصة، وعناصر التحكم المشتركة بدورة حياة الإضافات.',
  'pluginCard.details': 'التفاصيل',
  'pluginCard.use': 'استخدام',
  'pluginCard.useWithQuery': 'استخدام مع استعلام',
  'pluginCard.applying': 'جارٍ التطبيق…',
  'pluginCard.publish': 'نشر',
  'pluginCard.contribute': 'المساهمة',
  'pluginCard.starting': 'جارٍ البدء…',
  'pluginCard.detailsAria': 'عرض تفاصيل {title}',
  'pluginCard.chooseUseAria': 'اختر كيفية استخدام {title}',
  'pluginCard.useOptionsAria': 'خيارات استخدام {title}',
  'pluginCard.shareAria': 'مشاركة {title}',
  'pluginCard.publishAria': 'نشر {title} كمستودع GitHub',
  'pluginCard.publishTitle': 'نشر الإضافة كمستودع GitHub',
  'pluginCard.contributeAria': 'المساهمة بـ {title} في Open Design',
  'pluginCard.contributeTitle': 'المساهمة بالإضافة في Open Design عبر طلب سحب (PR)',
  'skillPluginCandidate.createForMe': 'إنشاء إضافة/قالب',
  'skillPluginCandidate.contributeToMain': 'المساهمة في open-design',
  'skillPluginCandidate.repoDescription': 'يبدو أن هذا المستودع يمكن أن يعمل كإضافة.',
  'integrations.kicker': 'التكامل',
  'integrations.lede': 'اربط الأنظمة الخارجية، وأدخِل أدوات MCP إلى حلقة الـ Agent الخاصة بك، واستخدم Open Design من بيئات تطوير وبرامج نصية وعمليات أتمتة أخرى.',
  'integrations.agentReady': 'جاهز للـ Agent',
  'integrations.areasAria': 'مجالات التكامل',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'المهارات',
  'integrations.tabHint.mcp': 'الأدوات الخارجية',
  'integrations.tabHint.connectors': 'الحسابات وواجهات API',
  'integrations.tabHint.useEverywhere': 'CLI وHTTP وMCP',
  'integrations.skillsTitle': 'تكاملات المهارات',
  'integrations.skillsBody': 'يجري نقل إدارة التكامل على مستوى المهارات من فرع آخر. هذا التبويب محجوز لكي يكون إعداد MCP والموصِّلات والمهارات المستقبلية ضمن مسار التكامل نفسه.',
  'mcpClient.title': 'خوادم MCP الخارجية',
  'mcpClient.subtitle': 'أدوات الطرف الثالث الخاصة بـ Agent البرمجة لديك.',
  'mcpClient.addServer': 'إضافة خادم',
  'mcpClient.emptyTitle': 'لم يتم تكوين أي خوادم MCP.',
  'mcpClient.emptyBody': 'انقر على "إضافة خادم" للبدء — اختر قالبًا (Higgsfield OpenClaw، Pollinations، Allyson، Imagician، EdgeOne Pages، GitHub، Filesystem…) أو قم بإعداد خادم stdio / HTTP مخصص.',
  'mcpClient.saveChanges': 'حفظ التغييرات',
  'mcpClient.storedAt': 'مخزَّن في',
  'mcpClient.daemonError': 'تعذّر الوصول إلى الخدمة المحلية. تأكّد من أن Open Design قيد التشغيل، ثم أعِد فتح هذه اللوحة.',
  'mcpClient.saveFailed': 'فشل الحفظ. تحقّق من أن الخدمة قيد التشغيل وحاول مرة أخرى.',
  'useEverywhere.modalAria': 'استخدم Open Design في كل مكان',
  'useEverywhere.modalTitle': 'استخدم Open Design في كل مكان',
  'useEverywhere.modalSubtitle': 'أدرِج Open Design في أي IDE أو Agent أو سكربت — CLI وHTTP وMCP وSkills. استخدم “Copy guide for an agent” والصقه في Claude Code أو Codex أو Cursor أو openclaw أو hermes لإعداد كل شيء.',
  'useEverywhere.closeAria': 'إغلاق الاستخدام في كل مكان',
  'useEverywhere.closeTitle': 'إغلاق (Esc)',
  'useEverywhere.tabsAria': 'واجهات التكامل',
  'useEverywhere.footStrong': 'تسليم بنقرة واحدة.',
  'useEverywhere.footBody': 'ينسخ دليلًا منظّمًا بصيغة markdown يمكن لـ Agent الخاص بك التصرف بناءً عليه فورًا — التثبيت والتحقق والاستخدام.',
  'useEverywhere.configureMcp': 'تكوين خادم MCP',
  'useEverywhere.copyGuide': 'نسخ الدليل لـ Agent',
  'useEverywhere.copy': 'نسخ',
  'useEverywhere.copied': 'تم النسخ',
  'useEverywhere.copyFailed': 'فشل النسخ',
  'useEverywhere.copySnippetAria': 'نسخ المقتطف: {label}',
  'useEverywhere.section.overview.tab': 'نظرة عامة',
  'useEverywhere.section.overview.heading': 'يعمل Open Design أينما يعمل الـ Agent الخاص بك',
  'useEverywhere.section.overview.intro': 'Open Design أكثر من مجرد نافذة — إنه daemon محلي ذو صلاحيات (`od`) إضافةً إلى سجل Skills + Design-Systems + Atoms. بمجرد تشغيله على جهازك، يمكن لأي Agent برمجي (Claude Code، Codex، Cursor، OpenCode/openclaw، Hermes، السكربت الخاص بك) أن يقود عمليات التوليد ويفحص المشاريع وينتج مخرجات التصميم عبر أربعة أسطح قابلة للتبادل.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` للسكربتات بلا واجهة، وCI، وأتمتة الـ shell.',
  'useEverywhere.section.overview.bullet2': 'خادم MCP — يربط Open Design كخادم Model Context Protocol بحيث يمكن لأي Agent يدعم MCP سرد المهارات وتشغيل السيناريوهات وقراءة المخرجات.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — نقاط نهاية REST + SSE على `http://127.0.0.1:7456/api/*`؛ نفس السطح الذي تستخدمه واجهة الويب.',
  'useEverywhere.section.overview.bullet4': 'Skills — حزم `SKILL.md` جاهزة للاستخدام (متوافقة مع Claude) يمكن لأي Agent موجود مسبقًا على الـ PATH استدعاؤها دون الحاجة إلى Open Design على الإطلاق.',
  'useEverywhere.section.overview.bullet5': 'المخرجات القياسية — أنشئ مشاريع HTML حقيقية انطلاقًا من Skills، والإضافات الافتراضية المُجمَّعة، وأمثلة إضافات المجتمع قبل بدء تشغيل الـ daemon.',
  'useEverywhere.section.overview.snippet1': 'تشغيل الـ daemon (وواجهة الويب) محليًا',
  'useEverywhere.section.overview.snippet2': 'تأكّد من إمكانية الوصول إليه',
  'useEverywhere.section.overview.snippet3': 'استيراد العناصر القياسية قبل الإقلاع',
  'useEverywhere.section.overview.footer': 'يكتب الـ daemon إلى `./.od/` (محلي للمشروع) افتراضيًا. عيّن `OD_DATA_DIR=~/.open-design` لمشاركة البيانات عبر المشاريع.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'تشغيل Open Design من أي shell',
  'useEverywhere.section.cli.intro': 'يُشحن الملف التنفيذي `od` مع الـ daemon وهو نفس الملف الثنائي الذي يستخدمه Claude Code / Codex عند تشغيل عملية توليد. معظم الأوامر الفرعية هي عملاء بسطاء يرسلون POST إلى الـ daemon المحلي، لذا فهي تعمل بالطريقة نفسها سواء شغّلته عبر `pnpm tools-dev` أو كتطبيق مُحزَّم.',
  'useEverywhere.section.cli.bullet1': '`od` (بدون وسائط) — يُقلِع الـ daemon ويفتح واجهة الويب.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — أنتِج بايتات الصورة / الفيديو / الصوت عبر بروتوكول الوسائط الموحّد.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — ابدأ تشغيل مشروع انطلاقًا من موجّه + مهارة.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — ثبِّت وطبِّق إضافات المجتمع.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — افحص ما هو متاح محليًا.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — تحقق من سلامة الـ daemon واكتشف أدوات Agent CLI على الـ PATH الخاص بك.',
  'useEverywhere.section.cli.snippet1': 'توليد صورة (يُفوَّض إلى مزوّد الوسائط المُهيّأ)',
  'useEverywhere.section.cli.snippet2': 'تشغيل ملحق سيناريو بدون واجهة وبثّ الأحداث كأسطر JSON',
  'useEverywhere.section.cli.snippet3': 'جرد المهارات وأنظمة التصميم المتاحة محليًا',
  'useEverywhere.section.cli.snippet4': 'التحقّق من العناصر المُهيّأة عبر الـ CLI',
  'useEverywhere.section.cli.snippet5': 'التحقق من البيئة + الـ Agents المكتشفة (Claude، Codex، Cursor، …)',
  'useEverywhere.section.cli.footer': 'تقبل جميع الأوامر الفرعية `--daemon-url http://127.0.0.1:<port>` لاستهداف daemon معيّن قيد التشغيل — مفيد عند تشغيل نسخة ثانية معزولة للاختبارات.',
  'useEverywhere.section.mcp.tab': 'خادم MCP',
  'useEverywhere.section.mcp.heading': 'اجعل Open Design متاحًا كخادم MCP لأي coding agent',
  'useEverywhere.section.mcp.intro': 'يأتي Open Design مع خادم Model Context Protocol (`od mcp`) يتيح لأي عميل يدعم MCP — Cursor، Claude Code، Antigravity، VS Code Copilot Chat، openclaw، hermes — اكتشاف أدوات Open Design (سرد المهارات، عرض المعاينات، توليد الوسائط، تشغيل الإضافات) دون استخدام الـ shell يدويًا. ينشر الـ daemon مقتطف تثبيت جاهزًا للصق عبر `GET /api/mcp/install-info` لكل عميل رئيسي.',
  'useEverywhere.section.mcp.bullet1': 'نقل Stdio — لا منفذ إضافي، يُشغِّل العميل `od mcp` مباشرةً.',
  'useEverywhere.section.mcp.bullet2': 'يكتشف تلقائيًا عنوان URL للـ daemon النشط عبر مقبس حالة IPC المحلي عند تشغيله كـ sidecar.',
  'useEverywhere.section.mcp.bullet3': 'يرجع إلى `--daemon-url http://127.0.0.1:<port>` للتثبيتات العادية بحيث تجد عملية MCP دائمًا daemon قيد التشغيل.',
  'useEverywhere.section.mcp.bullet4': 'يثبّت `OD_DATA_DIR` بحيث تكتب عملية MCP المُنشأة إلى المكان نفسه الذي يستخدمه الـ daemon بالفعل (يتجنّب EPERM في حزم تطبيقات macOS المُحزَّمة).',
  'useEverywhere.section.mcp.snippet1': 'إعداد عميل MCP عام (يعمل في Cursor، Claude Code، Codex، …)',
  'useEverywhere.section.mcp.snippet2': 'أو: اطلب من الـ daemon المقتطف المُخصّص لتثبيتك',
  'useEverywhere.section.mcp.snippet3': 'متغيّر MCP للعناصر الحية (قراءة وتحديث لوحات المعلومات)',
  'useEverywhere.section.mcp.footer': 'في تطبيق Open Design، افتح الإعدادات → التكاملات لنسخ أمر تثبيت خاص بكل عميل (Cursor، Claude Code، Antigravity، VS Code) بدلًا من تحرير JSON يدويًا.',
  'useEverywhere.section.http.tab': 'واجهة برمجة تطبيقات HTTP',
  'useEverywhere.section.http.heading': 'نفس واجهة REST + SSE التي تستخدمها واجهة الويب',
  'useEverywhere.section.http.intro': 'يخدم الـ daemon المحلي واجهة HTTP API على `http://127.0.0.1:7456` (المنفذ قابل للتهيئة). كل نقطة نهاية تستدعيها واجهة الويب متاحة أيضًا للنصوص البرمجية الخاصة بك. تُصدر نقاط نهاية البثّ (أدوار المحادثة، عمليات تشغيل المشاريع) أحداث Server-Sent Events بأنواع العقود الموجودة في `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — حيوية الـ daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` و`GET /api/design-systems` — السجلات المتاحة.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` و`POST /api/projects` — سرد المشاريع وإنشاؤها (يُرجِع POST المشروع + المحادثة الأولى).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — تدفق SSE لأحداث Agent الخاصة بمحادثة.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — اربط إضافة مثبّتة واحصل على استعلام المثال المعروض + مدخلاته.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — أدوات Agent البرمجية المكتشفة على الـ PATH الخاص بك.',
  'useEverywhere.section.http.snippet1': 'عرض المهارات المُثبّتة (سيستخدمها الـ Agent كقوالب)',
  'useEverywhere.section.http.snippet2': 'إنشاء مشروع من موجّه (تدفّق كامل من جانب الخادم)',
  'useEverywhere.section.http.snippet3': 'بثّ دور محادثة (SSE — كل سطر متوافق مع JSON-Lines)',
  'useEverywhere.section.http.footer': 'تتوفر أنواع TypeScript خالصة لكل طلب/استجابة في `@open-design/contracts` — استوردها في سكربتك للحصول على إكمال تلقائي كامل دون تهيئة مُولِّد.',
  'useEverywhere.section.skills.tab': 'المهارات والوضع بدون واجهة',
  'useEverywhere.section.skills.heading': 'مهارات Skills جاهزة للاستخدام لأي Agent — حتى دون تشغيل Open Design',
  'useEverywhere.section.skills.intro': 'المهارة هي دليل يحتوي على `SKILL.md` متوافق مع Claude (مقدّمة YAML + متن). يوسّع Open Design التنسيق بفضاء الأسماء `od:` (`mode`، `preview`، `design_system`، `inputs`، …) بحيث يمكن استخدام المخرَج نفسه داخل Open Design ومن قِبل Agent عادي مثل Claude Code أو Codex أو openclaw أو hermes. يتّبع الاكتشاف سلسلة أولوية بحيث يمكن للمشاريع تجاوز مهاراتها الخاصة.',
  'useEverywhere.section.skills.bullet1': 'الاكتشاف: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (تفوز المشاريع).',
  'useEverywhere.section.skills.bullet2': 'اربط مهارة واحدة بروابط رمزية في مشاريع متعددة لمشاركتها دون نسخ.',
  'useEverywhere.section.skills.bullet3': 'يمكن لكل مهارة أن تعلن عن الموصّلات والذرّات ومتطلبات نظام التصميم ومثال مخرجات `preview` للمعرض.',
  'useEverywhere.section.skills.bullet4': 'بدون واجهة: يمكن لأي Agent يحتوي على `od` في الـ PATH الخاص به استدعاء `od skills list` ثم تشغيل أي مهارة؛ الـ daemon اختياري للتدفقات للقراءة فقط.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` يختبر شكل العنصر نفسه مع أمثلة الملحقات الافتراضية وأمثلة ملحقات المجتمع، ثم يخزّن مشاريع `index.html` الناتجة كبيانات اختبار قابلة لإعادة الاستخدام.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md بحدّه الأدنى (front matter متوافق مع Claude + إضافات Open Design)',
  'useEverywhere.section.skills.snippet2': 'ربط مهارة مشتركة برابط رمزي في مشروع (بأسلوب cc-switch)',
  'useEverywhere.section.skills.snippet3': 'بدون واجهة: عرض المهارات التي يراها الـ daemon الآن',
  'useEverywhere.section.skills.snippet4': 'حزمة تجهيزات العناصر بدون واجهة',
  'useEverywhere.section.skills.footer': 'المواصفات: يغطّي `docs/skills-protocol.md` و`docs/agent-adapters.md` كامل واجهة المحوّل (Claude Code، Codex، Cursor، الـ Agents الداعمة لـ MCP، خيار BYOK API الاحتياطي) واستراتيجيات حقن المهارات لكل محوّل.',
  'tasks.kicker': 'مساحة عمل الأتمتة',
  'tasks.comingSoon': 'قريبًا',
  'tasks.lede': 'تحوّل عمليات الأتمتة الموجّهات إلى عمل دائم: يشغّلها Orbit، وتُبقيها الروتينات قائمة، وتقرّر الجداول متى تنطلق، وتُظهر العناصر الحية ما الذي تغيّر.',
  'tasks.newAutomation': 'أتمتة جديدة',
  'tasks.previewNote': 'واجهة معاينة فقط. إعدادات Orbit متاحة اليوم؛ أما الروتينات والجداول وربط العناصر الحية فستظهر مع دمج فروع الواجهة الخلفية.',
  'tasks.primitivesAria': 'أساسيات الأتمتة',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'بيئة تشغيل دائمة لعمل الـ Agent الطويل الأمد أو المتكرر.',
  'tasks.primitive.orbit.enabled': 'تم تفعيل الملخّص اليومي',
  'tasks.primitive.orbit.manualOnly': 'يدوي فقط',
  'tasks.primitive.routines.title': 'الروتينات',
  'tasks.primitive.routines.body': 'تعريفات مهام دائمة تستمر بعد انتهاء محادثة واحدة.',
  'tasks.primitive.routines.meta': 'غلاف المنتج جاهز',
  'tasks.primitive.schedules.title': 'الجداول',
  'tasks.primitive.schedules.body': 'مُشغّلات زمنية أو قائمة على الأحداث تقرّر متى ينبغي تشغيل روتين ما.',
  'tasks.primitive.schedules.meta': 'الفرع قيد الانتظار',
  'tasks.primitive.liveArtifacts.title': 'العناصر الحية',
  'tasks.primitive.liveArtifacts.body': 'تقارير وملاحظات تستمر في التحديث أثناء عمل الـ Agent.',
  'tasks.primitive.liveArtifacts.meta': 'نموذج المعاينة',
  'tasks.listAria': 'قائمة عمليات الأتمتة',
  'tasks.routinesAndRuns': '{n} روتينات وعمليات تشغيل',
  'tasks.filtersAria': 'عوامل تصفية الأتمتة',
  'tasks.filter.scheduled': 'مُجدوَل',
  'tasks.filter.running': 'قيد التشغيل',
  'tasks.filter.done': 'تم',
  'tasks.configurationAria': 'إعداد الأتمتة',
  'tasks.slot.trigger': 'المُشغِّل',
  'tasks.slot.pattern': 'النمط',
  'tasks.slot.runtime': 'وقت التشغيل',
  'tasks.slot.output': 'المُخرَجات',
  'tasks.liveArtifact': 'مُخرَج حي',
  'tasks.viewProgress': 'عرض التقدّم',
  'tasks.pause': 'إيقاف مؤقت',
  'tasks.runNow': 'تشغيل الآن',
  'tasks.openArtifact': 'فتح المُخرَج',
  'tasks.status.dailyAt': 'يوميًا · {time}',
  'tasks.status.pausedManual': 'متوقّف مؤقتًا · يدوي فقط',
  'tasks.sample.orbit.title': 'ملخّص موصّل Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'تمت جدولة موجز الموصّل',
  'tasks.sample.orbit.metaDisabled': 'افتح إعدادات Orbit للتفعيل',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · مخرَج مباشر',
  'tasks.sample.orbit.previewDisabled': 'لا يوجد تشغيل مجدوَل',
  'tasks.sample.orbit.triggerEnabled': 'الجدولة · يوميًا في {time}',
  'tasks.sample.orbit.triggerDisabled': 'يدوي · تشغيل عند الطلب',
  'tasks.sample.orbit.pattern': 'روتين · ملخّص الموصِّلات',
  'tasks.sample.orbit.runtime': 'Orbit · مجدول عبر الـ daemon',
  'tasks.sample.orbit.output': 'مخرَج مباشر · تقرير قابل للتحديث',
  'tasks.sample.orbit.artifactMetaEnabled': 'يتم التحديث بعد كل تشغيل',
  'tasks.sample.orbit.artifactMetaDisabled': 'في انتظار الجدولة',
  'tasks.sample.orbit.body1': '# ملخّص نشاط Orbit Daily',
  'tasks.sample.orbit.body2': 'الموصِّلات المفحوصة · النجاحات والتخطّيات والإخفاقات',
  'tasks.sample.orbit.body3': 'تتحوّل أبرز النقاط إلى مُخرَج حي قابل للتحديث.',
  'tasks.sample.mcp.title': 'بحث في بدائل MCP',
  'tasks.sample.mcp.status': 'قيد التشغيل في orbit · ساعتان و14 دقيقة',
  'tasks.sample.mcp.meta': 'تمت معالجة 14 / 30 مصدرًا',
  'tasks.sample.mcp.preview': 'research_notes.md · مباشر',
  'tasks.sample.mcp.trigger': 'يدوي · لمرة واحدة',
  'tasks.sample.mcp.pattern': 'موجّه بحث معمّق',
  'tasks.sample.mcp.runtime': 'عن بُعد · دائم',
  'tasks.sample.mcp.output': 'تقرير مباشر · يتحدّث تلقائيًا',
  'tasks.sample.mcp.artifactMeta': 'تم التحديث قبل 12 ثانية',
  'tasks.sample.mcp.body1': '# بدائل MCP - نتائج أولية',
  'tasks.sample.mcp.body2': 'تمت مراجعة 14 مصدرًا · 3 مرشّحين في القائمة المختصرة',
  'tasks.sample.mcp.body3': '## القائمة المختصرة',
  'tasks.sample.mcp.body4': '- مخطّطات استدعاء الأدوات عبر JSON-RPC...',
  'tasks.sample.mcp.body5': '- بروتوكولات Agent المعتمدة على gRPC...',
  'tasks.sample.weekly.title': 'الموجز الأسبوعي للفريق',
  'tasks.sample.weekly.status': 'التالي: الإثنين 9:00 صباحًا',
  'tasks.sample.weekly.meta': 'يحدّث مستند الفريق الأسبوعي',
  'tasks.sample.weekly.preview': 'team_weekly.md · المخرَج التالي',
  'tasks.sample.weekly.trigger': 'الجدولة · أسبوعيًا',
  'tasks.sample.weekly.pattern': 'روتين · ملخّص الفريق',
  'tasks.sample.weekly.runtime': 'عن بُعد · متكرر',
  'tasks.sample.weekly.output': 'مُخرَج حي · markdown',
  'tasks.sample.weekly.artifactMeta': 'آخر تحديث قبل 4 أيام',
  'tasks.sample.weekly.body1': '# أسبوع الفريق',
  'tasks.sample.weekly.body2': '## قيد التنفيذ',
  'tasks.sample.weekly.body3': '- دورة دمج نظام التصميم',
  'tasks.sample.weekly.body4': '- مراجعة جودة الموصّلات',
  'tasks.sample.weekly.body5': '## المخاطر',
  'tasks.sample.pr.title': 'تذكير بمراجعة PR',
  'tasks.sample.pr.status': 'عند PR جديد · شُغّل قبل 23 د',
  'tasks.sample.pr.meta': 'يرسل رسالة مباشرة عبر Slack',
  'tasks.sample.pr.preview': 'نجح آخر تسليم',
  'tasks.sample.pr.trigger': 'حدث · PR جديد',
  'tasks.sample.pr.pattern': 'روتين · إشعار',
  'tasks.sample.pr.runtime': 'محلي · تشغيل سريع',
  'tasks.sample.pr.output': 'رسالة · رسالة Slack مباشرة',
  'tasks.sample.pr.artifactMeta': 'آخر تشغيل قبل 23 دقيقة',
  'tasks.sample.pr.body1': 'تم فتح PR #184 للمراجعة',
  'tasks.sample.pr.body2': 'المراجعون المطابقون: design-platform، web-runtime',
  'tasks.sample.pr.body3': 'التسليم: تم إرسال رسالة Slack المباشرة',
  'tasks.sample.meeting.title': 'التحضير لما قبل الاجتماع',
  'tasks.sample.meeting.status': 'غدًا · 10:00 صباحًا',
  'tasks.sample.meeting.meta': 'لمرة واحدة · يرسل ملخصًا',
  'tasks.sample.meeting.preview': 'meeting_brief.md · في قائمة الانتظار',
  'tasks.sample.meeting.trigger': 'مجدول · لمرة واحدة',
  'tasks.sample.meeting.pattern': 'موجّه الإحاطة',
  'tasks.sample.meeting.runtime': 'عن بُعد · محدود',
  'tasks.sample.meeting.output': 'مُخرَج + رسالة',
  'tasks.sample.meeting.artifactMeta': 'في قائمة انتظار التوليد',
  'tasks.sample.meeting.body1': '# موجز الاجتماع',
  'tasks.sample.meeting.body2': 'مصدر جدول الأعمال: حدث التقويم + المستندات المرتبطة',
  'tasks.sample.meeting.body3': 'ستتضمّن المُخرَجات القرارات والعوائق والأسئلة.',
  'tasks.sample.candidate.title': 'تتبّع المرشّحين',
  'tasks.sample.candidate.status': 'فشل · يحتاج إلى انتباه',
  'tasks.sample.candidate.meta': 'انتهت صلاحية المصادقة',
  'tasks.sample.candidate.preview': 'أعد ربط Greenhouse للاستئناف',
  'tasks.sample.candidate.trigger': 'مجدول · يومي',
  'tasks.sample.candidate.pattern': 'روتين · مزامنة المتقدمين',
  'tasks.sample.candidate.runtime': 'عن بُعد · متكرر',
  'tasks.sample.candidate.output': 'مُخرَج حي · جدول',
  'tasks.sample.candidate.artifactMeta': 'متوقف مؤقتًا حتى استعادة المصادقة',
  'tasks.sample.candidate.body1': '# مسار المرشّحين',
  'tasks.sample.candidate.body2': 'آخر مزامنة ناجحة: قبل يومين',
  'tasks.sample.candidate.body3': 'إجراء مطلوب: أعد ربط حساب المصدر.',
  'routines.title': 'الأتمتة',
  'routines.subtitle': 'عمليات أتمتة مجدوَلة تعمل دون إشراف.',
  'routines.newAutomation': 'أتمتة جديدة',
  'routines.loading': 'جارٍ التحميل…',
  'routines.empty': 'لا توجد أتمتة بعد.',
  'routines.emptyHint': 'انقر على أتمتة جديدة لجدولة تشغيل Agent غير مراقب.',
  'routines.runHistoryLoading': 'جارٍ تحميل عمليات التشغيل…',
  'routines.runHistoryEmpty': 'لا توجد عمليات تشغيل بعد.',
  'routines.fieldName': 'الاسم',
  'routines.fieldNamePlaceholder': 'الإحاطة الصباحية',
  'routines.fieldPrompt': 'الموجّه',
  'routines.fieldPromptPlaceholder': 'اجلب نشاط GitHub وLinear ليوم أمس ولخّص ما تغيّر.',
  'routines.fieldSchedule': 'الجدول الزمني',
  'routines.fieldMinute': 'الدقيقة من كل ساعة',
  'routines.fieldTime': 'الوقت',
  'routines.fieldTimezone': 'المنطقة الزمنية',
  'routines.fieldsetProject': 'المشروع',
  'routines.kind.hourly': 'كل ساعة',
  'routines.kind.daily': 'يوميًا',
  'routines.kind.weekdays': 'أيام الأسبوع',
  'routines.kind.weekly': 'أسبوعيًا',
  'routines.weekday.short.0': 'الأحد',
  'routines.weekday.short.1': 'الإثنين',
  'routines.weekday.short.2': 'الثلاثاء',
  'routines.weekday.short.3': 'الأربعاء',
  'routines.weekday.short.4': 'الخميس',
  'routines.weekday.short.5': 'الجمعة',
  'routines.weekday.short.6': 'السبت',
  'routines.weekday.long.0': 'الأحد',
  'routines.weekday.long.1': 'الإثنين',
  'routines.weekday.long.2': 'الثلاثاء',
  'routines.weekday.long.3': 'الأربعاء',
  'routines.weekday.long.4': 'الخميس',
  'routines.weekday.long.5': 'الجمعة',
  'routines.weekday.long.6': 'السبت',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'يعمل كل ساعة عند :{minute}',
  'routines.describe.daily': 'يعمل يوميًا في {time} {tz}',
  'routines.describe.weekdays': 'يعمل من الإثنين إلى الجمعة في {time} {tz}',
  'routines.describe.weekly': 'يعمل كل {day} في {time} {tz}',
  'routines.modeCreate': 'إنشاء مشروع جديد في كل تشغيل',
  'routines.modeCreateHint': 'مساحة عمل جديدة ومعزولة لكل تشغيل.',
  'routines.modeReuse': 'إعادة استخدام مشروع موجود',
  'routines.modeReuseHint': 'يظهر كل تشغيل كمحادثة جديدة داخل المشروع.',
  'routines.pickProject': '— اختر مشروعًا —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '← مشروع جديد في كل تشغيل',
  'routines.tagPaused': 'موقوف مؤقتًا',
  'routines.metaNext': 'التالي: {when}',
  'routines.metaLast': 'الأخير:',
  'routines.triggerManual': 'يدوي',
  'routines.triggerScheduled': 'مجدول',
  'routines.openProject': 'فتح المشروع',
  'routines.openProjectTitle': 'افتح المشروع الذي كتب إليه هذا التشغيل',
  'routines.runNow': 'التشغيل الآن',
  'routines.edit': 'تحرير',
  'routines.pause': 'إيقاف مؤقت',
  'routines.resume': 'استئناف',
  'routines.history': 'السجل',
  'routines.hideHistory': 'إخفاء السجل',
  'routines.delete': 'حذف',
  'routines.deleteTitle': 'حذف هذه الأتمتة',
  'routines.cancel': 'إلغاء',
  'routines.save': 'حفظ',
  'routines.saving': 'جارٍ الحفظ…',
  'routines.create': 'إنشاء',
  'routines.creating': 'جارٍ الإنشاء…',
  'routines.status.queued': 'في قائمة الانتظار',
  'routines.status.running': 'قيد التشغيل',
  'routines.status.succeeded': 'نجح',
  'routines.status.failed': 'فشل',
  'routines.status.canceled': 'أُلغي',
  'routines.confirmDelete': 'حذف هذه الأتمتة؟ سيتم الاحتفاظ بعمليات التشغيل السابقة ومشاريعها.',
  'routines.errorPickProject': 'اختر مشروعًا لإعادة استخدامه، أو بدّل إلى “إنشاء مشروع جديد في كل تشغيل”',
  'routines.errorAgentEmptyOutput': 'أكمل الـ Agent دون إنتاج أي مُخرَج. ربما أرجع النموذج أو المزوّد استجابة فارغة — تحقّق من سجلات الـ Agent بحثًا عن أخطاء المصدر.',
  'entry.helpAria': 'المساعدة',
  'entry.helpMenuAria': 'قائمة المساعدة',
  'entry.helpGetHelp': 'احصل على مساعدة على GitHub',
  'entry.helpSubmitFeature': 'اقترح ميزة',
  'entry.helpWhatsNew': 'الجديد',
  'entry.helpDownloadDesktop': 'تنزيل تطبيق سطح المكتب',
  'entry.githubStarLabel': 'نجمة',
  'entry.githubStarTitle': 'انقر لمنحنا نجمة على GitHub',
  'entry.githubStarAria': 'منح Open Design نجمة على GitHub',
  'entry.tabImageTemplates': 'قوالب الصور',
  'entry.tabVideoTemplates': 'قوالب الفيديو',
  'promptTemplates.searchPlaceholder': 'بحث في القوالب...',
  'promptTemplates.countLabel': '{n} نتائج',
  'promptTemplates.emptyImage': 'لم يتم تثبيت قوالب صور بعد.',
  'promptTemplates.emptyVideo': 'لم يتم تثبيت قوالب فيديو بعد.',
  'promptTemplates.emptyNoMatch': 'لا توجد قوالب تطابق بحثك.',
  'promptTemplates.attributionFooter': 'مقتبس من مكتبات الأوامر العامة. كل بطاقة تشير إلى المؤلف الأصلي.',
  'promptTemplates.openPreviewTitle': 'فتح الأمر والمعاينة',
  'promptTemplates.sourcePrefix': 'المصدر:',
  'promptTemplates.fetchError': 'تعذر تحميل جسم هذا القالب.',
  'promptTemplates.promptLabel': 'جسم الأمر',
  'promptTemplates.copyPrompt': 'نسخ الأمر',
  'promptTemplates.copyDone': 'تم النسخ!',
  'promptTemplates.modelHint': 'النموذج المقترح: {model}',
  'promptTemplates.openSource': 'عرض الأصلي',
  'promptTemplates.openFullscreen': 'فتح معاينة بملء الشاشة',
  'promptTemplates.closeFullscreen': 'إغلاق معاينة بملء الشاشة',
  'promptTemplates.allSources': 'جميع المصادر',
  'promptTemplates.sourceFilterAria': 'تصفية حسب المصدر',
  'promptTemplates.retry': 'إعادة المحاولة',
  'connectors.title': 'الموصلات',
  'connectors.subtitle': 'مصادر بيانات محلية وقادمة يمكنها تشغيل العناصر الحية.',
  'connectors.account': 'الحساب',
  'connectors.noAccount': 'غير متصل',
  'connectors.tools': 'الأدوات',
  'connectors.connect': 'اتصال',
  'connectors.disconnect': 'قطع الاتصال',
  'connectors.authorizationPending': 'بانتظار التفويض...',
  'connectors.authorizationPendingHint': 'أكمل التفويض في النافذة المفتوحة.',
  'connectors.cancelAuthorization': 'إلغاء',
  'connectors.configure': 'إعداد',
  'connectors.unavailable': 'غير متاح',
  'connectors.phaseStubTitle': 'واجهات الموصلات ستصل في المرحلة 3؛ هذه مجرد واجهة معاينة.',
  'connectors.statusAvailable': 'متاح',
  'connectors.statusConnected': 'متصل',
  'connectors.statusError': 'خطأ',
  'connectors.statusDisabled': 'معطل',
  'connectors.gateTitle': 'أضف مفتاح Composio API للمتابعة',
  'connectors.gateBody': 'الصق المفتاح أعلاه واضغط حفظ المفتاح لتحميل التكاملات المتاحة.',
  'connectors.aboutLabel': 'حول',
  'connectors.detailsLabel': 'التفاصيل',
  'connectors.statusLabel': 'الحالة',
  'connectors.category.aiAgents': 'وكلاء AI',
  'connectors.category.aiInfrastructure': 'بنية AI التحتية',
  'connectors.category.accounting': 'المحاسبة',
  'connectors.category.admin': 'الإدارة',
  'connectors.category.advertising': 'الإعلانات',
  'connectors.category.analytics': 'التحليلات',
  'connectors.category.automation': 'الأتمتة',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'التقويم',
  'connectors.category.commerce': 'التجارة',
  'connectors.category.communication': 'التواصل',
  'connectors.category.contacts': 'جهات الاتصال',
  'connectors.category.dataPlatform': 'منصة البيانات',
  'connectors.category.database': 'قاعدة البيانات',
  'connectors.category.design': 'التصميم',
  'connectors.category.developer': 'أدوات المطورين',
  'connectors.category.documentation': 'التوثيق',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'التعليم',
  'connectors.category.email': 'البريد الإلكتروني',
  'connectors.category.events': 'الأحداث',
  'connectors.category.fieldService': 'الخدمة الميدانية',
  'connectors.category.finance': 'المالية',
  'connectors.category.fitness': 'اللياقة',
  'connectors.category.forms': 'النماذج',
  'connectors.category.gaming': 'الألعاب',
  'connectors.category.hr': 'الموارد البشرية',
  'connectors.category.hospitality': 'الضيافة',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'التكامل',
  'connectors.category.localization': 'التوطين',
  'connectors.category.logistics': 'اللوجستيات',
  'connectors.category.maps': 'الخرائط',
  'connectors.category.marketing': 'التسويق',
  'connectors.category.media': 'الوسائط',
  'connectors.category.meetings': 'الاجتماعات',
  'connectors.category.nonprofit': 'غير ربحي',
  'connectors.category.observability': 'قابلية المراقبة',
  'connectors.category.payments': 'المدفوعات',
  'connectors.category.personal': 'شخصي',
  'connectors.category.presentations': 'العروض التقديمية',
  'connectors.category.procurement': 'المشتريات',
  'connectors.category.product': 'المنتج',
  'connectors.category.productivity': 'الإنتاجية',
  'connectors.category.projectManagement': 'إدارة المشاريع',
  'connectors.category.recruiting': 'التوظيف',
  'connectors.category.research': 'البحث',
  'connectors.category.salesIntelligence': 'ذكاء المبيعات',
  'connectors.category.scheduling': 'الجدولة',
  'connectors.category.search': 'البحث',
  'connectors.category.security': 'الأمان',
  'connectors.category.signing': 'التوقيع',
  'connectors.category.social': 'اجتماعي',
  'connectors.category.spreadsheets': 'جداول البيانات',
  'connectors.category.storage': 'التخزين',
  'connectors.category.support': 'الدعم',
  'connectors.category.surveys': 'الاستبيانات',
  'connectors.category.tasks': 'المهام',
  'connectors.category.timeTracking': 'تتبع الوقت',
  'connectors.category.video': 'الفيديو',
  'connectors.category.whiteboard': 'السبورة',
  'connectors.categoryLabel': 'الفئة',
  'connectors.providerLabel': 'المزوّد',
  'connectors.toolsSection': 'الأدوات',
  'connectors.toolsLoading': 'جارٍ تحميل الأدوات…',
  'connectors.noToolsAvailable': 'لا توجد أدوات متاحة بعد. بعد الاتصال ستظهر إمكانات هذا التكامل.',
  'connectors.toolDetailsUnavailable': 'تفاصيل الأدوات غير متوفرة، لكن هذا الموصّل يُبلّغ عن {n} أداة.',
  'connectors.loadMoreTools': 'تحميل المزيد من الأدوات',
  'connectors.openDetailsAria': 'فتح تفاصيل {name}',
  'connectors.toolsBadgeNone': 'لا أدوات',
  'connectors.toolsBadgeOne': '{n} أداة',
  'connectors.toolsBadgeMany': '{n} أدوات',
  'connectors.searchPlaceholder': 'ابحث في الموصلات…',
  'connectors.searchAriaLabel': 'ابحث في الموصلات حسب الاسم أو المزوّد أو الأداة',
  'connectors.searchClear': 'مسح البحث',
  'connectors.emptyNoMatchTitle': 'لا توجد موصلات تطابق “{query}”',
  'connectors.emptyNoMatchBody': 'جرّب كلمة مفتاحية أخرى أو امسح البحث لعرض القائمة الكاملة.',
  'connectors.emptyNoMatchAction': 'مسح البحث',
  'newproj.tabPrototype': 'نموذج أولي',
  'newproj.tabLiveArtifact': 'عنصر مباشر',
  'newproj.tabDeck': 'عرض تقديمي',
  'newproj.tabTemplate': 'من قالب',
  'newproj.tabMedia': 'الوسائط',
  'newproj.tabOther': 'آخر',
  'newproj.titlePrototype': 'نموذج أولي جديد',
  'newproj.titleLiveArtifact': 'عنصر مباشر جديد',
  'newproj.titleDeck': 'عرض تقديمي جديد',
  'newproj.titleTemplate': 'ابدأ من قالب',
  'newproj.titleImage': 'صورة جديدة',
  'newproj.titleVideo': 'فيديو جديد',
  'newproj.titleAudio': 'صوت جديد',
  'newproj.titleMedia': 'وسائط جديدة',
  'newproj.titleOther': 'مشروع جديد',
  'newproj.namePlaceholder': 'اسم المشروع',
  'newproj.fidelityLabel': 'الدقة',
  'newproj.fidelityWireframe': 'رسم تخطيطي',
  'newproj.fidelityHigh': 'دقة عالية',
  'newproj.toggleSpeakerNotes': 'استخدم ملاحظات المتحدث',
  'newproj.toggleSpeakerNotesHint': 'نص أقل على الشرائح - احتفظ بنقاط الحديث في الملاحظات.',
  'newproj.toggleAnimations': 'تضمين الرسوم المتحركة',
  'newproj.toggleAnimationsHint': 'أضف الحركة (دخول، تحويم، انتقالات) فوق القالب.',
  'newproj.targetPlatformsLabel': 'المنصات المستهدفة',
  'newproj.targetPlatformsHint': 'اختر واحدة أو أكثر. الويب المتجاوب يغطي نقاط توقف المتصفح فقط؛ أضف iOS أو Android أو تطبيق الجهاز اللوحي أو تطبيق سطح المكتب للحصول على نسخ أصلية متعددة المنصات.',
  'newproj.platform.responsive.label': 'ويب متجاوب',
  'newproj.platform.responsive.hint': 'تجربة ويب واحدة مُهيّأة لمتصفحات سطح المكتب والجهاز اللوحي والجوال',
  'newproj.platform.webDesktop.label': 'ويب سطح المكتب',
  'newproj.platform.webDesktop.hint': 'منتج أو صفحة هبوط يعتمد على المتصفح أولاً',
  'newproj.platform.mobileIos.label': 'تطبيق iOS',
  'newproj.platform.mobileIos.hint': 'إطارات iPhone وقواعد تفاعل iOS',
  'newproj.platform.mobileAndroid.label': 'تطبيق Android',
  'newproj.platform.mobileAndroid.hint': 'إطارات Pixel وقواعد تفاعل Material',
  'newproj.platform.tablet.label': 'تطبيق الجهاز اللوحي',
  'newproj.platform.tablet.hint': 'تجربة جهاز لوحي بأسلوب أصلي مع عروض مقسّمة',
  'newproj.platform.desktopApp.label': 'تطبيق سطح المكتب',
  'newproj.platform.desktopApp.hint': 'واجهة تطبيق macOS/Windows',
  'newproj.surfaceOptionsLabel': 'الأسطح المصاحبة',
  'newproj.includeLandingPage': 'تضمين صفحة هبوط',
  'newproj.includeLandingPageHint': 'أضف صفحة تسويقية متجاوبة للإعلانات أو قوائم الانتظار أو حملات الإطلاق أو تنزيلات التطبيق أو شرح المنتج.',
  'newproj.includeOsWidgets': 'تضمين عناصر واجهة نظام التشغيل',
  'newproj.includeOsWidgetsHint': 'أضف عناصر واجهة أصلية للمنصة على الشاشة الرئيسية أو شاشة القفل أو الوصول السريع لتطبيقات الجوال/الجهاز اللوحي.',
  'newproj.includeOsWidgetsDisabledHint': 'متاح عند اختيار تطبيق iOS أو Android أو الجهاز اللوحي كمنصة مستهدفة.',
  'newproj.templateLabel': 'القالب',
  'newproj.noTemplatesTitle': 'لا توجد قوالب بعد',
  'newproj.noTemplatesBody': 'افتح أي مشروع، ثم استخدم قائمة المشاركة داخل عارض الملفات لتحويله إلى قالب. ستظهر القوالب هنا.',
  'newproj.savedTemplate': 'قالب محفوظ',
  'newproj.fileSingular': 'ملف',
  'newproj.filePlural': 'ملفات',
  'newproj.create': 'إنشاء',
  'newproj.locationLabel': 'حفظ في',
  'newproj.locationDefault': 'مشاريع Open Design',
  'newproj.locationExternalBase': 'قاعدة خارجية',
  'newproj.createLiveArtifact': 'إنشاء عنصر مباشر',
  'newproj.createFromTemplate': 'إنشاء من قالب',
  'newproj.createDisabledTitle': 'احفظ مشروعاً كقالب أولاً (قائمة المشاركة داخل أي مشروع).',
  'newproj.importClaudeZip': 'استيراد ZIP من Claude Design',
  'newproj.importClaudeZipTitle': 'استيراد تصدير .zip من Claude Design',
  'newproj.importingClaudeZip': 'جاري الاستيراد...',
  'newproj.privacyFooter': 'أنت فقط من يمكنه رؤية مشروعك افتراضياً.',
  'newproj.designSystem': 'نظام التصميم',
  'newproj.dsNoneFreeform': 'لا يوجد - شكل حر',
  'newproj.dsNoneSubtitleEmpty': 'لا توجد رموز نظام، اختر لوحة الألوان الخاصة بك',
  'newproj.dsNoneSubtitleSelected': 'تخطي رموز النظام. يختار الوكيل لوحة الألوان الخاصة به.',
  'newproj.dsCategoryFallback': 'نظام التصميم',
  'newproj.dsSearch': 'بحث في أنظمة التصميم...',
  'newproj.dsModeAria': 'وضع الاختيار',
  'newproj.dsModeSingle': 'فردي',
  'newproj.dsModeMulti': 'متعدد',
  'newproj.dsNoneTitle': 'لا يوجد - شكل حر',
  'newproj.dsNoneSub': 'تخطي رموز النظام. يختار الوكيل لوحة الألوان الخاصة به.',
  'newproj.dsEmpty': 'لا توجد أنظمة تصميم تطابق "{query}".',
  'newproj.dsFootSingular': 'للإلهام فقط.',
  'newproj.dsFootPlural': 'للإلهام فقط.',
  'newproj.dsFootClear': 'مسح',
  'newproj.dsBadgeDefault': 'افتراضي',
  'newproj.dsPrimaryFallback': 'أساسي',
  'newproj.surfaceImage': 'صورة',
  'newproj.surfaceVideo': 'فيديو',
  'newproj.surfaceAudio': 'صوت',
  'newproj.modelLabel': 'النموذج',
  'newproj.modelSearch': 'بحث في النماذج…',
  'newproj.modelEmpty': 'لا توجد نماذج مطابقة.',
  'newproj.modelRecommended': 'موصى به',
  'newproj.modelMissingTitle': 'اختر نموذجًا',
  'newproj.modelMissingSub': 'اختر النموذج المسؤول عن هذا السياق.',
  'newproj.aspectLabel': 'الأبعاد',
  'newproj.videoLengthLabel': 'الطول',
  'newproj.videoLengthSeconds': '{n} ثا',
  'newproj.audioKindLabel': 'نوع الصوت',
  'newproj.audioKindMusic': 'موسيقى',
  'newproj.audioKindSpeech': 'كلام / TTS',
  'newproj.audioKindSfx': 'تأثيرات صوتية',
  'newproj.audioDurationLabel': 'المدة',
  'newproj.audioDurationSeconds': '{n} ثا',
  'newproj.voiceLabel': 'الصوت',
  'newproj.voicePlaceholder': 'معرف صوت المزود، اختياري',
  'newproj.connectorsLabel': 'الموصلات',
  'newproj.connectorsHint': 'مصادر البيانات التي يمكن لهذا العنصر استخدامها.',
  'newproj.connectorsEmptyTitle': 'لا توجد موصلات مُعدّة',
  'newproj.connectorsEmptyBody': 'صِل مصدر بيانات حتى يستخدم العنصر الحي بيانات حقيقية بدل العناصر النائبة.',
  'newproj.connectorsEmptyCta': 'إعداد الموصلات ←',
  'newproj.connectorsLoading': 'جارٍ تحميل الموصلات…',
  'newproj.connectorsCountOne': '{n} متصل',
  'newproj.connectorsCountMany': '{n} متصل',
  'newproj.connectorsManage': 'إدارة',
  'newproj.promptTemplateLabel': 'قالب مرجعي',
  'newproj.promptTemplateNoneTitle': 'لا يوجد - اكتب خاصتك',
  'newproj.promptTemplateNoneSub': 'تخطي المعرض، صف موجزك الخاص',
  'newproj.promptTemplateRefSub': 'قالب مرجعي',
  'newproj.promptTemplateSearch': 'بحث في القوالب...',
  'newproj.promptTemplateEmpty': 'لم يتم تثبيت قوالب لهذه السطح بعد.',
  'newproj.promptTemplateBodyLabel': 'الأمر (يمكنك ضبطه)',
  'newproj.promptTemplateOptimizeHint': 'عدل أي شيء - تغييراتك تنتقل إلى موجز الوكيل.',
  'newproj.promptTemplateBodyEmpty': 'جسم فارغ - لن يحصل الوكيل على مرجع قالب.',
  'newproj.deleteTemplateTitle': 'حذف القالب',
  'newproj.deleteTemplateConfirm': 'هل تريد حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
  'newproj.deleteTemplateConfirmCta': 'حذف القالب',
  'newproj.deleteTemplateError': 'تعذر حذف هذا القالب. يرجى المحاولة مرة أخرى.',
  'designs.subRecent': 'الأخيرة',
  'designs.subYours': 'تصاميمك',
  'designs.filterAria': 'تصفية المشاريع',
  'designs.searchPlaceholder': 'بحث...',
  'designs.emptyNoProjects': 'لا توجد مشاريع بعد.',
  'designs.emptyNoMatch': 'لا توجد مشاريع تطابق بحثك.',
  'designs.deleteTitle': 'حذف المشروع',
  'designs.deleteConfirm': 'هل تريد حذف "{name}"؟',
  'designs.cardFreeform': 'شكل حر',
  'designs.badgeLive': 'مباشر',
  'designs.liveArtifactBadgesAria': 'شارات العناصر المباشرة',
  'designs.liveCount': '{n} مباشر',
  'designs.statusLive': 'عنصر مباشر',
  'designs.statusArchived': 'مؤرشف',
  'designs.statusError': 'خطأ',
  'designs.statusRefreshing': 'جارٍ التحديث…',
  'designs.statusRefreshFailed': 'فشل التحديث',
  'designs.statusRefreshed': 'تم التحديث',
  'designs.status.notStarted': 'لم يبدأ',
  'designs.status.queued': 'في الانتظار',
  'designs.status.running': 'جاري التشغيل',
  'designs.status.awaitingInput': 'يحتاج مدخلات',
  'designs.status.succeeded': 'اكتمل',
  'designs.status.published': 'تم النشر',
  'designs.status.failed': 'فشل',
  'designs.status.canceled': 'ملغى',
  'designs.viewToggleAria': 'وضع العرض',
  'designs.viewGrid': 'عرض الشبكة',
  'designs.viewKanban': 'عرض اللوحة',
  'designs.kanbanEmptyColumn': 'لا توجد تصاميم',
  'designs.deleteAria': 'حذف المشروع {name}',
  'designs.menuMore': 'المزيد من الإجراءات',
  'designs.menuRename': 'إعادة تسمية',
  'designs.menuDelete': 'حذف',
  'designs.renamePrompt': 'اسم جديد لـ "{name}"',
  'designs.selectMode': 'تحديد',
  'designs.cancelSelect': 'إلغاء',
  'designs.deleteSelected': 'حذف المحدد',
  'designs.selectedCount': 'تم تحديد {n}',
  'designs.deleteSelectedConfirm': 'حذف {n} مشروع؟',
  'designs.deleteSelectedSuccess': 'تم حذف {n} مشروع بنجاح.',
  'designs.deleteSelectedPartial': 'تم حذف {deleted} مشروع؛ فشل {failed}.',
  'designs.tagPrototype': 'نموذج أولي',
  'designs.tagLiveArtifact': 'عنصر مباشر',
  'designs.tagSlide': 'شريحة',
  'designs.tagMedia': 'وسائط',
  'designs.renameTitle': 'إعادة تسمية المشروع',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'إلغاء',
  'examples.typeLabel': 'النوع',
  'examples.surfaceLabel': 'السطح',
  'examples.surfaceWeb': 'ويب',
  'examples.surfaceImage': 'صورة',
  'examples.surfaceVideo': 'فيديو',
  'examples.surfaceAudio': 'صوت',
  'examples.scenarioLabel': 'السيناريو',
  'examples.modeAll': 'الكل',
  'examples.modePrototypeDesktop': 'نماذج أولية · سطح المكتب',
  'examples.modePrototypeMobile': 'نماذج أولية · الجوال',
  'examples.modeDeck': 'شرائح',
  'examples.modeDocument': 'مستندات وقوالب',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'مباشر',
  'examples.scenarioGeneral': 'عام',
  'examples.scenarioEngineering': 'هندسة',
  'examples.scenarioProduct': 'منتج',
  'examples.scenarioDesign': 'تصميم',
  'examples.scenarioMarketing': 'تسويق',
  'examples.scenarioSales': 'مبيعات',
  'examples.scenarioFinance': 'مالية',
  'examples.scenarioHr': 'موارد بشرية',
  'examples.scenarioOperations': 'عمليات',
  'examples.scenarioSupport': 'دعم',
  'examples.scenarioLegal': 'قانوني',
  'examples.scenarioEducation': 'تعليم',
  'examples.scenarioPersonal': 'شخصي',
  'examples.searchPlaceholder': 'بحث في الأمثلة...',
  'examples.searchAria': 'بحث في الأمثلة بالاسم',
  'examples.emptyNoSkills': 'لا توجد مهارات متوفرة. هل البرنامج الخفي يعمل؟',
  'examples.emptyNoMatch': 'لا توجد أمثلة تطابق هذه الفلاتر.',
  'examples.openPreview': '⤢ فتح المعاينة',
  'examples.loadingPreview': 'جاري تحميل المعاينة...',
  'examples.hoverPreview': 'حوم للمعاينة',
  'examples.usePrompt': 'استخدم هذا الأمر',
  'examples.previewModalTitle': 'فتح المعاينة الكاملة (نافذة)',
  'examples.shareTitle': 'مشاركة هذا المثال',
  'examples.shareLoadFirst': 'حوم لتحميل المعاينة أولاً',
  'examples.unavailablePlaceholder': 'لا توجد معاينة {kind} مرفقة — افتح لمعرفة المزيد',
  'examples.shareUnavailable': 'لا توجد معاينة {kind} مرفقة للمشاركة',
  'examples.shareMenu': 'مشاركة ▾',
  'examples.exportPdfAllSlides': 'تصدير كـ PDF (كل الشرائح)',
  'examples.exportPptxLocked': 'تصدير كـ PPTX... (افتح القالب أولاً)',
  'examples.tagSlideDeck': 'عرض تقديمي',
  'examples.tagTemplate': 'قالب',
  'examples.tagDesignSystem': 'نظام تصميم',
  'examples.tagMobilePrototype': 'نموذج أولي للجوال',
  'examples.tagDesktopPrototype': 'نموذج أولي لسطح المكتب',
  'examples.tagImage': 'صورة',
  'examples.tagVideo': 'فيديو',
  'examples.tagAudio': 'صوت',
  'examples.previewLabel': 'معاينة',
  'ds.surfaceLabel': 'السطح',
  'ds.surfaceWeb': 'ويب',
  'ds.surfaceImage': 'صورة',
  'ds.surfaceVideo': 'فيديو',
  'ds.surfaceAudio': 'صوت',
  'ds.searchPlaceholder': 'بحث في أنظمة التصميم...',
  'ds.emptyNoMatch': 'لا توجد أنظمة تصميم تطابق بحثك.',
  'ds.badgeDefault': 'افتراضي',
  'ds.preview': 'معاينة',
  'ds.previewTitle': 'معاينة نظام التصميم',
  'ds.categoryAll': 'الكل',
  'ds.categoryUncategorized': 'غير مصنف',
  'ds.showcase': 'عرض',
  'ds.tokens': 'الرموز',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'جاري تحميل DESIGN.md...',
  'avatar.title': 'الحساب والإعدادات',
  'avatar.localCli': 'CLI محلي',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'استخدام CLI محلي',
  'avatar.useApi': 'استخدام API · BYOK',
  'avatar.codeAgent': 'وكيل الكود',
  'avatar.rescan': 'إعادة مسح PATH',
  'avatar.amrConsole': 'حساب AMR',
  'avatar.amrConsoleMeta': 'الرصيد وإعادة الشحن',
  'avatar.settings': 'الإعدادات',
  'avatar.backToProjects': 'العودة للمشاريع',
  'avatar.metaActive': 'نشط',
  'avatar.metaOffline': 'غير متصل',
  'avatar.metaSelected': 'محدد',
  'avatar.noAgentSelected': 'لم يتم اختيار وكيل',
  'avatar.modelSection': 'النموذج',
  'avatar.modelLabel': 'النموذج',
  'avatar.reasoningLabel': 'التفكير',
  'avatar.customSuffix': '(مخصص)',
  'socialShare.openDesignSection': 'مشاركة Open Design',
  'socialShare.openDesignTitle': 'Open Design على GitHub',
  'socialShare.openDesignText': 'Open Design هي مساحة عمل مفتوحة المصدر لإنشاء عناصر التصميم وتحريرها ونشرها وتسليمها.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'المشاركة الاجتماعية',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'تم الإنشاء باستخدام Open Design: {title}. اعرض العنصر المنشور وامنح نجمة للمستودع: {repo}',
  'socialShare.projectCopyText': 'تم الإنشاء باستخدام Open Design: {title}\n{url}\nمستودع Open Design: {repo}',
  'socialShare.deployFirst': 'انشر ثم شارك…',
  'socialShare.copied': 'تم النسخ',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'شياو هونغ شو',
  'inlineSwitcher.chipTitle': 'تبديل CLI / النموذج',
  'inlineSwitcher.chipCli': 'CLI محلي',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'افتراضي',
  'inlineSwitcher.noAgent': 'لا يوجد عميل',
  'inlineSwitcher.modeLabel': 'الوضع',
  'inlineSwitcher.agentLabel': 'عميل',
  'inlineSwitcher.providerLabel': 'المزود',
  'inlineSwitcher.modelLabel': 'النموذج',
  'inlineSwitcher.useCli': 'استخدام CLI محلي',
  'inlineSwitcher.useByok': 'استخدام مفتاح API الخاص بك',
  'inlineSwitcher.daemonOffline': 'الخادم غير متصل — افتح الإعدادات',
  'inlineSwitcher.noAgentsDetected': 'لم يتم العثور على CLI في PATH',
  'inlineSwitcher.openSettingsForModel': 'قم بإعداد المزود في الإعدادات',
  'inlineSwitcher.missingApiKey': 'مفتاح API غير محدد — افتح الإعدادات لإضافته.',
  'inlineSwitcher.openFullSettings': 'فتح إعدادات التنفيذ',
  'inlineSwitcher.customSuffix': '(مخصص)',
  'project.backToProjects': 'العودة للمشاريع',
  'project.metaFreeform': 'شكل حر',
  'project.customInstructions': 'تعليمات المشروع',
  'project.customInstructionsPlaceholder': 'تعليمات لهذا المشروع (تُحقَن في كل رسالة)…',
  'project.resizeChatPanel': 'تغيير حجم لوحة الدردشة',
  'project.instructionsActive': 'نشط — مُضمَّن في كل رسالة',
  'chat.tabChat': 'دردشة',
  'chat.tabComments': 'تعليقات',
  'chat.commentsSoon': 'التعليقات - قريباً',
  'chat.comments.attached': 'مرفق بالدردشة',
  'chat.comments.emptyAttached': 'لا توجد تعليقات مرفقة.',
  'chat.comments.saved': 'تعليقات محفوظة',
  'chat.comments.emptySaved': 'لا توجد تعليقات محفوظة.',
  'chat.comments.add': 'إضافة',
  'chat.comments.addAll': 'إضافة الكل',
  'chat.comments.remove': 'إزالة',
  'chat.comments.placeholder': 'علق على هذا العنصر...',
  'chat.comments.addSend': 'إضافة وإرسال',
  'chat.comments.updateSend': 'تحديث وإرسال',
  'chat.comments.removeAttachment': 'إزالة مرفق التعليق',
  'chat.comments.removeAttachmentAria': 'إزالة مرفق التعليق لـ {name}',
  'chat.comments.comment': 'تعليق',
  'chat.comments.sendToChat': 'إرسال إلى المحادثة',
  'chat.comments.sending': 'جارٍ الإرسال…',
  'chat.comments.edit': 'تحرير',
  'chat.comments.select': 'تحديد',
  'chat.comments.selectAll': 'تحديد الكل',
  'chat.comments.deselect': 'إلغاء التحديد',
  'chat.comments.nSelected': '{n} محدد',
  'chat.comments.pin': 'تثبيت',
  'chat.comments.addNote': 'إضافة ملاحظة',
  'chat.comments.savedToast': 'تم حفظ التعليق',
  'chat.comments.pinSavedToast': 'تم حفظ التثبيت',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} عنصر ملتقط',
  'chat.comments.clear': 'مسح',
  'chat.comments.targetImage': 'صورة',
  'chat.comments.targetControl': 'عنصر تحكم',
  'chat.comments.targetLink': 'رابط',
  'chat.comments.targetText': 'نص',
  'chat.comments.targetSection': 'قسم',
  'chat.comments.targetPage': 'صفحة',
  'chat.comments.targetArea': 'منطقة',
  'chat.annotationNotePlaceholder': 'أضف ملاحظة لهذه العلامة',
  'chat.annotationAttachImage': 'إرفاق صورة',
  'chat.annotationAttachedImages': 'الصور المرفقة',
  'chat.annotationAttachedRemove': 'إزالة آخر صورة',
  'chat.annotationAddToInput': 'إضافة إلى الإدخال',
  'chat.annotationAddingToInput': 'جارٍ الإضافة...',
  'chat.annotationQueue': 'قائمة الانتظار',
  'chat.annotationQueueing': 'جارٍ الإضافة إلى قائمة الانتظار...',
  'chat.annotationSending': 'جارٍ الإرسال...',
  'chat.annotationSendDisabledReason': 'هناك مهمة قيد التشغيل حاليًا',
  'chat.annotationPreviewMissing': 'تعذّر التقاط المعاينة. يُرجى المحاولة مرة أخرى.',
  'chat.annotationPreviewMissingInk': 'تعذّر التقاط المعاينة. حاول مرة أخرى لتجنّب إرسال الحبر فقط.',
  'chat.annotationSentWithoutScreenshot': 'تعذّر التقاط المعاينة. تم إرسال التعليق التوضيحي بدون لقطة شاشة.',
  'chat.annotationTimeout': 'انتهت مهلة إرسال التعليق التوضيحي. يُرجى المحاولة مرة أخرى.',
  'chat.annotationFailed': 'فشل إرسال التعليق التوضيحي. يُرجى المحاولة مرة أخرى.',
  'chat.annotationProjectCreateFailed': 'تعذّر إنشاء مشروع، لذا لم يتم إرسال التعليق التوضيحي.',
  'chat.annotationUploadFailed': 'فشل رفع المرفق. يُرجى المحاولة مرة أخرى.',
  'chat.conversationsTitle': 'المحادثات',
  'chat.conversationsAria': 'سجل المحادثات',
  'chat.newConversation': 'محادثة جديدة',
  'chat.newConversationsTitle': 'محادثة جديدة',
  'chat.conversationsHeading': 'المحادثات',
  'chat.new': 'جديد',
  'chat.emptyConversations': 'لا توجد محادثات بعد.',
  'chat.deleteConversation': 'حذف المحادثة',
  'chat.renameConversationLabel': 'إعادة تسمية "{title}"',
  'chat.deleteConversationConfirm': 'هل تريد حذف "{title}"؟ سيؤدي هذا لإزالة رسائلها.',
  'chat.untitledConversation': 'محادثة بدون عنوان',
  'chat.forkedConversationTitle': 'تفرع {title}',
  'chat.forkConversationFailed': 'تعذر تفرع هذه المحادثة.',
  'chat.startTitle': 'ابدأ محادثة',
  'chat.startHint': 'صِف ما تريد إنشاءه، أو ابدأ من أحد هذه الأمثلة:',
  'chat.fillInputTitle': 'اضغط لملء المدخلات',
  'chat.jumpToLatest': 'انتقال للأحدث',
  'chat.scrollToLatest': 'التمرير للأحدث',
  'chat.you': 'أنت',
  'chat.openFile': 'فتح {name}',
  'chat.copyPrompt': 'نسخ الأمر',
  'chat.copyErrorDiagnostic': 'نسخ تشخيصات الخطأ',
  'chat.copyDone': 'تم النسخ!',
  'chat.inspect.noEditableTargets': 'لم يُعثر على نصوص قابلة للتحرير أو أهداف نمط.',
  'chat.inspect.noCommentTargets': 'لم يُعثر على نصوص قابلة للتعليق أو أهداف مرئية.',
  'chat.inspect.editHint': 'حدّد نصًا أو هدف نمط في المعاينة لتحريره.',
  'chat.inspect.commentHint': 'حدّد نصًا أو منطقة في المعاينة للتعليق عليها.',
  'chat.composerPlaceholder': 'صِف ما تريد إنشاءه…',
  'chat.activeFileEditingLabel': 'جارٍ التحرير',
  'chat.activeFilePlaceholder': 'اطلب من Open Design تعديل {file}...',
  'chat.designArtifactsShowMore': 'عرض {count} ملفات تصميم إضافية',
  'chat.mode.chat.label': 'اسأل',
  'chat.mode.chat.title': 'وضع السؤال',
  'chat.mode.chat.summary': 'للإجابات السريعة، التعديلات، التخطيط، والنقاش من دون افتراض إنشاء ملف تصميم.',
  'chat.mode.chat.solves': 'استخدمه لتوضيح الأفكار، تحسين المطالبات، مقارنة الخيارات، أو السؤال عن عمل موجود.',
  'chat.mode.chat.query1': 'لخص هذه المسودة وحدد الفجوات.',
  'chat.mode.chat.query2': 'ساعدني في اختيار أفضل بنية لصفحة الهبوط هذه.',
  'chat.mode.chat.query3': 'راجع هذا التصميم واقترح تحسينات عملية.',
  'chat.mode.design.label': 'التصميم',
  'chat.mode.design.title': 'وضع Design',
  'chat.mode.design.summary': 'لإنشاء أو تعديل مخرجات تصميم ملموسة مثل الصفحات، النماذج، القطع الحية، العروض، الصور، الفيديو، HyperFrames، الصوت، لوحات البيانات، وملفات المشروع.',
  'chat.mode.design.solves': 'استخدمه عندما تريد من Open Design إنشاء ملفات، تحديث مساحة العمل، أو تحويل موجز إلى مخرجات متعددة الوسائط جاهزة.',
  'chat.mode.design.query1': 'أنشئ صفحة هبوط لإطلاق منتج ونموذج HyperFrames من هذا الموجز.',
  'chat.mode.design.query2': 'اصنع عرضا استثماريا من 10 شرائح مع ملاحظات للمتحدث.',
  'chat.mode.design.query3': 'ولّد أفكار صور وفيديو وصوت لهذه الحملة.',
  'chat.mode.cardBestFor': 'الأفضل لـ',
  'chat.mode.cardTry': 'جرب أن تسأل',
  'chat.composerHint': '⌘/Ctrl + Enter للإرسال · اذكر الهدف والمحتوى والأسلوب والتنسيق',
  'chat.cliSettingsTitle': 'إعدادات CLI والنموذج',
  'chat.cliSettingsAria': 'فتح إعدادات CLI والنموذج',
  'chat.attachTitle': 'إرفاق ملفات (أو الصق / اسحب)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'إرفاق ملفات',
  'chat.importTitle': 'استيراد المصادر (قريباً)',
  'chat.importLabel': 'استيراد',
  'chat.importComingSoon': 'قريباً',
  'chat.importSoon': 'قريباً',
  'chat.importFig': 'رفع ملف .fig',
  'chat.importGitHub': 'ربط GitHub',
  'chat.importWeb': 'جلب عنصر ويب',
  'chat.importFolder': 'ربط مجلد كود',
  'chat.importSkills': 'المهارات وأنظمة التصميم',
  'chat.importProject': 'الإشارة إلى مشروع آخر',
  'chat.importDesignSystemHeader': 'اختر نظام تصميم',
  'chat.importDesignSystemBack': 'رجوع',
  'chat.importDesignSystemSearch': 'البحث في أنظمة التصميم…',
  'chat.importDesignSystemEmpty': 'لا توجد أنظمة تصميم تطابق "{query}"',
  'chat.importDesignSystemNone': 'لا شيء — حر',
  'chat.importDesignSystemNoneSub': 'لا تربط بنظام في هذه الجولة',
  'chat.importDesignSystemActive': 'نشط',
  'chat.importDesignSystemSwitched': 'تم تبديل نظام التصميم إلى {title}',
  'chat.importDesignSystemFailed': 'تعذر تبديل نظام التصميم. حاول مرة أخرى.',
  'chat.importDesignSystemLoadFailed': 'تعذّر تحميل أنظمة التصميم.',
  'browserUse.title': 'الإلهام',
  'browserUse.summary': '{count} إجراء على الويب، مع إعطاء الأولوية لاستخراج الأصول، ولغة التصميم، والحركة، والفحوصات البصرية، وبنية المكوّنات.',
  'browserUse.searchAria': 'البحث عن الإلهام',
  'browserUse.searchPlaceholder': 'ابحث عن لقطات الشاشة والخطوط والألوان وإمكانية الوصول...',
  'browserUse.empty': 'لا يوجد إلهام مطابق',
  'browserUse.unavailable': 'الإلهام غير متاح هنا',
  'browserUse.added': 'تمت الإضافة إلى أداة الإنشاء',
  'browserUse.category.assets': 'استخراج الأصول',
  'browserUse.category.tokens': 'لغة التصميم',
  'browserUse.category.motion': 'الحركة',
  'browserUse.category.visual': 'الفحوصات المرئية',
  'browserUse.category.structure': 'المكوّنات',
  'browserUse.category.project': 'تشغيل المشروع',
  'browserUse.category.general': 'عام',
  'browserUse.input.none': 'لا يوجد إدخال',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts، limit=200',
  'browserUse.input.optionalSelector': 'محدِّد اختياري',
  'browserUse.input.requirementSelector': 'متطلَّب، محدِّد اختياري',
  'browserUse.input.selectorOptional': 'محدِّد اختياري',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'محدِّد، scale=2',
  'browserUse.input.gridOverlay': '12 عمودًا، بحد أقصى 1200، فجوة 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL أو نطاق أو مصطلحات بحث',
  'browserUse.input.selector': 'محدِّد',
  'browserUse.input.selectorText': 'محدِّد ونص',
  'browserUse.input.scroll': 'بكسلات، أعلى، أسفل، أو صفحة',
  'browserUse.input.terminalRun': 'أمر، مهلة 120 ثانية',
  'browserUse.input.command': 'أمر',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'أفضل المرشحين للشعار من الترويسة، والتنقُّل، وأسماء الفئات، والموضع، وصورة OG، مع الرجوع إلى أيقونة favicon.',
  'browserUse.action.list_images.output': 'جميع صور img وsrcset وsource وصور الخلفية في CSS مع الأبعاد والنص البديل.',
  'browserUse.action.download_assets.output': 'مجلد الأصول المنزّلة بالإضافة إلى _manifest.json مع دعم referer وملفات تعريف الارتباط.',
  'browserUse.action.extract_svgs.output': 'ملفات SVG المضمّنة والملفات المرتبطة ‎.svg محفوظة كملفات SVG منفردة.',
  'browserUse.action.optimize_svgs.output': 'ملفات SVG مُحسَّنة بالإضافة إلى نسبة الضغط.',
  'browserUse.action.extract_colors.output': 'لوحة ألوان مُرجَّحة بالإضافة إلى متغيرات ألوان CSS ضمن ‎:root كـ palette.json وpalette.html.',
  'browserUse.action.extract_fonts.output': 'أبرز عائلات الخطوط والأحجام والأوزان وقواعد ‎@font-face كـ typography.json.',
  'browserUse.action.extract_design_tokens.output': 'نصف القطر والظل والتباعد ومتغيرات CSS كـ tokens.json.',
  'browserUse.action.extract_type_scale.output': 'سلّم أحجام الخط للعناوين والنص والأزرار مع الحجم والوزن وارتفاع السطر والنسب.',
  'browserUse.action.extract_buttons.output': 'مكتبة أنماط أزرار خالية من التكرار كـ buttons.html وbuttons.json.',
  'browserUse.action.extract_grid_system.output': 'حاويات Grid وflex والاتجاه والفجوات والأعمدة والعروض القصوى كـ layout.json.',
  'browserUse.action.extract_breakpoints.output': 'نقاط التوقف المتجاوبة لاستعلامات الوسائط كـ breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'تدرّجات CSS كـ gradients.css وgradients.json ومعاينة HTML.',
  'browserUse.action.extract_shadows.output': 'ظلال الصناديق وظلال النصوص والظلال المُسقَطة كـ shadows.json بالإضافة إلى معاينة.',
  'browserUse.action.extract_easings.output': 'دوال تخفيف الانتقالات والحركات كـ easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css وtokens.scss وtailwind.theme.js وstyle-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': 'قواعد ‎@keyframes والانتقال والتحويل، ومكتبات الحركة المكتشفة، وmotion.css، وmotion.json.',
  'browserUse.action.validate_view.output': 'مسارات لقطات الشاشة بالإضافة إلى مشكلات مرئية وتخطيطية مُهيكلة.',
  'browserUse.action.audit_layout.output': 'عيوب التخطيط بما في ذلك الفائض، والحدود، والتداخل، والنص المقصوص كـ audit.json.',
  'browserUse.action.audit_accessibility.output': 'مشكلات إمكانية الوصول مع المحدِّدات والتسميات والأدوار والتركيز والتباين ولقطات الشاشة حيثما كان مفيدًا.',
  'browserUse.action.responsive_screenshots.output': 'لقطات شاشة للهاتف 390، والجهاز اللوحي 834، وسطح المكتب 1440.',
  'browserUse.action.screenshot_full.output': 'لقطة شاشة للصفحة كاملةً تتجاوز منطقة العرض.',
  'browserUse.action.screenshot_element.output': 'لقطة شاشة لعنصر واحد بدقة 2x افتراضيًا.',
  'browserUse.action.screenshot_with_grid.output': 'لقطة شاشة مع تراكب شبكة التخطيط.',
  'browserUse.action.screenshot_dark_mode.output': 'لقطة شاشة مع ‎prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'دليل أنماط من صفحة واحدة يتضمّن الألوان وسلّم أحجام الخط ونصف القطر والظلال.',
  'browserUse.action.extract_html.output': 'HTML نظيف ومكتفٍ ذاتيًا دون سمات script أو noscript أو أحداث مضمّنة.',
  'browserUse.action.extract_component_inventory.output': 'أنماط المكوّنات المتكررة والمحدِّدات والأعداد ولقطات الشاشة.',
  'browserUse.action.extract_copy.output': 'العناوين، ودعوات اتخاذ الإجراء، والنص الأساسي، والأوصاف كـ copy.md وcopy.json.',
  'browserUse.action.extract_nav.output': 'التنقُّل الأساسي وروابط التذييل كـ sitemap.md وnav.json.',
  'browserUse.action.extract_forms.output': 'حقول النموذج والتسميات وتلميحات التحقق وإجراءات الإرسال كـ forms.json.',
  'browserUse.action.run_project.output': 'عنوان URL لخادم التطوير المكتشف مفتوحًا في علامة تبويب Browser.',
  'browserUse.action.detect_project.output': 'إطار العمل، ومدير الحزم، وأمر التثبيت، وأمر التطوير، والمنفذ.',
  'browserUse.action.page_info.output': 'URL، والعنوان، والوصف، وصورة OG، ولون السمة، وأيقونة favicon، ومنطقة العرض.',
  'browserUse.action.snapshot.output': 'ما يصل إلى 120 عنصرًا مرئيًا تفاعليًا ونصيًا مع الوسم والتسمية وhref والإحداثيات.',
  'browserUse.action.navigate.output': 'افتح الصفحة وأعد page_info.',
  'browserUse.action.click.output': 'انقر على أول عنصر مطابق بعد تمريره إلى نطاق العرض.',
  'browserUse.action.type_text.output': 'املأ حقل إدخال وأرسل حدثي input وchange.',
  'browserUse.action.scroll.output': 'موضع التمرير الحالي والأقصى.',
  'browserUse.action.extract_og_metadata.output': 'عنوان Meta، الوصف، الـ URL الأساسي (canonical)، بطاقات OG/Twitter، صورة التواصل الاجتماعي، ولون السمة.',
  'browserUse.action.terminal_run.output': 'stdout وstderr ورمز الخروج.',
  'browserUse.action.terminal_run_background.output': 'معرّف المهمة في الخلفية والمخرجات الأخيرة.',
  'browserUse.action.terminal_read.output': 'مخرجات الـ Terminal المشتركة الأخيرة.',
  'chat.designToolbox.title': 'صندوق أدوات التصميم',
  'chat.designToolbox.tooltip': 'صندوق أدوات التصميم',
  'chat.designToolbox.aria': 'افتح صندوق أدوات التصميم',
  'chat.designToolbox.searchPlaceholder': 'ابحث في المهارات / MCP / الإضافات / الموصّلات / ملفات التصميم...',
  'chat.designToolbox.searchAria': 'ابحث في موارد صندوق أدوات التصميم',
  'chat.designToolbox.followupSection': 'متابعة',
  'chat.designToolbox.resourcesSection': 'الموارد العامة',
  'chat.designToolbox.selected': 'المحدد',
  'chat.designToolbox.noResources': 'لم يتم العثور على موارد لـ "{query}".',
  'chat.designToolbox.badge.video': 'فيديو',
  'chat.designToolbox.badge.image': 'صورة',
  'chat.designToolbox.badge.motion': 'حركة',
  'chat.designToolbox.badge.polish': 'صقل',
  'chat.designToolbox.action.auto-match.title': 'طابق الخطوة التالية',
  'chat.designToolbox.action.auto-match.badge': 'طابق',
  'chat.designToolbox.action.auto-match.description': 'حدّد معيار الذوق أولاً، ثم طابق المهارات وMCP والإضافات والموصّلات والملفات.',
  'chat.designToolbox.action.motion.title': 'أضف رسومًا متحركة / حركة',
  'chat.designToolbox.action.motion.badge': 'حركة',
  'chat.designToolbox.action.motion.description': 'أضف حركات الدخول والتمرير وانتقال الحالة والتفاعلات الدقيقة إلى HTML الحالي أو عنصر الصفحة.',
  'chat.designToolbox.action.motion-polish.title': 'اصقل الحركة',
  'chat.designToolbox.action.motion-polish.badge': 'التوقيت',
  'chat.designToolbox.action.motion-polish.description': 'راجع التوقيت والتخفيف (easing) والأداء وبدائل تقليل الحركة للحركة الحالية.',
  'chat.designToolbox.action.anti-ai-polish.title': 'أزل الطابع الاصطناعي للذكاء الاصطناعي',
  'chat.designToolbox.action.anti-ai-polish.badge': 'الذوق',
  'chat.designToolbox.action.anti-ai-polish.description': 'أزل الطابع القالبي وتدرّجات الذكاء الاصطناعي وأكوام البطاقات الرخيصة والنصوص المبهمة.',
  'chat.designToolbox.action.visual-polish.title': 'صقل التصميم / جاهز للإطلاق',
  'chat.designToolbox.action.visual-polish.badge': 'صقل',
  'chat.designToolbox.action.visual-polish.description': 'دقّق التسلسل البصري والخط والتباعد والسلوك المتجاوب وإمكانية الوصول وجودة التسليم.',
  'chat.designToolbox.action.image-gen.title': 'أنشئ صورًا / مراجع بصرية',
  'chat.designToolbox.action.image-gen.badge': 'صورة',
  'chat.designToolbox.action.image-gen.description': 'أنشئ مراجع أقسام أو أصولًا أو أيقونات أو صور تواصل اجتماعي أو لوحة إلهام للصفحة الحالية.',
  'chat.designToolbox.action.video-gen.title': 'أنشئ فيديو / نص حركة',
  'chat.designToolbox.action.video-gen.badge': 'فيديو',
  'chat.designToolbox.action.video-gen.description': 'حوّل التصميم إلى فيديو قصير أو لوحة قصة Remotion / Hyperframes أو موجه جاهز للتوليد.',
  'chat.designToolbox.kind.skill': 'مهارة',
  'chat.designToolbox.kind.plugin': 'إضافة',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'قالب MCP',
  'chat.designToolbox.kind.connector': 'موصّل',
  'chat.designToolbox.kind.designFile': 'ملف تصميم',
  'chat.designToolbox.context.browser': 'المتصفح',
  'chat.designToolbox.context.designFiles': 'ملفات التصميم',
  'chat.designToolbox.context.designSystem': 'نظام التصميم',
  'chat.designToolbox.context.folder': 'مجلد',
  'chat.designToolbox.context.terminal': 'الطرفية',
  'chat.designToolbox.context.sideChat': 'محادثة جانبية',
  'chat.designToolbox.context.liveArtifact': 'عنصر حي',
  'chat.designToolbox.context.file': 'ملف',
  'chat.designToolbox.prompt.contextGeneric': 'الهدف الحالي: ملف HTML / ملف التصميم / عنصر الويب المفتوح حاليًا.',
  'chat.designToolbox.prompt.contextSpecific': 'الهدف الحالي: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'حافظ على القصد الموجود بالفعل في المُحرّر: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'المهارة المحددة: {skill}. استخدمها كسير العمل الأساسي في هذه الجولة.',
  'chat.designToolbox.prompt.noSkill': 'إذا لم تتطابق أي مهارة محددة، فاختر أولاً أفضل توليفة من المهارات وMCP والإضافات والموصِّلات وملفات التصميم المتاحة.',
  'chat.designToolbox.prompt.autoMatchIntro': 'تصرّف بصفتك المنسِّق للمدير الإبداعي وأكمِل سير عمل تصميمي:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. حدّد أولًا معنى “التصميم الجميل”: الجمهور، والهدف التجاري، وإحساس العلامة التجارية، والمراجع الأسلوبية، وكثافة المعلومات، ومعايير الألوان/الخطوط/الحركة/الأصول، وأنماط الذكاء الاصطناعي/القوالب التي يجب تجنّبها.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. ابحث وطابِق فهرس الموارد الكامل أعلاه. لا تكتفِ بتوصيات صندوق أدوات التصميم؛ بل ادمج المهارات وMCP والإضافات والموصِّلات وملفات التصميم عند الحاجة.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. إذا كان الهدف أو معيار الجماليات لا يزال غير واضح، فأرشدني عبر خيارات محدودة أو واجهة على هيئة نموذج مع تضمين قيمة افتراضية مُوصى بها. وإذا كان واضحًا بما يكفي، فنفِّذ الخطوة التالية مباشرة.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. أكمِل التدفق بهذا الترتيب: التشخيص ← اتجاه النمط ← اختيار الموارد ← التحرير/التوليد الملموس ← التحقق. وفي كل خطوة، اشرح سبب اختيار هذه الموارد وما الذي يحتاج إلى تأكيد بعد ذلك.',
  'chat.designToolbox.prompt.motion': 'أضِف حركة عالية الجودة إلى عنصر HTML / الصفحة الحالي: اختر أكثر لحظة أو لحظتين فائدة من بين الدخول أو التمرير أو انتقال الحالة أو التفاعل الدقيق. حافظ على التحفّظ، وفضِّل transform / opacity، وضمِّن بدائل احتياطية لـ prefers-reduced-motion.',
  'chat.designToolbox.prompt.motionPolish': 'راجِع وحسِّن توقيت الحركة الحالي والتخفيف والأداء وإمكانية الوصول. أزِل الحركة المفاجئة أو الرخيصة أو الضارة بقابلية القراءة؛ واستخدم خطًا زمنيًا أكثر تنقيحًا عند الحاجة.',
  'chat.designToolbox.prompt.antiAiPolish': 'نفِّذ تمريرة تنقيح واحدة لإزالة الطابع الاصطناعي للذكاء الاصطناعي: أزِل التخطيطات النمطية والتدرّجات/التوهّجات الرخيصة وأكوام البطاقات بلا معنى والنصوص المبهمة. احفظ المعلومات واجعلها تبدو وكأن مصمِّمًا حقيقيًا قد سلّمها.',
  'chat.designToolbox.prompt.visualPolish': 'نقِّح هذا التصميم حتى يصبح جاهزًا للإطلاق: تحقّق من التسلسل الهرمي والطباعة والتباعد والسلوك المتجاوب وحالات الأزرار وحالات الفراغ/التحميل/الخطأ وإمكانية الوصول؛ وأصلِح أهم المشكلات مباشرة.',
  'chat.designToolbox.prompt.imageGen': 'أنشئ خطة الأصول البصرية التالية لهذا التصميم: مراجع الأقسام أو أصول الواجهة الرئيسية أو الرسوم التوضيحية أو الأيقونات أو الصور الاجتماعية أو لوحة إلهام. حدِّد أولاً نوع الصورة المفقودة، ثم قدِّم موجِّهات توليد قابلة للتنفيذ / خطة ملفات.',
  'chat.designToolbox.prompt.videoGen': 'حوِّل هذا التصميم نحو الفيديو: أنشئ لوحة قصة لفيديو قصير، أو بنية إطارات Hyperframes / Remotion، أو موجِّهًا جاهزًا لـ Sora/fal. فضِّل جعل محتوى HTML / الصفحة الحالي يتحوّل بشكل طبيعي إلى لقطات.',
  'chat.designToolbox.prompt.useSkill': 'استخدم {skill} على التصميم الحالي.',
  'chat.designToolbox.prompt.skillInstruction': 'حدِّد أولاً أفضل هدف للمتابعة، ثم أكمِل تمريرة ملموسة واحدة. وإذا كان يعتمد على أصول أو واجهات API خارجية، فقدِّم بديلاً احتياطيًا قابلاً للتشغيل أو بيِّن ما أحتاج إلى توفيره.',
  'chat.designToolbox.prompt.selectedResource': 'المورد المحدد: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'وصف المورد: {description}',
  'chat.designToolbox.prompt.pluginResource': 'استخدم هذه الإضافة كسياق رئيسي لتدفّق التصميم الحالي. إذا كانت تكشف مدخلات أو GenUI، فأرشدني إلى الاختيار عند الحاجة؛ وإذا لم تناسب الهدف، فاختر موردًا عامًا أفضل واشرح السبب.',
  'chat.designToolbox.prompt.mcpResource': 'فضِّل إمكانية MCP هذه لخطوة التصميم التالية. عند الحاجة إلى أصول خارجية أو التقاط من الويب أو توليد صور/فيديو أو بيانات، حدِّد أولاً ما إذا كانت قادرة على إنجاز المهمة، ثم قدِّم خطة قابلة للتنفيذ.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'هذا الـ MCP قالب قابل للتهيئة. إذا كان الأداة الأكثر فائدة لخطوة التصميم هذه، فأرشِد إلى الإعداد أولاً؛ وإذا وُجد بديل مُهيّأ، فتابِع بذلك البديل.',
  'chat.designToolbox.prompt.connectorResource': 'استخدم هذا الموصِّل عند الحاجة إلى بيانات حقيقية أو أصول أو محتوى حساب أو الوصول إلى سير عمل خارجي. قبل استخدامه، اشرح ما الذي ستتم قراءته أو كتابته واطلب التأكيد عند الاقتضاء.',
  'chat.designToolbox.prompt.fileResource': 'استخدم ملف التصميم هذا كهدف تصميم حالي أو أصل مرجعي وأكمِل الخطوة التالية انطلاقًا منه. وإذا احتاجت ملفات أخرى إلى المقارنة، فتابِع البحث عبر جميع ملفات التصميم.',
  'chat.designToolbox.prompt.resourceIndex': 'فهرس الموارد العام: المهارات({skills})، الإضافات({plugins})، MCP({mcpEnabled} مُفعَّل / {mcpTemplates} قالب)، الموصِّلات({connectors} متصل)، ملفات التصميم({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'المهارات القابلة للبحث',
  'chat.designToolbox.prompt.searchablePlugins': 'الإضافات القابلة للبحث',
  'chat.designToolbox.prompt.availableMcp': 'MCP المتاح',
  'chat.designToolbox.prompt.connectedConnectors': 'الموصِّلات المتصلة',
  'chat.designToolbox.prompt.referenceDesignFiles': 'ملفات التصميم المرجعية',
  'chat.designToolbox.prompt.mcpTemplateName': 'قالب {name}',
  'chat.designToolbox.prompt.processRule': 'قاعدة سير العمل: حدِّد الهدف الجمالي والقيود أولاً، ثم ابحث وطابِق الموارد؛ وعند الحاجة إلى اختيار المستخدم، أنشئ واجهة خيارات محدودة وتابِع بعد التأكيد.',
  'chat.designToolbox.prompt.moreSuffix': '، +{count} أخرى',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'أسطح الإشارة',
  'chat.mentionTabAll': 'الكل',
  'chat.mentionTabTabs': 'علامات التبويب',
  'chat.mentionTabPlugins': 'الإضافات',
  'chat.mentionTabSkills': 'المهارات',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'الموصِّلات',
  'chat.mentionTabFiles': 'ملفات التصميم',
  'chat.mentionNoResults': 'لا نتائج لـ “{query}”.',
  'chat.mentionSearchPrompt': 'ابحث في ملفات التصميم وعلامات التبويب والإضافات والمهارات وخوادم MCP والموصِّلات.',
  'chat.mentionSectionTabs': 'علامات التبويب',
  'chat.mentionSectionPlugins': 'الإضافات',
  'chat.mentionSectionSkills': 'المهارات',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'الموصِّلات',
  'chat.mentionSectionFiles': 'ملفات التصميم',
  'chat.mentionActiveSkill': 'نشط',
  'chat.mentionUseMcpTitle': 'استخدم {name}',
  'chat.mentionUseConnectorTitle': 'استخدم {name}',
  'chat.mentionPluginOfficial': 'رسمي',
  'chat.mentionPluginMine': 'إضافتي',
  'chat.linkedFolderRemoveAria': 'إزالة المجلد المرتبط {path}',
  'chat.linkedFolderNotFound': 'المجلد غير موجود',
  'chat.linkedFolderAlready': 'هذا المجلد مرتبط بالفعل',
  'chat.linkedFolderPickError': 'تعذر فتح منتقي المجلدات',
  'chat.queuedHeader': 'في قائمة الانتظار',
  'chat.queuedToSend': 'للإرسال',
  'chat.queuedEditQueuedTaskAria': 'تحرير المهمة في قائمة الانتظار',
  'chat.queuedSave': 'حفظ',
  'chat.queuedCancel': 'إلغاء',
  'chat.queuedReorder': 'اسحب لإعادة الترتيب',
  'chat.queuedEdit': 'تحرير',
  'chat.queuedMore': 'في قائمة الانتظار',
  'chat.queuedFollowUpFallback': 'متابعة في قائمة الانتظار',
  'chat.send': 'إرسال',
  'chat.stop': 'إيقاف',
  'chat.removeAria': 'إزالة {name}',
  'chat.example1Title': 'عرض تقديمي تحريري',
  'chat.example1Tag': 'مجلة',
  'chat.example1Prompt': 'عرض تقديمي تحريري من 10 شرائح لاستوديو تصميم يجمع تمويلاً - تخطيط شبكة سويسرية، عناوين عريضة مع أحرف استهلالية بارزة، أرقام أقسام أحادية المسافة، مساحات سلبية سخية، وشرائح صور بملء الشاشة تتخللها شرائح نصية مكثفة. الغلاف، الرؤية، السوق، المنتج، الزخم، الفريق، الطلب، الاتصال.',
  'chat.example2Title': 'لوحة تحكم تحليلات SaaS',
  'chat.example2Tag': 'بيانات',
  'chat.example2Prompt': 'لوحة تحكم تحليلات مكثفة لـ SaaS لأدوات المطورين - شريط KPI مع التغييرات الأسبوعية، مخططان خطيان متراكمان (MRR ومساحات العمل النشطة)، خريطة حرارية عالمية للاستخدام، شبكة احتفاظ بالمجموعات، لوحة صدارة لكبار العملاء، وخلاصة أحداث فورية. سمة داكنة، أرقام أحادية المسافة، تأثيرات sparkline.',
  'chat.example3Title': 'تقرير سنوي بالتمرير الطويل',
  'chat.example3Tag': 'تحريري',
  'chat.example3Prompt': 'تقرير سنوي تفاعلي لمنظمة مناخية غير ربحية - تخطيط تحريري بالتمرير الطويل يمزج بين كتل الاقتباسات الكبيرة، تصورات البيانات (أعمدة متراكمة، عدادات متحركة، خريطة لمواقع المشاريع)، فواصل صور، جدار المتبرعين، ودعوة نهائية للعمل. خط متن حديث، تسميات مخططات sans-serif، لوحة ألوان ورقية ترابية.',
  'preview.usePlugin': 'استخدام الإضافة',
  'preview.usePluginOnly': 'استخدام الإضافة فقط',
  'preview.usePluginOnlyDesc': 'استخدم بنية الإضافة واكتب المحتوى بنفسك',
  'preview.replicateContent': 'استنساخ هذا المحتوى',
  'preview.replicateContentDesc': 'استخدم المطالبة النموذجية لإعادة إنشاء المعاينة',
  'preview.shareMenu': 'مشاركة',
  'preview.exportMenu': 'تصدير',
  'preview.shareTemplateBadge': 'قالب',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'نسخ رابط القالب',
  'preview.copyShareText': 'نسخ نص المشاركة',
  'preview.shareSocialGroup': 'مشاركة على وسائل التواصل',
  'preview.shareCopyGroup': 'نسخ',
  'preview.shareExportGroup': 'تصدير الملفات',
  'preview.shareCopied': 'تم النسخ',
  'preview.shareCopyFailed': 'فشل النسخ',
  'preview.shareTextDefault': 'قالب Open Design: {title}',
  'preview.openInNewTab': 'فتح في علامة تبويب جديدة',
  'preview.exit': '⤓ خروج',
  'preview.fullscreen': '⤢ ملء الشاشة',
  'preview.closeTitle': 'إغلاق (Esc)',
  'preview.loading': 'جاري تحميل {label}...',
  'preview.errorTitle': 'تعذّر تحميل هذا المثال.',
  'preview.errorBody': 'فشل جلب HTML الخاص بالمثال. تأكد من تشغيل Open Design ثم أعد المحاولة.',
  'preview.retry': 'إعادة المحاولة',
  'preview.unavailableTitle': 'لا توجد معاينة مرفقة لـ{noun}.',
  'preview.unavailableBody': 'شغّل الأمر في المحادثة لإنشاء مخرجات {kind}.',
  'preview.nounSkill': 'هذه المهارة',
  'preview.nounPlugin': 'هذه الإضافة',
  'preview.nounTemplate': 'هذا القالب',
  'preview.showSidebar': 'إظهار {label}',
  'preview.hideSidebar': 'إخفاء {label}',
  'misc.savedTemplate': 'قالب محفوظ',
  'misc.primary': 'أساسي',
  'misc.designSystem': 'نظام تصميم',
  'workspace.designFiles': 'ملفات التصميم',
  'workspace.focusMode': 'التركيز على مساحة العمل',
  'workspace.showChat': 'إظهار المحادثة',
  'workspace.closeTab': 'إغلاق علامة التبويب',
  'workspace.deleteFileConfirm': 'حذف "{name}" من مجلد المشروع؟',
  'workspace.deleteSelectedFilesConfirm': 'حذف {n} ملف(ات) محددة من مجلد المشروع؟',
  'workspace.deleteSelectedFilesPartial': 'فشل حذف {n} ملف(ات).',
  'workspace.openFromDesignFiles': 'فتح ملف من',
  'workspace.designFilesLink': 'ملفات التصميم',
  'workspace.loadingSketch': 'جاري تحميل الرسم...',
  'workspace.newTab': 'علامة تبويب جديدة',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'علامات التبويب المفتوحة',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.terminalStarting': 'جارٍ بدء تشغيل الطرفية…',
  'workspace.terminalStartingDescription': 'يتم تجهيز صدفة المشروع. يستغرق ذلك عادة بضع ثوانٍ.',
  'workspace.terminalSessionEnded': 'انتهت الجلسة',
  'workspace.terminalReconnecting': 'جارٍ إعادة الاتصال…',
  'workspace.terminalStartFailed': 'تعذّر بدء جلسة الطرفية',
  'workspace.terminalRestart': 'إعادة التشغيل',
  'designFiles.title': 'ملفات التصميم',
  'designFiles.upload': 'رفع ملفات',
  'designFiles.pasteText': 'لصق كملف نصي',
  'designFiles.newSketch': 'رسم جديد',
  'designFiles.empty': 'ستظهر الإبداعات هنا',
  'designFiles.refresh': 'تحديث',
  'designFiles.delete': 'حذف',
  'designFiles.searchPlaceholder': 'بحث في الملفات...',
  'designFiles.up': 'للأعلى',
  'designFiles.back': 'رجوع',
  'designFiles.crumbs': 'مشروع',
  'designFiles.rowMenu': 'قائمة الصف',
  'designFiles.openInTab': 'فتح في علامة تبويب',
  'designFiles.download': 'تحميل',
  'designFiles.downloadSelected': 'تنزيل {n} كـ ZIP',
  'designFiles.deleteSelected': 'حذف {n}',
  'designFiles.clearSelection': 'مسح التحديد',
  'designFiles.selectPage': 'تحديد الكل في الصفحة',
  'designFiles.selectAll': 'تحديد الكل',
  'designFiles.dropTitle': '⤓ أسقط الملفات هنا',
  'designFiles.dropDesc': 'الصور، المستندات، المراجع، أو المجلدات - سيستخدمها الوكيل كسياق.',
  'designFiles.dropLabel': 'أفلت الملفات هنا',
  'designFiles.upload.title': 'رفع ملفات',
  'designFiles.paste.title': 'لصق نص كملف',
  'designFiles.upload.label': 'رفع',
  'designFiles.paste.label': 'لصق',
  'designFiles.previewOpen': 'فتح',
  'designFiles.previewClose': 'إغلاق المعاينة',
  'designFiles.modified': 'تم التعديل {time} · {size}',
  'designFiles.weeksAgo': 'منذ {n} أسبوع',
  'designFiles.groupBy': 'التجميع حسب',
  'designFiles.groupByKind': 'النوع',
  'designFiles.groupByModified': 'تاريخ التعديل',
  'designFiles.filterBy': 'تصفية حسب النوع',
  'designFiles.filterClear': 'مسح',
  'designFiles.filterCount': '{n} أنواع',
  'designFiles.expandGroup': 'توسيع',
  'designFiles.collapseGroup': 'طي',
  'designFiles.sectionPages': 'صفحات',
  'designFiles.sectionScripts': 'سكربتات',
  'designFiles.sectionImages': 'صور',
  'designFiles.sectionSketches': 'رسومات',
  'designFiles.sectionLiveArtifacts': 'عناصر حية',
  'designFiles.sectionOther': 'أخرى',
  'designFiles.modifiedToday': 'اليوم',
  'designFiles.modifiedYesterday': 'أمس',
  'designFiles.modifiedPrevious7Days': 'آخر 7 أيام',
  'designFiles.modifiedPrevious30Days': 'آخر 30 يومًا',
  'designFiles.modifiedOlder': 'أقدم',
  'designFiles.showMore': 'عرض +{n} أخرى',
  'designFiles.kindHtml': 'صفحة HTML',
  'designFiles.kindImage': 'صورة',
  'designFiles.kindSketch': 'رسم',
  'designFiles.kindText': 'نص',
  'designFiles.kindCode': 'سكربت',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'مستند',
  'designFiles.kindPresentation': 'عرض تقديمي',
  'designFiles.kindSpreadsheet': 'جدول بيانات',
  'designFiles.kindLiveArtifact': 'عنصر حي',
  'designFiles.kindBinary': 'ثنائي',
  'designFiles.kindFolder': 'مجلد',
  'designFiles.folderCount': '{n} ملفات',
  'designFiles.newFolderTitle': 'مجلد جديد',
  'designFiles.newFolderLabel': 'اسم المجلد',
  'designFiles.moveTitle': 'نقل إلى مجلد',
  'designFiles.moveLabel': 'المجلد الوجهة',
  'designFiles.moveRoot': 'جذر المشروع',
  'designFiles.moveNewFolder': 'مجلد جديد…',
  'designFiles.move': 'نقل',
  'designFiles.copyPath': 'نسخ المسار',
  'designFiles.copiedPath': 'تم نسخ المسار',
  'designFiles.deleteFolderConfirm': 'حذف المجلد "{name}" وكل محتوياته؟',
  'designFiles.folderCreated': 'تم إنشاء المجلد "{name}"',
  'designFiles.folderDeleted': 'تم حذف المجلد "{name}"',
  'designFiles.filesMoved': 'تم نقل {n} إلى {dest}',
  'designFiles.colName': 'الاسم',
  'designFiles.colKind': 'النوع',
  'designFiles.colModified': 'آخر تعديل',
  'designFiles.perPage': 'عرض',
  'designFiles.all': 'الكل',
  'designFiles.prev': 'السابق',
  'designFiles.next': 'التالي',
  'designFiles.jumpToPage': 'انتقل إلى الصفحة',
  'designFiles.pageInfo': '{start}–{end} من {total}',
  'designFiles.sectionFolders': 'المجلدات',
  'designFiles.sectionStylesheets': 'أوراق الأنماط',
  'designFiles.sectionDocuments': 'المستندات',
  'designFiles.kindStylesheet': 'ورقة أنماط',
  'designFiles.modifiedExt': 'عُدّل {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'معلومات مفيدة',
  'designFiles.usefulInfoTip': 'انقر نقرًا مزدوجًا على أي ملف لفتحه في علامة تبويب كاملة.',
  'designFiles.usefulInfoTip2': 'اكتب @ في المحادثة للإشارة إلى ملف كسياق.',
  'designFiles.usefulInfoTip4': 'اختر نظام تصميم لتحصل على نتائج متوافقة مع هوية علامتك.',
  'designFiles.usefulInfoTip5': 'لا توجد أفكار؟ جرّب قالب إضافة من قسم المجتمع في الصفحة الرئيسية.',
  'designFiles.usefulInfoTip6': 'لديك سؤال أو اقتراح؟ انضم إلينا على Discord.',
  'designFiles.usefulInfoTip7': 'أعجبك Open Design؟ امنحنا نجمة على GitHub.',
  'designFiles.usefulInfoTip8': 'تابع @nexudotio على X لمعرفة آخر المستجدات.',
  'designFiles.usefulInfoTip9': 'اسحب الصور أو المستندات أو مجلدات كاملة إلى هذه اللوحة — سيستخدمها الوكيل كسياق.',
  'designFiles.usefulInfoTip10': 'انقر على «رسم جديد» وارسم تخطيطًا تقريبيًا ليولّد الوكيل التصميم منه.',
  'designFiles.usefulInfoTip11': 'حدد أي عنصر في المعاينة للتعليق عليه — سيجري الوكيل تعديلات موجهة.',
  'designFiles.usefulInfoTip12': 'لم تعجبك النتيجة؟ تحديد العنصر أسرع من إعادة الوصف.',
  'designFiles.usefulInfoTip13': 'صدّر أي تصميم كملف PDF أو صورة أو HTML مستقل بنقرة واحدة.',
  'designFiles.usefulInfoTip14': 'أعجبك مشروع؟ احفظه كقالب من قائمة المشاركة لإعادة استخدامه.',
  'designFiles.usefulInfoTip15': 'بعد النشر، أنشئ بطاقات مشاركة اجتماعية مباشرة.',
  'quickSwitcher.placeholder': 'فتح ملف…',
  'quickSwitcher.empty': 'لا توجد ملفات في هذا المشروع',
  'quickSwitcher.noMatches': 'لا توجد نتائج',
  'quickSwitcher.navigate': 'تنقل',
  'quickSwitcher.open': 'فتح',
  'quickSwitcher.close': 'إغلاق',
  'pasteDialog.title': 'لصق نص',
  'pasteDialog.hint': 'يحفظ في مجلد المشروع. اختر أي اسم.',
  'pasteDialog.fileNameLabel': 'اسم الملف',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'المحتوى',
  'pasteDialog.contentPlaceholder': 'الصق أي شيء...',
  'pasteDialog.save': 'حفظ',
  'pasteDialog.cancel': 'إلغاء',
  'sketch.save': 'حفظ الرسم',
  'sketch.cancel': 'إلغاء',
  'sketch.saving': 'جاري الحفظ...',
  'sketch.saved': 'تم الحفظ',
  'sketch.tooltipDirty': 'تغييرات غير محفوظة',
  'sketch.tooltipClean': 'تم الحفظ',
  'fileViewer.empty': 'اختر ملفاً لعرضه.',
  'fileViewer.loading': 'جاري التحميل...',
  'fileViewer.exportPptx': 'تصدير كـ PPTX',
  'fileViewer.openInNewTab': 'فتح في علامة تبويب جديدة',
  'fileViewer.copyPath': 'نسخ المسار',
  'fileViewer.copied': 'تم النسخ!',
  'fileViewer.share': 'مشاركة',
  'fileViewer.binaryMeta': 'ثنائي · {size}',
  'fileViewer.binaryNote': 'ملف ثنائي ({size} بايت). حمله أو افتحه من القرص لفحصه.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'مستند',
  'fileViewer.presentationMeta': 'عرض تقديمي',
  'fileViewer.spreadsheetMeta': 'جدول بيانات',
  'fileViewer.previewUnavailable': 'المعاينة غير متوفرة. حمل الملف أو افتحه لفحصه.',
  'fileViewer.download': 'تحميل',
  'fileViewer.open': 'فتح',
  'fileViewer.imageMeta': 'صورة · {size}',
  'fileViewer.reactMeta': 'مكون React · {size}',
  'fileViewer.sketchMeta': 'رسم · {size}',
  'fileViewer.markdownStreamingMeta': 'معاينة متدفقة...',
  'fileViewer.markdownErrorMeta': 'قد تكون المعاينة غير مكتملة (خطأ في التوليد).',
  'fileViewer.markdownStreamingStatus': 'تدفق... عرض ماركداون جزئي.',
  'fileViewer.markdownErrorStatus': 'خطأ في التوليد. عرض آخر محتوى متوفر.',
  'fileViewer.videoMeta': 'فيديو · {size}',
  'fileViewer.audioMeta': 'صوت · {size}',
  'fileViewer.reload': 'إعادة تحميل',
  'fileViewer.reloadDisk': 'إعادة تحميل من القرص',
  'fileViewer.copy': 'نسخ',
  'fileViewer.copyTitle': 'نسخ محتويات الملف',
  'fileViewer.saveDisabled': 'حفظ (عارض للقراءة فقط)',
  'fileViewer.save': 'حفظ',
  'fileViewer.preview': 'معاينة',
  'fileViewer.source': 'المصدر',
  'fileViewer.tweaks': 'تعديلات',
  'fileViewer.tweaksUnavailable': 'لا توجد لوحة تعديلات في هذا العمل',
  'fileViewer.jsxModuleTitle': 'لا توجد معاينة مستقلة',
  'fileViewer.jsxModuleBody': 'هذا الملف وحدة مكوّن يتم تحميلها بواسطة صفحة أخرى.',
  'fileViewer.jsxModuleCta': 'افتح الصفحة التي تعرضه:',
  'fileViewer.comment': 'تعليق',
  'fileViewer.edit': 'تعديل',
  'fileViewer.draw': 'رسم',
  'fileViewer.mark': 'تحديد',
  'fileViewer.markTool': 'أداة التحديد',
  'fileViewer.boxSelect': 'تحديد بمربع',
  'fileViewer.screenshot': 'لقطة شاشة',
  'manualEdit.layers': 'الطبقات',
  'manualEdit.editableCount': '{count} قابلة للتحرير',
  'manualEdit.hiddenBadge': 'مخفية',
  'manualEdit.title': 'المحرر اليدوي',
  'manualEdit.fallbackTitle': 'تحرير',
  'manualEdit.movePanel': 'نقل لوحة التحرير',
  'manualEdit.editParams': 'تعديل المعلمات',
  'manualEdit.closePanel': 'إغلاق لوحة التحرير',
  'manualEdit.selectLayer': 'اختر طبقة',
  'manualEdit.empty': 'انقر على عنصر في المعاينة أو اختر طبقة.',
  'manualEdit.noEditableLayers': 'لم يتم العثور على طبقات قابلة للتحرير.',
  'manualEdit.noClass': 'بدون فئة',
  'manualEdit.tabsAria': 'علامات تبويب التحرير اليدوي',
  'manualEdit.tabContent': 'المحتوى',
  'manualEdit.tabStyle': 'النمط',
  'manualEdit.tabAttributes': 'السمات',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'المصدر',
  'manualEdit.attributesJson': 'السمات بصيغة JSON',
  'manualEdit.selectedHtml': 'HTML للعنصر المحدد',
  'manualEdit.fullSource': 'المصدر الكامل للعنصر',
  'manualEdit.applyContent': 'تطبيق المحتوى',
  'manualEdit.applyStyle': 'تطبيق النمط',
  'manualEdit.applyAttributes': 'تطبيق السمات',
  'manualEdit.applyHtml': 'تطبيق HTML',
  'manualEdit.applySource': 'تطبيق المصدر',
  'manualEdit.invalidAttributes': 'السمات بصيغة JSON غير صالحة.',
  'manualEdit.changes': 'التغييرات',
  'manualEdit.undo': 'تراجع',
  'manualEdit.redo': 'إعادة',
  'manualEdit.noChanges': 'لا توجد تعديلات يدوية بعد.',
  'manualEdit.imageUrl': 'عنوان URL للصورة',
  'manualEdit.altText': 'النص البديل',
  'manualEdit.label': 'التسمية',
  'manualEdit.text': 'النص',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'لون النص',
  'manualEdit.background': 'الخلفية',
  'manualEdit.fontSize': 'حجم الخط',
  'manualEdit.weight': 'السماكة',
  'manualEdit.align': 'المحاذاة',
  'manualEdit.padding': 'التباعد الداخلي',
  'manualEdit.margin': 'الهامش',
  'manualEdit.radius': 'نصف القطر',
  'manualEdit.border': 'الحدود',
  'manualEdit.width': 'العرض',
  'manualEdit.minHeight': 'أدنى ارتفاع',
  'manualEdit.deleteElement': 'حذف العنصر',
  'manualEdit.deleteElementConfirm': 'حذف العنصر المحدد؟ يمكن التراجع عن ذلك باستخدام تراجع.',
  'manualEdit.uploadImage': 'رفع صورة',
  'manualEdit.uploadingImage': 'جارٍ رفع الصورة…',
  'manualEdit.uploadImageFailed': 'تعذّر رفع الصورة.',
  'manualEdit.focusSlides': 'التركيز على الشرائح',
  'manualEdit.showPanels': 'إظهار اللوحات',
  'fileViewer.zoomOut': 'تصغير',
  'fileViewer.zoomIn': 'تكبير',
  'fileViewer.resetZoom': 'إعادة تعيين الزوم',
  'fileViewer.viewportAria': 'منفذ عرض المعاينة',
  'fileViewer.viewportDesktop': 'سطح المكتب',
  'fileViewer.viewportDesktopTitle': 'معاينة سطح المكتب بعرض كامل',
  'fileViewer.viewportTablet': 'الجهاز اللوحي',
  'fileViewer.viewportTabletTitle': 'معاينة الجهاز اللوحي بأبعاد 820 × 1180 (الأساس العمودي الحديث)',
  'fileViewer.viewportMobile': 'الجوال',
  'fileViewer.viewportMobileTitle': 'معاينة الجوال بأبعاد 390 × 844',
  'fileViewer.reloadAria': 'إعادة تحميل',
  'fileViewer.previousSlide': 'الشريحة السابقة',
  'fileViewer.nextSlide': 'الشريحة التالية',
  'fileViewer.slideNavAria': 'التنقل بين الشرائح',
  'fileViewer.present': 'تقديم',
  'fileViewer.presentInTab': 'في علامة التبويب هذه',
  'fileViewer.presentFullscreen': 'ملء الشاشة',
  'fileViewer.presentNewTab': 'علامة تبويب جديدة',
  'fileViewer.exitPresentation': 'الخروج من العرض',
  'fileViewer.shareLabel': 'مشاركة',
  'fileViewer.shareMenuShareLink': 'مشاركة',
  'fileViewer.shareMenuPublishOnline': 'النشر على الإنترنت',
  'fileViewer.shareMenuDownload': 'تنزيل',
  'fileViewer.shareMenuPresentation': 'عرض تقديمي',
  'fileViewer.shareMenuSourceFiles': 'ملفات المصدر',
  'fileViewer.shareMenuSave': 'حفظ',
  'fileViewer.copyShareLink': 'نسخ رابط المشاركة',
  'fileViewer.openSharePage': 'فتح صفحة المشاركة',
  'fileViewer.shareLinkRequiresDeploy': 'انشر على الإنترنت أولاً للحصول على رابط',
  'fileViewer.shareLinkPublishGuide': 'انشر على الإنترنت أعلاه لتفعيل المشاركة ↑',
  'fileViewer.shareAfterGenerationComplete': 'يمكن المشاركة بعد اكتمال الإنشاء',
  'fileViewer.copyProviderLink': 'نسخ رابط {provider}',
  'fileViewer.copyCloudflareLink': 'نسخ رابط Cloudflare',
  'fileViewer.screenshotCopying': 'جارٍ نسخ لقطة الشاشة...',
  'fileViewer.screenshotCopied': 'تم نسخ لقطة الشاشة إلى الحافظة',
  'fileViewer.screenshotClipboardDenied': 'حظر المتصفح الوصول إلى الحافظة',
  'fileViewer.screenshotPreviewLoading': 'لا تزال المعاينة قيد التحميل. حاول مجددًا بعد لحظة.',
  'fileViewer.screenshotCaptureFailed': 'تعذّر التقاط المعاينة. يُرجى المحاولة مرة أخرى.',
  'fileViewer.exportPdf': 'تصدير كـ PDF',
  'fileViewer.exportPdfAllSlides': 'تصدير كـ PDF (كل الشرائح)',
  'fileViewer.exportPptxBusy': 'انتظر انتهاء الدور الحالي.',
  'fileViewer.exportPptxHint': 'أرسل طلباً للوكيل لتحويل هذا التصميم إلى PPTX.',
  'fileViewer.exportPptxNa': 'تصدير PPTX غير متوفر هنا.',
  'fileViewer.exportZip': 'تحميل كـ zip.',
  'fileViewer.exportHtml': 'تصدير كـ HTML مستقل',
  'fileViewer.exportMd': 'تصدير كـ Markdown',
  'fileViewer.exportImage': 'تصدير كصورة',
  'fileViewer.exportImageFailed': 'فشل التقاط الصورة. يرجى المحاولة مرة أخرى أو استخدام أداة لقطة الشاشة في المتصفح.',
  'fileViewer.exportImageModalSubtitle': 'اختر تنسيقًا، ثم نزّل المعاينة الحالية كصورة.',
  'fileViewer.exportImageFormatLabel': 'التنسيق',
  'fileViewer.exportImageSaving': 'جارٍ حفظ الصورة…',
  'fileViewer.exportImageSaved': 'تم حفظ الصورة',
  'fileViewer.exportImageDownloadStarted': 'بدأ التنزيل',
  'fileViewer.exportImageDownloadDetails': 'إذا لم تظهر نافذة حفظ باسم، فابحث عن {filename} في مجلد تنزيلات المتصفح.',
  'fileViewer.exportJsx': 'تصدير كـ JSX',
  'fileViewer.exportReactHtml': 'تصدير المعاينة كـ HTML',
  'fileViewer.exportStarted': 'بدأ التصدير',
  'fileViewer.saveAsTemplate': 'حفظ كقالب...',
  'fileViewer.savingTemplate': 'جاري حفظ القالب...',
  'fileViewer.savedTemplate': 'تم الحفظ باسم "{name}"',
  'fileViewer.savedTemplateFail': 'تعذر حفظ القالب - حاول مرة أخرى.',
  'fileViewer.templateNamePrompt': 'اسم القالب',
  'fileViewer.templateNameDefault': 'قالب بدون عنوان',
  'fileViewer.templateDescPrompt': 'وصف قصير (اختياري - ما الذي يجعل هذا القالب مفيداً؟)',
  'liveArtifact.refresh.button': 'تحديث',
  'liveArtifact.refresh.buttonTitle': 'تحديث هذا العنصر المباشر',
  'liveArtifact.refresh.loadingTitle': 'جارٍ تحميل المُخرَج الحي…',
  'liveArtifact.refresh.noSourceTitle': 'لا يتوفر مصدر تحديث بعد.',
  'liveArtifact.refresh.running': 'جارٍ التحديث…',
  'liveArtifact.refresh.runningMessage': 'جارٍ تحديث البيانات والمعاينة. قد يستغرق ذلك لحظة.',
  'liveArtifact.refresh.runningAction': 'تبقى المعاينة السابقة ظاهرة حتى ينجح التحديث.',
  'liveArtifact.refresh.successOne': 'اكتمل التحديث. تم تحديث البيانات.',
  'liveArtifact.refresh.successMany': 'اكتمل التحديث. تم تحديث البيانات.',
  'liveArtifact.refresh.successAction': 'تمت إعادة تحميل المعاينة بأحدث البيانات المُلتزَم بها.',
  'liveArtifact.refresh.previousFailure': 'فشل التحديث السابق: {message}',
  'liveArtifact.refresh.failureAction': 'راجع سجل التحديثات، وأصلح مشكلة المصدر أو الأذونات، ثم حاول مرة أخرى.',
  'liveArtifact.refresh.networkFailure': 'فشل طلب التحديث. تحقق من اتصالك وحاول مرة أخرى.',
  'liveArtifact.refresh.genericFailure': 'فشل التحديث.',
  'liveArtifact.refresh.statusNever': 'غير قابل للتحديث',
  'liveArtifact.refresh.statusReady': 'جاهز للتحديث',
  'liveArtifact.refresh.statusSucceeded': 'محدَّث',
  'liveArtifact.refresh.statusFailed': 'فشل التحديث',
  'liveArtifact.refresh.statusRunning': 'جارٍ التحديث',
  'liveArtifact.refresh.statusRunningDescription': 'تجري حاليًا عملية تحديث.',
  'liveArtifact.refresh.statusSucceededDescription': 'اكتمل آخر تحديث بنجاح.',
  'liveArtifact.refresh.statusFailedDescription': 'لم تكتمل محاولة التحديث الأخيرة بنجاح.',
  'liveArtifact.refresh.statusReadyDescription': 'المصادر القابلة للتحديث مُهيّأة لكن لا توجد عملية قيد التشغيل.',
  'liveArtifact.refresh.statusNeverDescription': 'لا يحتوي هذا العنصر المباشر على مصدر تحديث بعد.',
  'liveArtifact.refresh.eventStarted': 'بدأ',
  'liveArtifact.refresh.eventSucceeded': 'نجح',
  'liveArtifact.refresh.eventFailed': 'فشل',
  'liveArtifact.refresh.eventStartedDetail': 'بدأ التحديث…',
  'liveArtifact.refresh.sourcesUpdatedOne': 'تم تحديث {n} مصدر',
  'liveArtifact.refresh.sourcesUpdatedMany': 'تم تحديث {n} مصادر',
  'liveArtifact.refresh.timelineEmpty': 'لا يوجد نشاط تحديث بعد في هذه الجلسة. شغّل التحديث لتسجيل مخطط زمني، أو انتظر عمليات التشغيل التلقائية.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'آخر تحديث',
  'liveArtifact.refresh.heroLastRefreshedNever': 'مطلقًا',
  'liveArtifact.refresh.justNow': 'الآن',
  'liveArtifact.refresh.factCreated': 'تم الإنشاء',
  'liveArtifact.refresh.factLastUpdated': 'آخر تحديث',
  'liveArtifact.refresh.factUnknown': 'غير معروف',
  'liveArtifact.refresh.persistedTitle': 'سجل التحديثات المحفوظ',
  'liveArtifact.refresh.persistedHint': 'الإدخالات المُحمَّلة من refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'لا يوجد سجل تحديثات محفوظ بعد.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'نجح',
  'liveArtifact.refresh.persistedStatusRunning': 'قيد التشغيل',
  'liveArtifact.refresh.persistedStatusFailed': 'فشل',
  'liveArtifact.refresh.persistedStatusCancelled': 'أُلغي',
  'liveArtifact.refresh.persistedStatusSkipped': 'تم التخطي',
  'liveArtifact.refresh.sessionTitle': 'نشاط الجلسة',
  'liveArtifact.refresh.sessionHint': 'الأحداث المُلاحَظة أثناء فتح هذا التبويب',
  'liveArtifact.refresh.docSourceTitle': 'مصدر المستند',
  'liveArtifact.refresh.docSourceHint': 'تم تهيئة المصدر',
  'liveArtifact.refresh.docSourceType': 'النوع',
  'liveArtifact.refresh.docSourceTool': 'الأداة',
  'liveArtifact.refresh.docSourceConnector': 'موصِّل',
  'liveArtifact.refresh.debugSummary': 'بيانات تصحيح متقدمة',
  'liveArtifact.refresh.debugNote': 'قد تتضمن معرّفات الموصِّلات وأسماء الملفات وبيانات المصدر الوصفية ومسارات العناصر الداخلية.',
  'liveArtifact.viewer.tabPreview': 'معاينة',
  'liveArtifact.viewer.tabCode': 'الكود',
  'liveArtifact.viewer.tabData': 'البيانات',
  'liveArtifact.viewer.tabRefreshHistory': 'سجل التحديث',
  'liveArtifact.viewer.dataEmpty': 'لا توجد ذاكرة data.json مؤقتة متاحة.',
  'liveArtifact.viewer.code.templateHeading': 'HTML القالب',
  'liveArtifact.viewer.code.renderedHeading': 'HTML المعروض',
  'liveArtifact.viewer.code.templateHelp': 'القالب القابل للتحرير المستخدم مع data.json لإنشاء المعاينة.',
  'liveArtifact.viewer.code.renderedHelp': 'ملف index.html المُنشأ الذي تحمّله المعاينة حاليًا.',
  'liveArtifact.viewer.code.variantAria': 'متغير الكود',
  'liveArtifact.viewer.code.variantTemplate': 'القالب',
  'liveArtifact.viewer.code.variantRendered': 'معروض',
  'liveArtifact.viewer.code.loading': 'جارٍ تحميل الكود…',
  'liveArtifact.viewer.code.unavailable': 'الكود غير متاح بعد.',
  'liveArtifact.viewer.code.empty': 'ملف الكود هذا فارغ.',
  'fileViewer.deployToVercel': 'النشر إلى Vercel',
  'fileViewer.redeployToVercel': 'إعادة النشر',
  'fileViewer.deployingToVercel': 'جارٍ النشر إلى Vercel…',
  'fileViewer.deployProviderLabel': 'منصة النشر',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'النشر إلى {provider}',
  'fileViewer.redeployToProvider': 'إعادة النشر إلى {provider}',
  'fileViewer.deployingToProvider': 'جارٍ النشر إلى {provider}…',
  'fileViewer.preparingPublicLink': 'جاري تحضير الرابط العام...',
  'fileViewer.copyDeployLink': 'نسخ الرابط',
  'fileViewer.deployModalTitle': 'النشر',
  'fileViewer.deployModalSubtitle': 'استخدم حساب منصة النشر المحددة لنشر معاينة HTML هذه.',
  'fileViewer.vercelToken': 'رمز Vercel',
  'fileViewer.vercelTokenGetLink': 'احصل على رمز Vercel',
  'fileViewer.vercelTokenPlaceholder': 'الصق رمز Vercel الخاص بك',
  'fileViewer.vercelTokenReuseHint': 'سيتم استخدام الرمز المحفوظ. أدخل رمزاً جديداً لاستبداله.',
  'fileViewer.vercelTokenRequired': 'أدخل واحفظ رمز Vercel أولاً.',
  'fileViewer.cloudflareApiToken': 'رمز Cloudflare API',
  'fileViewer.cloudflareApiTokenGetLink': 'الحصول على رمز API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'الصق رمز Cloudflare API الخاص بك',
  'fileViewer.cloudflareApiTokenReuseHint': 'سيتم استخدام رمز Cloudflare API المحفوظ. أدخل رمزاً جديداً لاستبداله.',
  'fileViewer.cloudflareApiTokenRequired': 'أدخل واحفظ رمز Cloudflare API أولاً.',
  'fileViewer.cloudflareApiTokenScopeHint': 'اختر Pages Edit عند إنشاء رمز API؛ تحتاج النطاقات المخصصة إلى Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'معرف الفريق',
  'fileViewer.vercelTeamSlug': 'اسم الفريق اللطيف',
  'fileViewer.cloudflareAccountId': 'معرف الحساب',
  'fileViewer.cloudflareAccountIdHint': 'اعثر على معرف الحساب في لوحة Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'أدخل واحفظ Cloudflare Account ID أولاً.',
  'fileViewer.cloudflareZoneLabel': 'النطاق',
  'fileViewer.cloudflareZonePlaceholder': 'احفظ إعدادات Cloudflare لتحميل النطاقات',
  'fileViewer.cloudflareZoneRequired': 'اختر نطاق Cloudflare أولًا.',
  'fileViewer.cloudflareZonesLoading': 'جارٍ تحميل نطاقات Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'تحديث النطاقات',
  'fileViewer.cloudflareZonesLoadFailed': 'تعذّر تحميل نطاقات Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'لم يتم العثور على نطاقات Cloudflare كاملة نشطة لهذا الحساب.',
  'fileViewer.cloudflareDomainPrefixLabel': 'بادئة النطاق الفرعي',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'استخدم تسمية DNS واحدة فقط: أحرف صغيرة وأرقام وشرطات.',
  'fileViewer.cloudflareHostnamePreview': 'معاينة النطاق المخصص: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'اختياري: اربط نطاقاً مخصصاً. تركه فارغاً سيظل ينشئ رابط pages.dev.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'عنوان pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'نطاق مخصص',
  'fileViewer.optional': 'اختياري',
  'fileViewer.vercelPreviewOnly': 'النشر للمعاينة فقط حالياً.',
  'fileViewer.cloudflarePagesPreviewHint': 'تستخدم Cloudflare Pages أسلوب Direct Upload.',
  'fileViewer.savingConfig': 'جاري الحفظ...',
  'fileViewer.deployConfigSaveFailed': 'تعذر حفظ إعدادات Vercel.',
  'fileViewer.deployFailed': 'فشل النشر. تحقق من إعدادات Vercel وحاول مرة أخرى.',
  'fileViewer.deployProviderConfigSaveFailed': 'تعذر حفظ إعدادات {provider}.',
  'fileViewer.deployProviderFailed': 'فشل النشر إلى {provider}. تحقق من الإعدادات وحاول مرة أخرى.',
  'fileViewer.deployResultLabel': 'رابط النشر',
  'fileViewer.deployLinkReady': 'جاهز',
  'fileViewer.deploySuccessToast': 'تم رفع النشر بنجاح',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'الرابط العام معلق',
  'fileViewer.deployLinkDelayed': 'تم نشر الموقع، لكن الرابط العام ما زال قيد التحضير.',
  'fileViewer.deployLinkFailed': 'فشل النطاق المخصص',
  'fileViewer.deployLinkProtectedLabel': 'حماية النشر مفعلة',
  'fileViewer.deployLinkProtected': 'تم نشر الموقع، لكن رابط المعاينة هذا يتطلب المصادقة. عطّل Deployment Protection أو استخدم نطاقاً مخصصاً.',
  'fileViewer.retryLink': 'إعادة المحاولة الآن',
  'questionForm.submit': 'إرسال',
  'questionForm.skip': 'تخطي',
  'questionForm.locked': 'تمت الإجابة',
  'conv.switch': 'تبديل المحادثة',
  'conv.label': 'المحادثة',
  'conv.heading': 'المحادثات',
  'conv.new': '+ جديد',
  'conv.empty': 'لا توجد محادثات بعد.',
  'conv.untitled': 'محادثة بدون عنوان',
  'conv.renameTooltip': 'انقر مرتين لإعادة التسمية',
  'conv.delete': 'حذف المحادثة',
  'conv.deleteConfirm': 'هل تريد حذف "{title}"؟ سيؤدي هذا لإزالة رسائلها.',
  'agentPicker.label': 'الوكيل',
  'agentPicker.modeChoose': 'اختر وضع التنفيذ',
  'agentPicker.localCli': 'CLI محلي',
  'agentPicker.daemonOff': 'البرنامج الخفي متوقف',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'اختر وكيل كود مكتشف',
  'agentPicker.noAgents': 'لا يوجد وكلاء في PATH',
  'agentPicker.notInstalled': 'غير مثبت',
  'agentPicker.rescan': 'إعادة مسح PATH المحلي للوكلاء',
  'tool.openInTab': 'فتح {name} في علامة تبويب',
  'tool.open': 'فتح',
  'tool.todos': 'المهام',
  'tool.todosExpand': 'عرض المهام',
  'tool.todosCollapse': 'إخفاء المهام',
  'tool.todosDone': 'تم',
  'tool.todosDismiss': 'إغلاق قائمة المهام',
  'tool.write': 'كتابة',
  'tool.edit': 'تعديل',
  'tool.read': 'قراءة',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'جلب',
  'tool.search': 'بحث',
  'tool.lines': '{n} أسطر',
  'tool.changeSingular': 'تغيير',
  'tool.changePlural': 'تغييرات',
  'tool.in': 'في {path}',
  'tool.hide': 'إخفاء',
  'tool.output': 'المخرجات',
  'tool.running': 'جاري التشغيل...',
  'tool.error': 'خطأ',
  'tool.done': 'تم',
  'assistant.role': 'المساعد',
  'assistant.workingLabel': 'جاري العمل',
  'assistant.doneLabel': 'تم',
  'assistant.copyMarkdown': 'نسخ Markdown الرد',
  'assistant.forkConversation': 'تفرع من هنا',
  'assistant.forkingConversation': 'جارٍ التفرع…',
  'assistant.shareToOpenDesign': 'المشاركة على Open Design',
  'assistant.shareToOpenDesignBusy': 'جارٍ تجهيز الحزمة…',
  'assistant.feedbackPrompt': 'ملاحظات',
  'assistant.feedbackPositive': 'مفيد',
  'assistant.feedbackNegative': 'غير مفيد',
  'assistant.feedbackReasonTitle': 'أخبرنا بالسبب',
  'assistant.feedbackReasonPositiveMatched': 'فهم طلبي',
  'assistant.feedbackReasonPositiveVisual': 'يبدو جيدًا',
  'assistant.feedbackReasonPositiveUseful': 'بنية مفيدة',
  'assistant.feedbackReasonPositiveEasy': 'سهل المتابعة في التحرير',
  'assistant.feedbackReasonPositiveDesignSystem': 'اتّبع نظام التصميم',
  'assistant.feedbackReasonNegativeMissed': 'أغفل طلبي',
  'assistant.feedbackReasonNegativeVisual': 'الجودة البصرية تحتاج إلى تحسين',
  'assistant.feedbackReasonNegativeIncomplete': 'مخرجات غير مكتملة',
  'assistant.feedbackReasonNegativeHard': 'صعب الاستخدام',
  'assistant.feedbackReasonNegativeDesignSystem': 'لم يتّبع نظام التصميم',
  'assistant.feedbackReasonOther': 'أخرى',
  'assistant.feedbackReasonPlaceholder': 'أضف ملاحظة قصيرة...',
  'assistant.feedbackReasonSubmit': 'إرسال',
  'assistant.emptyResponseLabel': 'لا توجد مخرجات',
  'assistant.emptyResponseMessage': 'أنهى المزوّد الطلب دون إرجاع نص أو عنصر. جرّب نموذجًا أو مزوّدًا آخر، أو تحقّق من الحصة، أو أعد المحاولة.',
  'assistant.unfinishedLabel': 'توقف مع عمل غير مكتمل',
  'assistant.unfinishedSummary': 'تبقى {n} مهمة/مهام',
  'assistant.unfinishedMore': '+{n} أكثر',
  'assistant.continueRemaining': 'متابعة المهام المتبقية',
  'chat.resumeRunCta': 'متابعة التشغيل',
  'assistant.outTokens': '{n} خرج',
  'assistant.producedFiles': 'الملفات من هذا الدور',
  'assistant.openFile': 'فتح',
  'assistant.downloadFile': 'تحميل',
  'nextStep.title': 'الخطوة التالية',
  'nextStep.more': 'المزيد',
  'nextStep.share': 'مشاركة',
  'nextStep.download': 'تنزيل',
  'nextStep.contribute': 'المساهمة',
  'assistant.thinking': 'تفكير',
  'assistant.thought': 'فكّر',
  'assistant.thoughtFor': 'فكّر لمدة {s} ث',
  'assistant.systemReminder': 'تذكير النظام',
  'assistant.possiblePromptInjection': 'احتمال حقن التوجيه',
  'assistant.waitingFirstOutput': 'في انتظار أول مخرج',
  'assistant.statusBootingAgent': 'تشغيل الوكيل',
  'assistant.statusPreparing': 'جارٍ التحضير...',
  'assistant.statusStarting': 'بدء',
  'assistant.statusRequesting': 'إرسال الطلب',
  'assistant.statusThinking': 'تفكير',
  'assistant.statusStreaming': 'تدفق',
  'assistant.slowHint': 'يستغرق وقتاً أطول من المعتاد. يظهر النموذج عادة في 5-10 ثوانٍ - يمكنك التوقف وإعادة الصياغة.',
  'assistant.verbEditing': 'تعديل',
  'assistant.verbWriting': 'كتابة',
  'assistant.verbReading': 'قراءة',
  'assistant.verbSearching': 'بحث',
  'assistant.verbRunning': 'تشغيل',
  'assistant.verbTodos': 'مهام',
  'assistant.verbFetching': 'جلب',
  'assistant.verbCalling': 'اتصال',
  'qf.answered': 'تمت الإجابة',
  'qf.choose': 'اختر...',
  'qf.required': 'مطلوب',
  'qf.lockedSubmitted': 'تم إرسال الإجابات - يستخدمها الوكيل لبقية الجلسة.',
  'qf.lockedPrev': 'هذا النموذج من دور سابق.',
  'qf.hint': 'اختر ما يناسبك. تخطى الحقول الاختيارية التي لا تهمك - سيستخدم الوكيل افتراضات معقولة.',
  'qf.submitDefault': 'إرسال الإجابات',
  'qf.submitDisabledTitle': 'املأ الحقول المطلوبة أولاً',
  'qf.submitTitle': 'إرسال الإجابات',
  'qf.cardSelected': 'محدد',
  'qf.cardRefs': 'المراجع:',
  'qf.cardSampleText': 'الثعلب البني السريع · 0123',
  'questions.tabLabel': 'أسئلة',
  'questions.banner': 'هل تمانع أن أطرح عليك بضعة أسئلة سريعة؟',
  'questions.bannerAnswered': 'تمت الإجابة عن الأسئلة',
  'questions.continue': 'متابعة',
  'questions.generating': 'جارٍ إنشاء الأسئلة…',
  'questions.skipAll': 'تخطّي الكل',
  'questions.autoSkipHint': 'يتابع تلقائيًا عند انتهاء المؤقّت',
  'sketch.toolSelect': 'تحديد (لا إجراء)',
  'sketch.toolPen': 'قلم',
  'sketch.toolText': 'نص',
  'sketch.toolRect': 'مستطيل',
  'sketch.toolArrow': 'سهم',
  'sketch.toolEraser': 'ممحاة',
  'sketch.color': 'اللون',
  'sketch.strokeSize': 'حجم الخط',
  'sketch.undo': 'تراجع',
  'sketch.clear': 'مسح',
  'sketch.close': 'إغلاق',
  'sketch.closeConfirm': 'إغلاق الرسم وتجاهل التغييرات غير المحفوظة؟',
  'sketch.textPrompt': 'النص:',
  'sketch.textModalTitle': 'إضافة نص',
  'critiqueTheater.userFacingName': 'لجنة تحكيم التصميم',
  'critiqueTheater.roleDesigner': 'المصمّم',
  'critiqueTheater.roleCritic': 'الناقد',
  'critiqueTheater.roleBrand': 'العلامة التجارية',
  'critiqueTheater.roleA11y': 'إمكانية الوصول',
  'critiqueTheater.roleCopy': 'النص',
  'critiqueTheater.roundLabel': 'الجولة {n} من {m}',
  'critiqueTheater.mustFix': '{n} يجب إصلاحها',
  'critiqueTheater.composite': 'مركّب',
  'critiqueTheater.threshold': 'العتبة',
  'critiqueTheater.consensus': 'الإجماع',
  'critiqueTheater.interrupt': 'مقاطعة',
  'critiqueTheater.interrupting': 'جارٍ المقاطعة…',
  'critiqueTheater.interrupted': 'تمّت المقاطعة',
  'critiqueTheater.degradedHeading': 'اللجنة غير متصلة في هذه الجلسة',
  'critiqueTheater.degradedReasonMalformed': 'مخرجات اللجنة غير صحيحة (رفض المحلّل الكتلة).',
  'critiqueTheater.degradedReasonOversize': 'تجاوزت مخرجات اللجنة الحدّ الآمن من البايتات.',
  'critiqueTheater.degradedReasonAdapter': 'المحوّل {adapter} لا يدعم بروتوكول Critique.',
  'critiqueTheater.degradedReasonProtocol': 'أرسل المحوّل {adapter} إصدار بروتوكول غير مدعوم.',
  'critiqueTheater.degradedReasonMissingArtifact': 'انتهت الجلسة دون عنصر نهائي.',
  'critiqueTheater.replay': 'إعادة التشغيل',
  'critiqueTheater.replaySpeed': 'سرعة إعادة التشغيل',
  'critiqueTheater.readOnly': 'للقراءة فقط',
  'critiqueTheater.shippedSummary': 'تم الإطلاق في الجولة {round} · النتيجة المركبة {composite}',
  'critiqueTheater.interruptedSummary': 'تمت المقاطعة في الجولة {round} · أفضل نتيجة مركبة {composite}',
  'critiqueTheater.shippedBadge': 'تم الإطلاق',
  'critiqueTheater.belowThresholdBadge': 'دون العتبة',
  'critiqueTheater.timedOutBadge': 'انتهت المهلة',
  'critiqueTheater.failedHeading': 'فشلت الجلسة',
  'critiqueTheater.failedReasonCliExit': 'خرج Agent CLI برمز غير صفري قبل أن تتمكّن اللجنة من الإنهاء.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'تجاوزت إحدى الجولات حدّها الزمني.',
  'critiqueTheater.failedReasonTotalTimeout': 'تجاوزت الجلسة الكاملة إجمالي حدّها الزمني.',
  'critiqueTheater.failedReasonOrchestrator': 'خطأ داخلي في المنسّق.',
  'critiqueTheater.transcriptEmpty': 'لا يوجد نص محادثة لإعادة تشغيله بعد. شغّل نقدًا لتسجيل واحد.',
  'critiqueTheater.transcriptLoading': 'جارٍ تحميل النص…',
  'critiqueTheater.transcriptError': 'تعذّر تحميل نص المحادثة: {error}',
  'critiqueTheater.replaySpeedPaused': 'متوقّف مؤقتًا',
  'critiqueTheater.replaySpeedInstant': 'فوري',
  'critiqueTheater.replaySpeedLive': 'مباشر',
  'critiqueTheater.replaySpeedFast': 'سريع',
  'critiqueTheater.settingsNav': 'لجنة تحكيم التصميم',
  'critiqueTheater.settingsNavHint': 'مراجعة تصميم بخمس لوحات لعمليات التشغيل الخاصة بك',
  'critiqueTheater.settingsEnabledLabel': 'إظهار لجنة تحكيم التصميم أثناء تشغيل الـ Agent',
  'critiqueTheater.settingsEnabledDescription': 'عند التفعيل، تظهر مراجعة بخمس لوحات بجانب مخرجات الـ Agent وتقيّم الناتج قبل التسليم. يمكنك المقاطعة في أي وقت.',
  'critiqueTheater.settingsEnabledProjectHint': 'تم الحفظ لهذا المشروع. ستمر عمليات التشغيل الجديدة في هذا المشروع عبر لجنة تحكيم التصميم من جانب الخادم.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'افتح مشروعًا للحفظ من جانب الخادم. حتى ذلك الحين، يغيّر هذا فقط التفضيل داخل المتصفح.',
  'pet.title': 'الحيوانات الأليفة',
  'pet.subtitle': 'تبنَّ رفيقاً صغيراً يطفو فوق مساحة عملك.',
  'pet.navTitle': 'الحيوانات الأليفة',
  'pet.navHint': 'تبنَّ أو خصص',
  'pet.tabBuiltIn': 'مدمج',
  'pet.tabBuiltInHint': 'رفقاء منتقون مدمجون مع Open Design - اختر واحداً وتبنَّه.',
  'pet.builtInEmpty': 'الحيوانات الأليفة المدمجة غير متوفرة حالياً. حاول تحديث تبويب المجتمع بمجرد اتصال البرنامج الخفي.',
  'pet.tabCustom': 'مخصص',
  'pet.tabCustomHint': 'اصنع خاصتك باسم، رمز، لون أو صورة.',
  'pet.tabCommunity': 'المجتمع',
  'pet.tabCommunityHint': 'حيوانات مفقوسة من Codex - تبنَّ واحداً أو ولد واحداً جديداً.',
  'pet.tabsAria': 'مصدر الحيوان الأليف',
  'pet.adopt': 'تبنَّ',
  'pet.adoptedBadge': 'تم التبني',
  'pet.adoptCallout': 'تبنَّ حيواناً أليفاً',
  'pet.changePet': 'تغيير الحيوان الأليف',
  'pet.wake': 'إيقاظ',
  'pet.tuck': 'إخفاء',
  'pet.wakeTitle': 'إيقاظ الحيوان الأليف - إظهار الطبقة العائمة.',
  'pet.tuckTitle': 'إخفاء الحيوان الأليف - إخفاء الطبقة العائمة.',
  'pet.settingsTitle': 'فتح إعدادات الحيوان الأليف',
  'pet.useCustom': 'استخدم حيواني',
  'pet.customTitle': 'اصنع خاصتك',
  'pet.customHint': 'اختر اسماً، رمزاً ولوناً - الطبقة تتحدث مباشرة.',
  'pet.customGreetingPlaceholder': 'قل مرحباً من حيوانك الأليف...',
  'pet.fieldName': 'الاسم',
  'pet.fieldGlyph': 'الرمز',
  'pet.fieldGlyphHint': 'إيموجي واحد يعمل بشكل أفضل (مثلاً: 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'التحية',
  'pet.fieldAccent': 'لون التمييز',
  'pet.fieldAccentCustom': 'لون مخصص',
  'pet.fieldAccentDefault': 'لون التمييز الافتراضي',
  'pet.overlayAria': 'رفيق الحيوان الأليف',
  'pet.spriteAria': '{name} - اسحب للتحريك، اضغط للدردشة',
  'pet.spriteTitle': 'مرحباً من {name}! اضغط للدردشة.',
  'pet.taskSummarySingle': 'تعمل {count} مهمة Agent.',
  'pet.taskSummaryMultiple': 'تعمل {count} مهام Agent عبر {projects} مشاريع.',
  'pet.taskSummaryRecentSingle': 'اكتملت مؤخرًا {count} مهمة Agent.',
  'pet.taskSummaryRecentMultiple': 'اكتملت مؤخرًا {count} مهام Agent.',
  'pet.taskListAria': 'مهام Agent النشطة',
  'pet.taskOpenProject': 'فتح {project}',
  'pet.taskGroup.running': 'قيد التشغيل',
  'pet.taskGroup.queued': 'في الانتظار',
  'pet.taskGroup.recent': 'اكتملت مؤخرًا',
  'pet.idleQuote.leonardo.text': 'التعلّم لا يُنهك العقل أبدًا.',
  'pet.idleQuote.leonardo.author': 'ليوناردو دافنشي',
  'pet.idleQuote.michelangelo.text': 'رأيتُ الملاك في الرخام ونحتُّ حتى حررتُه.',
  'pet.idleQuote.michelangelo.author': 'مايكل أنجلو',
  'pet.idleQuote.bernini.text': 'هناك أداتان يمكن أن تساعدا النحّات: الضوء والظل.',
  'pet.idleQuote.bernini.author': 'جان لورينزو برنيني',
  'pet.idleQuote.raphael.text': 'حين يرسم المرء فإنه لا يفكّر.',
  'pet.idleQuote.raphael.author': 'رفائيل',
  'pet.idleQuote.caravaggio.text': 'كل الأعمال، أيًّا كانت أو مهما كان من رسمها، ليست سوى تفاهات وأمور صبيانية ما لم تُصنع وتُرسم من الواقع.',
  'pet.idleQuote.caravaggio.author': 'كارافاجيو',
  'pet.idleQuote.rodin.text': 'الأهم هو أن تتأثّر، أن تحبّ، أن تأمل، أن ترتجف، أن تحيا.',
  'pet.idleQuote.rodin.author': 'أوغست رودان',
  'pet.composerTitle': 'الحيوانات الأليفة - إيقاظ، إخفاء، أو اختيار واحد',
  'pet.composerMenuTitle': 'الحيوانات الأليفة',
  'pet.composerMenuHint': 'تلميح: اكتب /pet للتبديل',
  'pet.composerOpenSettings': 'إدارة الحيوانات الأليفة',
  'pet.welcomeTeaserTitle': 'تبنَّ حيواناً أليفاً',
  'pet.welcomeTeaserBody': 'رفيق عائم صغير يقضي الوقت معك.',
  'pet.welcomeTeaserCta': 'اختر واحداً',
  'pet.imageUpload': 'رفع صورة',
  'pet.imageReplace': 'استبدال الصورة',
  'pet.imageRemove': 'استخدام إيموجي',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF أو SVG. رفع ورقة؟ أسقط شريطاً أفقياً وحدد عدد الإطارات.',
  'pet.imageHintActive': 'عرض صورتك. حدد الإطارات > 1 للمشي في ورقة صور أفقية.',
  'pet.fieldFrames': 'الإطارات',
  'pet.fieldFramesHint': '1 = ثابت. > 1 = ورقة صور أفقية.',
  'pet.fieldFps': 'السرعة (fps)',
  'pet.fieldFpsHint': 'مدى سرعة تدوير الإطارات.',
  'pet.atlasImport': 'استيراد صورة Codex',
  'pet.atlasImportTitle': 'استيراد أطلس حيوان مفقوس 8x9 / 192x208 (PNG أو WebP).',
  'pet.atlasPickerTitle': 'اختر صف رسوم متحركة',
  'pet.atlasPickerHint': 'حيوانات Codex تأتي بـ 9 صفوف رسوم متحركة. افتراضياً نحتفظ بالأطلس الكامل ليغير الحيوان الصفوف عند التحويم، السحب، والسكون. يمكنك أيضاً تجميده في حلقة واحدة.',
  'pet.atlasCancel': 'تجاهل الأطلس',
  'pet.atlasAdopt': 'تجميد في هذا الصف',
  'pet.atlasAdoptFull': 'استخدام الأطلس الكامل (متحرك)',
  'pet.atlasAdoptFullTitle': 'الاحتفاظ بكل الصفوف ليتفاعل الحيوان مع التحويم، اتجاه السحب، والسكون الطويل.',
  'pet.atlasAdoptRowTitle': 'قص الصف المظلل فقط في شريط متكرر واحد.',
  'pet.atlasActiveHint': 'الأطلس المتحرك نشط - يختار الحيوان صفاً من تفاعلك (تحويم، سحب، سكون).',
  'pet.atlasRow.idle': 'ساكن',
  'pet.atlasRow.running-right': 'جري يميناً',
  'pet.atlasRow.running-left': 'جري يساراً',
  'pet.atlasRow.waving': 'تلويح',
  'pet.atlasRow.jumping': 'قفز',
  'pet.atlasRow.failed': 'فشل',
  'pet.atlasRow.waiting': 'انتظار',
  'pet.atlasRow.running': 'جري',
  'pet.atlasRow.review': 'مراجعة',
  'pet.hatchTitle': 'فقس حيوان جديد بالذكاء الاصطناعي',
  'pet.hatchHint': 'استخدم مهارة hatch-pet في الدردشة لتوليد ورقة صور بأسلوب Codex، ثم استوردها هنا.',
  'pet.hatchConcept': 'مفهوم الحيوان (اختياري)',
  'pet.hatchConceptPlaceholder': 'مثلاً: شيبا بيكسل-آرت صغير في سترة مريحة',
  'pet.hatchCopy': 'نسخ الأمر',
  'pet.hatchCopied': 'تم النسخ!',
  'pet.hatchFoot': 'بعد أن يحفظ المساعد حيوانك، عد إلى هنا واختر "استيراد صورة Codex".',
  'pet.slashPopoverAria': 'أوامر Slash',
  'pet.slashPopoverTitle': 'الأوامر',
  'pet.slashPopoverHint': '↑↓ للتنقل · enter للاختيار · esc للتجاهل',
  'pet.slashPet': 'تبديل، تبني، أو الانتقال لإعدادات الحيوانات الأليفة.',
  'pet.slashPetWake': 'إيقاظ طبقة الحيوان الأليف العائمة.',
  'pet.slashPetTuck': 'إخفاء الحيوان الأليف حالياً.',
  'pet.slashHatch': 'توليد حيوان Codex عبر مهارة hatch-pet.',
  'pet.slashHatchArg': '<مفهوم>',
  'pet.slashSearch': 'ابحث في الويب عبر أمر OD research.',
  'pet.slashSearchArg': '<استعلام>',
  'pet.codexTitle': 'فقس مؤخراً',
  'pet.codexSubtitle': 'الحيوانات التي تمت تعبئتها بواسطة مهارة hatch-pet تظهر هنا للتبني بنقرة واحدة.',
  'pet.codexSubtitleWithDir': 'مسح {dir} للبحث عن حيوانات معبأة بواسطة مهارة hatch-pet.',
  'pet.codexEmpty': 'لا توجد حيوانات مفقوسة بعد. اكتب /hatch في الدردشة لتوليد واحد.',
  'pet.codexLoading': 'البحث عن حيوانات مفقوسة...',
  'pet.codexRefresh': 'تحديث',
  'pet.codexAdopt': 'تبنَّ',
  'pet.codexAdopting': 'جاري التبني...',
  'pet.communitySync': 'تحميل حيوانات المجتمع',
  'pet.communitySyncing': 'جاري التحميل...',
  'pet.communitySyncTitle': 'مزامنة أحدث الحيوانات من Codex Pet Share + j20 Hatchery إلى ~/.codex/pets/.',
  'pet.communitySyncDone': 'تمت مزامنة {wrote} حيواناً جديداً ({total} إجمالي).',
  'pet.communitySyncFailed': 'فشلت المزامنة: {error}',
  'pet.codexBundled': 'مدمج',
  'pet.codexBundledTitle': 'يأتي مع Open Design - لا حاجة للتحميل.',
  'settings.notifications': 'الإشعارات',
  'settings.notificationsHint': 'صوت وإشعار سطح المكتب عند اكتمال المهمة',
  'settings.notifyCompletionSound': 'صوت الاكتمال',
  'settings.notifyCompletionSoundHint': 'يُشغَّل عند انتهاء الجولة. متوقف افتراضيًا.',
  'settings.notifySuccessSound': 'صوت النجاح',
  'settings.notifyFailureSound': 'صوت الفشل',
  'settings.notifyDesktop': 'إشعار سطح المكتب',
  'settings.notifyDesktopHint': 'يُرسَل عندما لا تكون النافذة في المقدمة.',
  'settings.notifyDesktopBlocked': 'تم حظر الإشعارات من المتصفح. اسمح بها من إعدادات الموقع.',
  'settings.notifyDesktopUnsupported': 'إشعارات سطح المكتب غير متاحة في هذه البيئة.',
  'settings.notifyTest': 'إرسال اختبار',
  'settings.notifyTestSent': 'تم إرسال إشعار الاختبار. إذا لم تظهر نافذة، فتحقق من إعدادات إشعارات المتصفح والنظام.',
  'settings.notifyTestFailed': 'فشل استدعاء الإشعار. تحقق من إعدادات إشعارات المتصفح والنظام.',
  'settings.notifySoundDing': 'دينج',
  'settings.notifySoundChime': 'جرس',
  'settings.notifySoundTwoToneUp': 'نغمتان صاعدتان',
  'settings.notifySoundPluck': 'نقرة وتر',
  'settings.notifySoundBuzz': 'طنين',
  'settings.notifySoundTwoToneDown': 'نغمتان هابطتان',
  'settings.notifySoundThud': 'دمدمة',
  'settings.skills': 'المهارات',
  'settings.skillsHint': 'المهارات الوظيفية التي يمكن للوكيل استدعاؤها أثناء المهمة',
  'settings.skillsNew': 'مهارة جديدة',
  'settings.skillsEmpty': 'حدد مهارة من اليسار أو أنشئ مهارة جديدة.',
  'settings.skillsEdit': 'تحرير',
  'settings.skillsDelete': 'حذف',
  'settings.skillsDeleteConfirm': 'تأكيد الحذف',
  'settings.skillsName': 'الاسم',
  'settings.skillsTriggers': 'محفزات (مفصولة بفواصل أو أسطر جديدة)',
  'settings.skillsDescription': 'الوصف',
  'settings.skillsBody': 'محتوى SKILL.md',
  'settings.skillsCreate': 'إنشاء',
  'settings.skillsSave': 'حفظ',
  'settings.skillsSaving': 'جاري الحفظ…',
  'settings.skillsFiles': 'الملفات',
  'settings.skillsNoFiles': 'لا توجد ملفات في مجلد هذه المهارة.',
  'settings.skillsNameRequired': 'اسم المهارة مطلوب.',
  'settings.skillsBodyRequired': 'محتوى المهارة مطلوب.',
  'settings.designSystems': 'أنظمة التصميم',
  'settings.designSystemsHint': 'تصفح وتفعيل أنظمة التصميم المتاحة للوكيل',
  'settings.designSystemsInstalled': 'مثبّتة',
  'settings.designSystemsAdd': 'إضافة نظام تصميم',
  'settings.designSystemsHiddenCount': '{count} مخفية من معرض الصفحة الرئيسية',
  'settings.designSystemsShowAll': 'عرض الكل',
  'settings.designSystemsShowHidden': 'عرض المخفية',
  'settings.designSystemsSource': 'المصدر',
  'settings.designSystemsSourceLocal': 'محلي',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'مرجع سجل shadcn',
  'settings.designSystemsImportShadcn': 'استيراد من shadcn',
  'settings.designSystemsStructure': 'البنية',
  'settings.designSystemsModeHybrid': 'مختلط',
  'settings.designSystemsModeNormalized': 'مطبّع',
  'settings.designSystemsModeVerbatim': 'كما هو',
  'settings.designSystemsCraft': 'الحِرفة',
  'settings.designSystemsCraftColor': 'اللون',
  'settings.designSystemsCraftAccessibility': 'إمكانية الوصول',
  'settings.designSystemsGithubUrl': 'رابط GitHub',
  'settings.designSystemsProjectPath': 'مسار المشروع',
  'settings.designSystemsImportGithub': 'استيراد من GitHub',
  'settings.designSystemsImportProject': 'استيراد من المشروع',
  'settings.designSystemsImportedStatus': 'تم استيراد {title}',
  'settings.designSystemsViewImported': 'عرض نظام التصميم المستورد',
  'settings.designSystemsCategory': 'الفئة',
  'settings.designSystemsAllCategories': 'كل الفئات',
  'settings.designSystemsShowInHomeGallery': 'إظهار في معرض الصفحة الرئيسية',
  'settings.projectLocations': 'مواقع المشاريع',
  'settings.projectLocationsHint': 'جذور تخزين مساحات العمل',
  'settings.projectLocationsDescription': 'أضف قواعد عمل يمكن أن تحتوي على عدة مجلدات مشاريع Open Design. تُحفظ المشاريع الجديدة كمجلد داخل القاعدة المحددة.',
  'settings.projectLocationsSaveError': 'تعذّر حفظ مواقع المشاريع. تحقق من أن كل مسار مجلد يمكن الوصول إليه.',
  'settings.projectLocationsSaved': 'تم حفظ مواقع المشاريع.',
  'settings.projectLocationsScanError': 'تعذّر فحص مواقع المشاريع.',
  'settings.projectLocationsScanComplete': 'اكتمل الفحص: تم استيراد {imported}، و{existing} مسجلة مسبقًا.',
  'settings.projectLocationsNoFolderSelected': 'لم يتم اختيار مجلد.',
  'settings.projectLocationsDuplicate': 'تمت إضافة قاعدة العمل هذه بالفعل.',
  'settings.projectLocationsWorkBaseMeta': 'قاعدة عمل · يتم إنشاء المشاريع هنا كمجلدات فرعية',
  'settings.projectLocationsAddFolder': 'إضافة مجلد…',
  'settings.projectLocationsDefaultBadge': 'الموقع الافتراضي',
  'settings.projectLocationsMakeDefault': 'تعيين كافتراضي',
  'settings.projectLocationsDefaultSaved': 'تم تحديث موقع المشروع الافتراضي.',
  'settings.librarySkills': 'المهارات',
  'settings.libraryDesignSystems': 'أنظمة التصميم',
  'settings.librarySearch': 'بحث...',
  'settings.libraryAll': 'الكل',
  'settings.libraryPreview': 'معاينة',
  'settings.libraryPreviewClose': 'إغلاق',
  'settings.libraryLoading': 'جارٍ التحميل...',
  'settings.libraryNoResults': 'لا توجد عناصر تطابق بحثك.',
  'settings.libraryEnabled': 'مفعّل',
  'settings.libraryDisabled': 'معطّل',
  'settings.connectorsNavHint': 'اتصالات الأنظمة الخارجية',
  'settings.connectorsHint': 'إدارة إعدادات الموصّلات ومزوّدي الأدوات لهذا الجهاز.',
  'settings.connectorsComposioApiKey': 'مفتاح API لـ Composio',
  'settings.connectorsSavedTitle': 'محفوظ في daemon المحلي',
  'settings.connectorsSavedWithTail': 'محفوظ · ••••{tail}',
  'settings.connectorsSaved': 'محفوظ',
  'settings.connectorsGetApiKey': 'الحصول على مفتاح API',
  'settings.connectorsReplaceKeyPlaceholder': 'الصق مفتاحًا جديدًا لاستبدال المحفوظ',
  'settings.connectorsApiKeyPlaceholder': 'الصق مفتاح API لـ Composio',
  'settings.connectorsClear': 'مسح',
  'settings.connectorsClearConfirmTitle': 'مسح مفتاح Composio API المحفوظ؟',
  'settings.connectorsClearConfirmBody': 'إزالة المفتاح ستفصل جميع موصلات Composio المرتبطة بمساحة العمل هذه. سيُحذف كل من الحسابات المتصلة وأذونات OAuth والوصول إلى الأدوات.',
  'settings.connectorsClearConfirmContinue': 'متابعة',
  'settings.connectorsClearFinalTitle': 'سيؤدي هذا إلى فصل جميع الموصلات',
  'settings.connectorsClearFinalBody': 'لا يمكن التراجع عن هذا الإجراء. ستحتاج إلى إعادة ربط كل تكامل من البداية بعد لصق مفتاح جديد.',
  'settings.connectorsClearFinalConfirm': 'حذف المفتاح وفصل التكاملات',
  'settings.connectorsClearArming': 'لحظة…',
  'settings.connectorsClearCancel': 'إلغاء',
  'settings.connectorsSaveKey': 'حفظ المفتاح',
  'settings.connectorsSaveKeyTitle': 'إرسال هذا المفتاح إلى الـ daemon المحلي',
  'settings.connectorsKeySaving': 'جارٍ الحفظ…',
  'settings.connectorsKeySaved': 'تم الحفظ ✓',
  'settings.connectorsKeyError': 'تعذّر حفظ المفتاح. تأكد أن الـ daemon المحلي يعمل ثم حاول مرة أخرى.',
  'settings.connectorsHelpSaved': 'يفتح مفتاحك الكتالوج أدناه ويبقى في daemon المحلي. الصق مفتاحًا جديدًا لاستبداله أو امسحه لإزالته.',
  'settings.connectorsHelpUnsaved': 'تغييرات غير محفوظة — اضغط على "حفظ المفتاح" لتخزين بيانات الاعتماد في الـ daemon المحلي وفتح الكتالوج أدناه.',
  'settings.connectorsHelpEmpty': 'أضف مفتاحًا لفتح الكتالوج أدناه. تُخزّن المفاتيح محليًا في daemon ولا تُرسل أبدًا عبر متغيرات البيئة.',
  'settings.connectorsLoadingSavedKey': 'جارٍ التحقق من مفتاح محفوظ في daemon المحلي…',
  'settings.autosaveSaving': 'جارٍ الحفظ…',
  'settings.autosaveSaved': 'تم حفظ جميع التغييرات',
  'settings.autosaveError': 'تعذّر حفظ التغييرات. قد يكون الـ daemon المحلي غير متاح.',
  'settings.libraryToggleLabel': 'تبديل',
  'settings.memory': 'الذاكرة',
  'settings.memoryHint': 'الحقائق والسياق المحفوظة للمحادثات المستقبلية',
  'settings.customInstructionsTitle': 'القواعد العامة',
  'settings.customInstructionsHint': 'تعليمات ثابتة يجب أن يتبعها OpenDesign في كل محادثة. احفظ الحقائق والتفضيلات وسياق المشروع كذكريات.',
  'settings.customInstructionsPlaceholder': 'مثال: "استخدم TypeScript دائمًا. فضّل المكوّنات الوظيفية. اجعل الردود موجزة."',
  'settings.memoryDescription': 'تحكّم في ما إذا كان سيُعاد استخدام الحقائق والتفضيلات وسياق المشروع المحفوظة في المحادثات المستقبلية.',
  'settings.memoryEnabled': 'مُفعّل',
  'settings.memoryDisabled': 'مُعطّل',
  'settings.memoryEnableLabel': 'تفعيل إدراج الذاكرة',
  'settings.memoryDisabledBanner': 'الذاكرة مُعطّلة حاليًا. تُحفظ الحقائق الموجودة على القرص لكنها لن تُدمج في المحادثات الجديدة، ولن تستخرج الأدوار الجديدة أي شيء جديد.',
  'settings.memoryNew': 'ذاكرة جديدة',
  'settings.memoryEdit': 'تعديل',
  'settings.memoryDelete': 'حذف',
  'settings.memoryPreview': 'معاينة',
  'settings.memoryEmpty': 'لا توجد ذاكرة بعد.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'أفضّل الوضع الداكن',
  'settings.memoryName': 'مثال: تفضيلات الواجهة',
  'settings.memoryDesc': 'جملة واحدة — ما موضوع هذه الذاكرة؟',
  'settings.memoryBody': '- القاعدة الأولى\n- القاعدة الثانية\n\nالسبب: سبب اختياري\nمتى تُطبَّق: نطاق اختياري',
  'settings.memoryBodyHint': 'اكتب القواعد كنقاط أولًا، ثم أضِف سطري السبب ومتى تُطبَّق اختياريًا. يدعم Markdown. أو انقر على مثال بدء أعلاه لتحميل مثال عملي.',
  'settings.memoryStartersLabel': 'تحتاج إلى نقطة بداية؟ انقر لملء النموذج:',
  'settings.memoryStarterUserName': 'دوري',
  'settings.memoryStarterUserDesc': 'أنا مهندس واجهات أمامية أعمل على أداة تصميم SaaS',
  'settings.memoryStarterUserBody': '- الدور: مهندس واجهات أمامية أول\n- التقنيات: React، TypeScript، Vite\n- المجال: أدوات التصميم / التعاون\n- المنطقة الزمنية: GMT+8 (آسيا/شنغهاي)\n\nمتى يُطبَّق: في أي محادثة — اجعل الأمثلة متمحورة حول واجهات الويب الأمامية.',
  'settings.memoryStarterFeedbackName': 'تفضيلات الواجهة',
  'settings.memoryStarterFeedbackDesc': 'الوضع الداكن، نص أساسي كبير، كثافة معلومات منخفضة',
  'settings.memoryStarterFeedbackBody': '- السمة: داكنة افتراضيًا\n- نص المحتوى: ≥ 18px\n- كثافة المعلومات: تفضيل المساحات البيضاء، عناصر أقل لكل شاشة\n\nالسبب: إجهاد أقل للعين أثناء الجلسات الطويلة.\nمتى يُطبَّق: كلما أنشأت واجهة مستخدم أو صفحات ويب أو شرائح عرض.',
  'settings.memoryStarterProjectName': 'المشروع الحالي',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — محرر تصميم يعمل بالمحادثة',
  'settings.memoryStarterProjectBody': '- الهدف: إطلاق المحرر القائم على المحادثة هذا الربع\n- الأولويات: التصيير المتدفق، الوسائط المتعددة المحلية، الأولوية لوضع عدم الاتصال\n- المنصة التقنية: Next.js 16، خادم Express، SQLite\n\nمتى يُطبّق: في أي محادثة حول هذا المشروع.',
  'settings.memorySaveHint': 'لا يُحفَظ تلقائيًا — انقر إنشاء / حفظ للتطبيق.',
  'settings.memoryIndexSaveHint': 'لا تُحفَظ التعديلات على الفهرس تلقائيًا — انقر حفظ الفهرس للتطبيق.',
  'settings.memoryIndexUnsaved': 'تغييرات غير محفوظة',
  'settings.memoryFlashCreated': '✓ تم إنشاء الذاكرة',
  'settings.memoryFlashSaved': '✓ تم حفظ الذاكرة',
  'settings.memoryFlashDeleted': '✓ تم حذف الذاكرة',
  'settings.memoryFlashIndexSaved': '✓ تم حفظ الفهرس',
  'settings.memoryFlashPathCopied': '✓ تم نسخ المسار',
  'settings.memoryNameLabel': 'العنوان',
  'settings.memoryTypeLabel': 'النوع',
  'settings.memoryDescLabel': 'الوصف',
  'settings.memoryBodyLabel': 'المحتوى',
  'settings.memoryTypeUser': 'المستخدم',
  'settings.memoryTypeFeedback': 'الملاحظات',
  'settings.memoryTypeProject': 'المشروع',
  'settings.memoryTypeReference': 'مرجع',
  'settings.memoryIndex': 'MEMORY.md (الفهرس)',
  'settings.memoryIndexSave': 'حفظ الفهرس',
  'settings.memoryIndexReset': 'إعادة تعيين',
  'settings.memoryToastChanged': 'تم تحديث الذاكرة',
  'settings.memoryToastClickHint': 'عرض',
  'settings.memoryAll': 'الكل',
  'settings.memoryExtractions': 'سجل الاستخراج',
  'settings.memoryExtractionsHint': 'يعمل Regex أولًا، ويعمل LLM في الخلفية.',
  'settings.memoryExtractionsEmpty': 'لا توجد عمليات استخراج بعد. ستملأ هذه القائمة في دور المحادثة التالي.',
  'settings.memoryExtractionsRefresh': 'تحديث',
  'settings.memoryExtractionsRefreshing': 'جارٍ التحديث…',
  'settings.memoryExtractionPhaseRunning': 'جارٍ التشغيل…',
  'settings.memoryExtractionPhaseSuccess': 'نجاح',
  'settings.memoryExtractionPhaseSkipped': 'تم التخطي',
  'settings.memoryExtractionPhaseFailed': 'فشل',
  'settings.memoryExtractionSkipNoProvider': 'لم يتم تكوين API key لاستخراج الذاكرة عبر LLM.',
  'settings.memoryExtractionSkipDisabled': 'الذاكرة معطّلة.',
  'settings.memoryExtractionSkipEmpty': 'رسالة المستخدم فارغة — لا يوجد ما يُستخرَج.',
  'settings.memoryExtractionSkipNoMatch': 'لم يتطابق أي نمط regex في هذا الدور.',
  'settings.memoryExtractionKindHeuristic': 'تعبير نمطي',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'إعدادات الوسائط',
  'settings.memoryExtractionProviderOverride': 'إعدادات الذاكرة',
  'settings.memoryExtractionProposed': 'مقترح',
  'settings.memoryExtractionWritten': 'مكتوب',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'حذف',
  'settings.memoryExtractionsClear': 'مسح',
  'settings.memoryExtractionsClearTitle': 'مسح كل سجل الاستخراج',
  'settings.memoryExtractionsClearConfirm': 'هل تريد مسح كل سجل الاستخراج؟ لا يمكن التراجع عن هذا الإجراء.',
  'settings.memoryNoProviderBannerTitle': 'استخراج الذاكرة عبر LLM غير قيد التشغيل',
  'settings.memoryNoProviderBannerBody': 'لم يُعثر على API key لمستخرج الذاكرة. أضف مفتاح OpenAI ضمن مزودي الوسائط، أو عيّن ANTHROPIC_API_KEY / OPENAI_API_KEY في البيئة لتفعيل الاستخراج المعتمد على LLM. لا يزال الاستخراج الاستدلالي عبر regex نشطًا.',
  'settings.libraryInstall': 'تثبيت',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'مسار محلي',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'تثبيت',
  'settings.libraryUninstall': 'إلغاء التثبيت',
  'settings.libraryBuiltIn': 'مدمج',
  'settings.libraryInstalled': 'مثبّت',
  'notify.successTitle': 'اكتملت المهمة',
  'notify.failureTitle': 'فشلت المهمة',
  'notify.successBody': 'انتهت جولة.',
  'notify.failureBody': 'انتهت المهمة بخطأ.',
  'updater.available': 'يتوفر تحديث',
  'updater.availableBody': 'Open Design {version} متوفر. سيتم تنزيله قبل فتح المثبت.',
  'updater.checking': 'جارٍ البحث عن تحديثات',
  'updater.download': 'تنزيل التحديث',
  'updater.downloading': 'جارٍ تنزيل التحديث',
  'updater.downloadingPercent': 'جارٍ تنزيل التحديث {percent}%',
  'updater.done': 'تم',
  'updater.failed': 'فشل التحديث',
  'updater.installerOpenBody': 'المثبت مفتوح. يتم الآن إنهاء Open Design لتتمكن من إكمال التحديث.',
  'updater.installerOpened': 'تم فتح المثبت',
  'updater.later': 'لاحقًا',
  'updater.openFailedFallback': 'تعذر فتح المثبت.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'تثبيت التحديث',
  'updater.opening': 'جارٍ فتح المثبت...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'إنهاء Open Design',
  'updater.quitFailedBody': 'المثبت مفتوح، لكن تعذر إنهاء Open Design. أغلق Open Design قبل استبدال التطبيق.',
  'updater.quitFailedTitle': 'تعذر الإنهاء',
  'updater.quitting': 'جارٍ الإنهاء...',
  'updater.ready': 'التحديث جاهز',
  'updater.readyGeneric': 'إصدار جديد جاهز. سيتم إغلاق Open Design وفتح المثبت.',
  'updater.readyVersion': 'Open Design {version} جاهز. سيتم إغلاق Open Design وفتح المثبت.',
  'updater.upToDate': 'أنت تستخدم أحدث إصدار بالفعل.',
  'newsletter.label': 'النشرة (اختياري)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'الأتمتة',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'ملخص يومي للموصّلات',
  'settings.orbit.lede': 'اجمع نشاط الموصّلات وفق جدول وانشر النتيجة كـ live artifact قابل للتحديث.',
  'settings.orbit.statusOnTitle': 'التشغيلات اليومية المجدولة مفعّلة',
  'settings.orbit.statusOffTitle': 'التشغيلات اليومية المجدولة متوقفة',
  'settings.orbit.statusActive': 'نشط',
  'settings.orbit.statusOff': 'متوقف',
  'settings.orbit.runTitle': 'ابدأ تشغيل Orbit وافتح المحادثة الحية',
  'settings.orbit.running': 'قيد التشغيل…',
  'settings.orbit.runOpen': 'شغّله الآن',
  'settings.orbit.dailySummaryTitle': 'ملخص يومي',
  'settings.orbit.dailySummarySub': 'يعمل مرة يوميًا في الوقت المحلي المجدول.',
  'settings.orbit.on': 'تشغيل',
  'settings.orbit.off': 'متوقف',
  'settings.orbit.runTimeTitle': 'وقت التشغيل',
  'settings.orbit.runTimeSub': 'الافتراضي 08:00. احفظ لتطبيق جدول daemon.',
  'settings.orbit.runTimeAria': 'وقت تشغيل Orbit اليومي',
  'settings.orbit.nextRun': 'التشغيل التالي',
  'settings.orbit.nextRunScheduledAfterSave': 'سيُجدول بعد الحفظ',
  'settings.orbit.schedule': 'الجدول',
  'settings.orbit.pausedManualOnly': 'متوقف مؤقتًا — تشغيل يدوي فقط',
  'settings.orbit.templateTitle': 'قالب prompt',
  'settings.orbit.templateMissing': 'القالب {id} غير مثبت.',
  'settings.orbit.templateMissingOption': '{id} (مفقود)',
  'settings.orbit.templateMissingInstall': 'ثبّت skill لـ Orbit لتوجيه prompt.',
  'settings.orbit.templateMissingPickAnother': 'اختر قالبًا آخر من القائمة.',
  'settings.orbit.templateResetTitle': 'إعادة إلى {id}',
  'settings.orbit.templateReset': 'إعادة ضبط',
  'settings.orbit.templateHelp': 'وجّه Orbit باستخدام skill — يُحقن prompt المثال للقالب المحدد في كل تشغيل Orbit كي تتبع الملخصات شكل ذلك القالب.',
  'settings.orbit.templateAria': 'قالب prompt لـ Orbit',
  'settings.orbit.templatesLoading': 'جارٍ تحميل القوالب…',
  'settings.orbit.templatesOptgroup': 'قوالب skills لـ Orbit',
  'settings.orbit.lastRun': 'آخر تشغيل',
  'settings.orbit.triggerManual': 'يدوي',
  'settings.orbit.triggerScheduled': 'مجدول',
  'settings.orbit.meterAria': '{succeeded} نجح، {skipped} تم تخطيه، {failed} فشل من أصل {checked} تم فحصه',
  'settings.orbit.countChecked': 'تم الفحص',
  'settings.orbit.countSucceeded': 'نجح',
  'settings.orbit.countSkipped': 'تم التخطي',
  'settings.orbit.countFailed': 'فشل',
  'settings.orbit.runError': 'تعذر تشغيل Orbit. تأكد من أن daemon المحلي يعمل وأن الموصّلات مهيأة.',
  'settings.orbit.gateAriaLabel': 'يلزم وجود موصلات لاستخدام Orbit',
  'settings.orbit.gateEyebrow': 'الإعداد مطلوب',
  'settings.orbit.gateTitle': 'اربط أداة لتشغيل Orbit',
  'settings.orbit.gateBody': 'يلخّص Orbit نشاط الموصلات الخاصة بك. لم تربط أيّ موصل بعد — أضف تكاملًا واحدًا على الأقل ليعمل Orbit.',
  'settings.orbit.gateBodyNoKey': 'يلخّص Orbit نشاط موصلاتك، وتعمل الموصلات عبر Composio. أضِف مفتاح Composio API في «الموصلات» لفتح الكتالوج واختيار أوّل تكامل لك.',
  'settings.orbit.gateAction': 'فتح الموصلات',
  'settings.orbit.gateActionNoKey': 'تهيئة Composio',
  'settings.orbit.gateLoading': 'جارٍ فحص الموصلات…',
  'settings.orbit.controlsLockedBadge': 'مقفل',
  'settings.orbit.controlsLockedHint': 'اربط أداة لإلغاء قفل جدولة Orbit وقالبه.',
  'settings.orbit.artifactKickerLive': 'عنصر حي',
  'settings.orbit.artifactKickerLegacy': 'ملخص قديم',
  'settings.orbit.artifactTitle': 'ملخص نشاط Orbit اليومي',
  'settings.orbit.artifactMetaLive': 'artifact HTML قابل للتحديث تم إنشاؤه من نشاط الموصّلات.',
  'settings.orbit.artifactMetaLegacy': 'تم إنشاؤه قبل تفعيل دعم live artifact — شغّل Orbit مرة أخرى لنشر واحد.',
  'settings.orbit.copyMarkdownTitle': 'نسخ ملخص Markdown إلى الحافظة',
  'settings.orbit.copied': 'تم النسخ',
  'settings.orbit.copy': 'نسخ',
  'settings.orbit.openArtifact': 'فتح artifact',
  'settings.orbit.sourceMarkdown': 'Markdown المصدر',
  'settings.memoryModelInlineHintByokNeutral': 'تستخدم الذاكرة نموذجًا منفصلاً عن المحادثة. يكون الافتراضي هو نموذج المحادثة لديك.',
  'diagnostics.exportTitle': 'تصدير التشخيص',
  'diagnostics.exportButton': 'تصدير التشخيص',
  'diagnostics.exportHint': 'يحزم سجلات التطبيق الأخيرة ومعلومات الجهاز في ملف zip لمشاركته مع الفريق.',
  'diagnostics.exporting': 'جارٍ التصدير…',
  'diagnostics.exportSuccess': 'تم حفظ التشخيص في {path}',
  'diagnostics.exportFailed': 'تعذّر تصدير التشخيص: {message}',
  'automations.eyebrow': 'جلسات الـ Agent المجدولة',
  'automations.title': 'الأتمتة',
  'automations.lede': 'خطّط لمحادثات متكررة لأعمال المشاريع، وملخّصات Orbit، والقطع الحيّة.',
  'automations.summaryAria': 'ملخّص الأتمتة',
  'automations.metricActive': 'نشطة',
  'automations.metricPaused': 'متوقفة مؤقتًا',
  'automations.metricTemplates': 'القوالب',
  'automations.newAutomation': 'أتمتة جديدة',
  'automations.yourAutomations': 'أتمتاتك',
  'automations.loading': 'جارٍ التحميل',
  'automations.emptyTitle': 'لا توجد أتمتة بعد',
  'automations.emptyBody': 'أنشئ واحدة من قالب أو ابدأ بجدول فارغ.',
  'automations.targetNewEachRun': 'مشروع جديد في كل تشغيل',
  'automations.lastRun': 'آخر تشغيل {time}',
  'automations.openResult': 'فتح النتيجة',
  'automations.run': 'تشغيل',
  'automations.runNowTitle': 'التشغيل الآن وفتح المحادثة',
  'automations.history': 'السجل',
  'automations.hideHistory': 'إخفاء السجل',
  'automations.edit': 'تعديل',
  'automations.pause': 'إيقاف مؤقت',
  'automations.resume': 'استئناف',
  'automations.deleteAria': 'حذف الأتمتة',
  'automations.deleteTitle': 'حذف هذه الأتمتة',
  'automations.deleteConfirm': 'حذف هذه الأتمتة؟ تُحفَظ عمليات التشغيل السابقة ومشاريعها.',
  'automations.proposalsTitle': 'مقترحات التطوّر',
  'automations.proposalsSub': 'راجِع مُخرجات الأتمتة قبل أن تُغيّر الذاكرة أو المهارات أو أنظمة التصميم.',
  'automations.proposalsPending': '{n} قيد الانتظار',
  'automations.apply': 'تطبيق',
  'automations.reject': 'رفض',
  'automations.proposalsDismissReason': 'تم تجاهله في الأتمتة',
  'automations.templatesTitle': 'القوالب',
  'automations.templatesSub': 'Orbit والقطع الحيّة قوالب ضمن تدفّق الأتمتة نفسه.',
  'automations.templatesCount': '{filtered} من {total}',
  'automations.templateFiltersAria': 'عوامل تصفية القوالب',
  'automations.templatesEmptyTitle': 'لا توجد قوالب في هذه الفئة بعد.',
  'automations.templatesEmptyBody': 'جرّب عامل تصفية مختلفًا، أو ابدأ من أتمتة فارغة.',
  'automations.useTemplate': 'استخدام القالب',
  'automations.runHistoryLoading': 'جارٍ تحميل سجل التشغيل...',
  'automations.runHistoryEmpty': 'لا توجد عمليات تشغيل بعد.',
  'automations.runHistoryTitle': 'سجل التشغيل',
  'automations.runHistoryLatest': 'آخر 10',
  'automations.crystallize': 'تبلوُر',
  'automations.crystallizing': 'جارٍ التبلوُر',
  'automations.crystallizeTitle': 'صياغة مقترحات مهارات وذاكرة من هذا التشغيل',
  'automations.openConversation': 'فتح المحادثة',
  'automations.runHistoryAria': 'سجل تشغيل الأتمتة',
  'automations.proposalsAria': 'مقترحات تطوّر الأتمتة',
  'automations.templatesAria': 'قوالب الأتمتة',
  'automations.runInProgress': 'قيد التنفيذ',
  'automations.scheduleStatusPaused': 'متوقفة مؤقتًا',
  'automations.nextRunManualOnly': 'يدوي فقط',
  'automations.nextRunScheduled': 'مجدول',
  'automations.nextRunAt': 'التالي {time}',
  'automations.statusSucceeded': 'نجح',
  'automations.statusFailed': 'فشل',
  'automations.statusRunning': 'قيد التشغيل',
  'automations.statusQueued': 'في قائمة الانتظار',
  'automations.statusCanceled': 'أُلغي',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'قطعة حيّة',
  'automations.kindAutomation': 'أتمتة',
  'automations.proposalTargetMemory': 'الذاكرة',
  'automations.proposalTargetDesignSystem': 'نظام التصميم',
  'automations.proposalTargetSkill': 'مهارة',
  'automations.proposalTargetTemplate': 'قالب أتمتة',
  'automations.proposalActionCreate': 'إنشاء',
  'automations.proposalActionUpdate': 'تحديث',
  'automations.proposalActionMerge': 'دمج',
  'automations.proposalActionMove': 'نقل',
  'automations.proposalActionDelete': 'حذف',
  'automations.proposalActionPromote': 'ترقية',
  'automations.filterAll': 'الكل',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'القطع الحيّة',
  'automations.filterMemory': 'الذاكرة',
  'automations.filterDesignSystems': 'أنظمة التصميم',
  'automations.filterSkills': 'المهارات',
  'automations.filterConnectors': 'الموصِّلات',
  'automations.filterCompression': 'الضغط',
  'automations.filterRelease': 'الإصدار',
  'automations.filterQuality': 'الجودة',
  'automations.tpl.memoryRefresh.title': 'تحديث ذاكرة المشروع من الأعمال الأخيرة.',
  'automations.tpl.memoryRefresh.desc': 'يحوّل القرارات والتفضيلات والملاحظات المتكررة إلى تحديثات ذاكرة قابلة لإعادة الاستخدام.',
  'automations.tpl.designSystemRefresh.title': 'تحديث أنظمة التصميم من القطع المُسلَّمة.',
  'automations.tpl.designSystemRefresh.desc': 'يكتشف الرموز والمكوّنات والقواعد القابلة لإعادة الاستخدام عبر أعمال التصميم الأخيرة.',
  'automations.tpl.liveArtifactRegistry.title': 'تدقيق القطع الحيّة وتحديث الإصدارات القديمة.',
  'automations.tpl.liveArtifactRegistry.desc': 'يُبقي لوحات المعلومات والتقارير والمعاينات الدائمة محدّثة بدلًا من تكرارها.',
  'automations.tpl.orbitDashboard.title': 'بناء لوحة معلومات لنشاط الموصِّلات.',
  'automations.tpl.orbitDashboard.desc': 'يجمّع الموصِّلات المحدّدة في لوحة معلومات حيّة بأسلوب Orbit.',
  'automations.tpl.releaseNotes.title': 'صياغة ملاحظات الإصدار من أعمال التصميم المُسلَّمة.',
  'automations.tpl.releaseNotes.desc': 'يربط طلبات الدمج PR والقطع والتغييرات الموجَّهة للمنتج في ملاحظات الإصدار.',
  'automations.tpl.qualityRegressionWatch.title': 'مراقبة تراجعات التصميم والتنفيذ.',
  'automations.tpl.qualityRegressionWatch.desc': 'يقارن التغييرات الأخيرة بالمعايير والتتبّعات والمراجع المعتمدة.',
  'automations.tpl.orbitDaily.title': 'ملخّص يومي للموصِّلات.',
  'automations.tpl.orbitDaily.desc': 'يحدّث ملخّص نشاط الموصِّلات وفق جدول زمني.',
  'automations.tpl.liveStatusBoard.title': 'إبقاء قطعة الحالة الحيّة محدّثة.',
  'automations.tpl.liveStatusBoard.desc': 'يحدّث قطعة دائمة واحدة بدلًا من إنشاء تقرير جديد في كل تشغيل.',
  'dsManager.areaAria': 'منطقة أنظمة التصميم',
  'dsManager.tabDesignSystem': 'نظام التصميم',
  'dsManager.tabTemplate': 'قالب',
  'dsManager.sourceAria': 'مصدر نظام التصميم',
  'dsManager.templateSourceAria': 'مصدر القالب',
  'dsManager.yourSystems': 'أنظمتك',
  'dsManager.officialPresets': 'الإعدادات المسبقة الرسمية',
  'dsManager.enterprise': 'المؤسسات',
  'dsManager.yourTemplates': 'قوالبك',
  'dsManager.yourSystemsAria': 'أنظمة التصميم الخاصة بك',
  'dsManager.eyebrowDesignSystems': 'أنظمة التصميم',
  'dsManager.yourSystemsHeading': 'أنظمتك',
  'dsManager.filterAria': 'تصفية أنظمة التصميم',
  'dsManager.filterAll': 'الكل',
  'dsManager.filterPublished': 'منشورة',
  'dsManager.filterDraft': 'مسودة',
  'dsManager.createTitle': 'إنشاء نظام تصميم جديد',
  'dsManager.createBody': 'علّم Open Design علامتك التجارية ومنتجك وكودك وأصولك ومراجع التصميم الخاصة بك.',
  'dsManager.createAction': 'إنشاء',
  'dsManager.emptyMine': 'لا توجد أنظمة تصميم بعد. أنشئ واحدًا من سياق منتج حقيقي، وراجِع المسودة، ثم انشره للمشاريع المستقبلية.',
  'dsManager.badgeDefault': 'افتراضي',
  'dsManager.rowMetaUpdated': 'أنت · تم التحديث {date}',
  'dsManager.edit': 'تعديل',
  'dsManager.makeDefault': 'تعيين كافتراضي',
  'dsManager.statusPublished': 'منشور',
  'dsManager.statusDraft': 'مسودة',
  'dsManager.openSystemAria': 'فتح {title}',
  'dsManager.deleteSystemAria': 'حذف {title}',
  'dsManager.presetsAria': 'الإعدادات المسبقة الرسمية لأنظمة التصميم',
  'dsManager.eyebrowLibrary': 'المكتبة',
  'dsManager.eyebrowTemplates': 'القوالب',
  'dsManager.yourTemplatesAria': 'قوالبك',
  'dsManager.emptyTemplates': 'لا توجد قوالب بعد. أنشئ واحدًا من أي مشروع مُنشأ عبر المشاركة بمجرد تفعيل نشر القوالب.',
  'dsManager.templateDescFallback': 'تم الإنشاء من مشروع',
  'dsManager.comingSoonBadge': 'قريبًا',
  'dsManager.enterpriseDsTitle': 'أنظمة تصميم المؤسسات',
  'dsManager.enterpriseDsBody': 'أنظمة التصميم المشتركة للفِرق ومكتبات العلامات التجارية المُدارة قريبًا.',
  'dsManager.enterpriseTplTitle': 'قوالب المؤسسات',
  'dsManager.enterpriseTplBody': 'القوالب المعتمدة من الفريق والنشر على مستوى المؤسسة قريبًا.',
  'settings.instructionsTitle': 'التعليمات / القواعد',
  'settings.instructionsSubtitle': 'سلوك ثابت ينبغي للمساعد اتباعه',
  'settings.instructionsNavSub': 'سلوك ثابت للمساعد',
  'settings.customInstructionsDesc': 'تعليمات ثابتة يتبعها Open Design في كل محادثة. هذه ليست ذكريات محفوظة؛ استخدم الذاكرة للحقائق والتفضيلات وسياق المشروع.',
  'mcpClient.forwardedToLabel': 'مُمرَّر إلى:',
  'mcpClient.notForwardedToLabel': 'غير مُمرَّر إلى:',
  'mcpClient.forwardedAcpNote': 'محوِّلات ACP المُعلَّمة بـ stdio تتلقى فقط خوادم MCP من نوع stdio من هذه القائمة؛ تُسقَط إدخالات HTTP وSSE عند بدء التشغيل.',
  'mcpClient.notForwardedNote': 'بالنسبة إلى تلك الـ Agents، اضبط خوادم MCP في ملف إعدادات الـ Agent الخاص به (مثل ~/.codex/config.toml و~/.gemini/settings.json)؛ الخوادم أدناه غير مستخدمة هناك دون إشعار.',
};
